/* blueprints-lib.js -- blueprints-v1
   THE DRAWINGS PAGE. Reads ?p= (the project), fetches it from leva-share,
   loads the product's own configurator lib and boots it headless, then
   drives it: views (the stage's presets), layers (on / dim / off through the
   lib's setLayerMode), and the dimension overlay. Nothing here knows how a
   house is built; everything it draws it asks the lib for. */
(function (global) {
  var VERSION = 'blueprints-v51';   /* v51 (RUSSWORX SHED thread, 2026-11-03): window.LEVA_BP_PROJECT = the fetched project before the lib loads (a product switch inside a lib reads it) */
  /* the section defines HOUSE_BOOT and the labels in a plain script before
     this one (blueprints-liquid-v25; before that in the module script, which
     runs after three.js has loaded) and THREE in its module: read them at start */
  var BOOT = {}, L = { views: {}, modes: {}, dims: {} }, LIBS = {};
  /* Shopify's | t hands words HTML-escaped ("Black &amp; white"); a sheet
     writes them as text, so they are read back here once (v28) */
  function deEnt(o) {
    if (typeof o === 'string') return o.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&#x27;/g, "'").replace(/&amp;/g, '&');
    if (o && typeof o === 'object') { for (var k in o) if (o.hasOwnProperty(k)) o[k] = deEnt(o[k]); }
    return o;
  }
  function readBoot() {
    BOOT = global.HOUSE_BOOT || {};
    L = deEnt(global.BLUEPRINT_LABELS || { views: {}, modes: {}, dims: {} });
    LIBS = global.BLUEPRINT_LIBS || {};
    if (global.BLUEPRINT_ROOMS) deEnt(global.BLUEPRINT_ROOMS);
  }
  var $ = function (id) { return document.getElementById(id); };
  /* DIMENSIONS ON BY DEFAULT (blueprints-v19): a square-on view comes up
     dimensioned; the drawer turns them off */
  var _lib = null, _st = null, _view = 'iso', _dimsOn = true, _dimsMode = 'corner', _proj = null;
  var _queue = [];   /* the views added to the sheet, in order */
  var _ink = 0;
  /* v27: the sheets on the page (mode 'sheets') or one view live ('live') */
  var _roomsMode = false;   /* v46: drawing the room plan (rooms coloured, areas, no section marks) */
  var _mode = 'sheets', _look = { color: false, frame: true }, _building = false, _inApply = false, _sheetGen = 0, _dirty = false, _svgOut = false, _ts = 1;

  /* THE LOG: the page's own lines plus every line the lib writes -- the
     product pages have Configurator.log, this one has a stand-in so the lib's
     _log lands here too; Copy log takes it all with the lib's snapshot */
  var _lines = [];
  if (!global.Configurator) global.Configurator = {};
  if (!global.Configurator.log) {
    global.Configurator.log = { log: function (m) { _lines.push(String(m)); if (_lines.length > 800) _lines.shift(); try { console.log(m); } catch (e) {} } };
  }
  function log(m) { try { global.Configurator.log.log('[blueprints] ' + m); } catch (e) {} }
  function logText() {
    var txt = 'blueprints ' + VERSION + ' | ' + (BOOT.liquidVersion || '?') + ' | url ' + global.location.href + '\n' +
              'status: ' + (($('bp-status') || {}).textContent || '') + '\n' +
              'view ' + _view + ' | dims ' + (_dimsOn ? _dimsMode : 'off') + ' | ink ' + _ink + '\n' +
              'dims    ' + (_dimNote || '-') + '\n' +
              'ink     ' + (LN.note || '-') + '\n' +
              'pdf     ' + (_pdfNote || '-') + '\n' +
              'lock    ' + (_lock.on ? 'locked' : 'open') + ' -- ' + _lock.why + '\n' +
              'doc     ' + (_docNote || '-') + '\n' +
              'package ' + (_pkg ? (_pkg.note + (_pkg.cardNote ? (' | ' + _pkg.cardNote) : '')) : 'none') + '\n' +
              'sheets  ' + (_sheetNote || '-') + ' | mode ' + _mode + ' | look ' + (_look.color ? 'colour' : 'b&w') + (_look.frame ? ' framed' : ' clean') + '\n' +
              'section ' + (SEC.note || '-') + ' | A ' + (SEC.lines.x ? JSON.stringify(SEC.lines.x, ['segs', 'c', 'lo', 'hi', 'auto']) : '-') + ' | B ' + (SEC.lines.z ? JSON.stringify(SEC.lines.z, ['segs', 'c', 'lo', 'hi', 'auto']) : '-') + ' | plan cut ' + Math.round(planCutH() * 1000) + ' mm\n' +
              '----- log -----\n' + _lines.join('\n') + '\n';
    try { if (_lib && _lib.snapshot) txt += '----- lib snapshot -----\n' + _lib.snapshot() + '\n'; } catch (e) { txt += 'snapshot threw: ' + (e && e.message) + '\n'; }
    return txt;
  }
  function copyLog() {
    var txt = logText();
    var done = function () { status('log copied (' + txt.length + ' chars)'); };
    try { global.navigator.clipboard.writeText(txt).then(done, function () { fallback(); }); } catch (e2) { fallback(); }
    function fallback() {
      try { var ta = document.createElement('textarea'); ta.value = txt; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); done(); } catch (e3) { status('copy failed'); }
    }
  }
  /* SEND LOG (blueprints-v19): the log goes to the same store the product
     pages' SEND LOG writes to (leva-share /log), so Marek only says that it
     was sent; on a failure the text goes to the clipboard instead */
  function sendLog(btn) {
    if (!btn || btn.getAttribute('data-send') === 'busy') return;
    btn.setAttribute('data-send', 'busy');
    btn.textContent = 'SENDING...';
    var txt = logText();
    var body = JSON.stringify({ kind: 'log', product: 'blueprints' + (_proj ? (' ' + _proj.product) : ''), version: VERSION, page: String(global.location.href), text: txt });
    global.fetch(worker() + '/log', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, credentials: 'omit', cache: 'no-store' })
      .then(function (r) { return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (eP) {} if (!r.ok || !j || j.ok !== true) throw new Error('HTTP ' + r.status); return j; }); })
      .then(function (j) { btn.setAttribute('data-send', 'ok'); btn.textContent = 'SENT #' + (j.id != null ? j.id : '?'); log('SEND LOG sent as #' + j.id + ', ' + txt.length + ' characters'); })
      .catch(function (err) {
        btn.setAttribute('data-send', 'fail');
        btn.textContent = 'FAIL';
        log('SEND LOG failed: ' + (err && err.message) + ' -- copied instead');
        copyLog();
      });
  }
  function status(m) {
    var el = $('bp-status'); if (el) el.textContent = m;
    try { toast(m); } catch (e) {}
    log('status: ' + m);
  }
  function worker() { return BOOT.shareWorkerUrl || 'https://leva-share.long-cloud-d006.workers.dev'; }

  /* ---------- the projects the user has touched: the diary ---------- */
  function diary() {
    try { return JSON.parse(global.localStorage.getItem('leva-projects') || '[]'); } catch (e) { return []; }
  }
  function diaryAdd(id, product, label) {
    try {
      var d = diary().filter(function (e) { return e.id !== id; });
      d.unshift({ id: id, product: product, label: label, at: new Date().toISOString() });
      global.localStorage.setItem('leva-projects', JSON.stringify(d.slice(0, 30)));
    } catch (e) {}
  }
  function fillProjects(current) {
    var sel = $('bp-projects'); if (!sel) return;
    var d = diary(), i;
    sel.innerHTML = '';
    if (current && !d.some(function (e) { return e.id === current.id; })) d.unshift(current);
    if (!d.length) { var o0 = document.createElement('option'); o0.textContent = '-'; sel.appendChild(o0); return; }
    for (i = 0; i < d.length; i++) {
      var o = document.createElement('option');
      o.value = d[i].id; o.textContent = (d[i].label || d[i].product || '?') + '  (' + d[i].id + ')';
      if (current && d[i].id === current.id) o.selected = true;
      sel.appendChild(o);
    }
    sel.onchange = function () {
      var id = sel.value;
      try { var u = new URL(global.location.href); u.searchParams.set('p', id); global.location.href = u.toString(); } catch (e) {}
    };
  }

  /* ---------- the project ---------- */
  function readP() {
    try { return new URL(global.location.href).searchParams.get('p'); } catch (e) { return null; }
  }
  function fetchProject(id) {
    return global.fetch(worker() + '/s/' + id).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  /* v32: a product's own scripts before its lib (BLUEPRINT_PRE, the bunker's
     model and native builders) */
  function loadPre(product) {
    var list = ((global.BLUEPRINT_PRE || {})[product]) || [], chain = Promise.resolve();
    list.forEach(function (src) {
      chain = chain.then(function () {
        return new Promise(function (ok, no) {
          var s = document.createElement('script'); s.src = src;
          s.onload = function () { ok(); }; s.onerror = function () { no(new Error('script for ' + product + ' failed to load: ' + src)); };
          document.head.appendChild(s);
        });
      });
    });
    return chain;
  }
  function loadLib(product) {
    return loadPre(product).then(function () { return loadLib0(product); });
  }
  function loadLib0(product) {
    return new Promise(function (resolve, reject) {
      var src = LIBS[product] || ('/cdn/shop/t/assets/configurator-' + product + '-lib.js');
      /* v40: the ANY HOUSE engine builds the preset the page names */
      if (global.BLUEPRINT_PRESET && global.BLUEPRINT_PRESET[product]) global.LEVA_PRESET_ID = product;
      var s = document.createElement('script');
      s.src = src;
      s.onload = function () { resolve(global.HouseLib || null); };
      s.onerror = function () { reject(new Error('lib for ' + product + ' failed to load')); };
      document.head.appendChild(s);
    });
  }

  /* ---------- the panel ---------- */
  function cap(s) { s = String(s || ''); return s ? (s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()) : s; }
  function buildViews() {
    var host = $('bp-views'); if (!host) return;
    host.innerHTML = '';
    /* A PLAN PER STOREY (blueprints-v18): a lib with more than one storey
       (planStoreys() > 1, the container) gets Floor plan 1, 2 ... instead of
       one Floor plan; the others keep the one button */
    var nSt = nPlans();
    var keys = ['iso', 'front', 'back', 'left', 'right'], q;
    if (nSt > 1) { for (q = 1; q <= nSt; q++) keys.push('plan' + q); } else keys.push('plan');
    keys = keys.concat(['secX', 'secY', 'secZ', 'free']);
    keys.forEach(function (k) {
      var b = document.createElement('button');
      b.className = (k === _view ? 'on' : '');
      var mP = /^plan(\d+)$/.exec(k);
      var mS = /^sec([XYZ])$/.exec(k);
      b.textContent = mP ? (cap(L.views.plan || 'Floor plan') + ' ' + mP[1]) : mS ? (cap(L.views.section || 'Section') + ' ' + SEC_LETTER[mS[1].toLowerCase()]) : cap(L.views[k] || k);
      b.onclick = function () { setView(k); };
      host.appendChild(b);
    });
    /* + PDF is the gold pill on the canvas (the section's); its count follows the queue */
    var pdf = $('bp-pdf');
    if (pdf) { pdf.textContent = '+ PDF' + (_queue.length ? (' (' + _queue.length + ')') : ''); pdf.onclick = addToSheet; }
  }
  /* =========================================================================
     THE SECTIONS (blueprints-v22, Marek: editovat reznou rovinu / linii /
     rezy s moznosti i lomene cary, idealne automaticke)

     The page cuts the model itself now, not through the configurator's cut
     kit: a section is a LINE IN THE PLAN, made of cut segments square to the
     view and jogs between them -- a stepped section. Each cut segment owns a
     band of the plan, and the model is drawn once per band, each time with
     three planes: the cut and the band's two edges. The bands drawn one over
     the other are the stepped section, in the colour picture and in the line
     drawing alike (the renderer's render is wrapped while a section is on).

     Section A looks along -x (the cut segments run along z), section B looks
     along -z, section C is horizontal at half the height of the model; the
     floor plan is a horizontal cut at the plan's cut height (1.2 m / 4 ft
     over the floor by default, set in the drawer). A and B are proposed
     automatically -- through the best door or window of each of the two
     walls the section crosses, stepped where they do not line up, never
     along a partition -- and shown in the plan as section lines with grips:
     drag a cut segment across, a jog along. Auto and Straight in the drawer.
     The lines are kept per project in this browser.
     ========================================================================= */
  var SEC = { on: false, kind: null, planes: null, bands: [], lines: { x: null, z: null }, planH: null, wrapped: false, note: '' };
  var SEC_LETTER = { x: 'A', z: 'B', y: 'C' };
  /* how far the section line runs past the outline, and its arrows */
  var SEC_OUT = 0.45, SEC_ARROW = 0.5;
  function secPlanes() {
    var T = global.THREE;
    if (!SEC.planes) SEC.planes = [new T.Plane(), new T.Plane(), new T.Plane()];
    return SEC.planes;
  }
  /* a band as three planes, kept where n.p + c >= 0 */
  function secBandsFor(kind) {
    var out = [], FAR = 1e5;
    if (kind === 'plan' || kind === 'y') {
      var h = (kind === 'plan') ? planCutY() : SEC.yMid;
      out.push([[0, -1, 0, h], [0, 1, 0, FAR], [0, 1, 0, FAR]]);
      return out;
    }
    var L0 = SEC.lines[kind]; if (!L0 || !L0.segs || !L0.segs.length) return out;
    L0.segs.forEach(function (sg, i) {
      var lo = (i === 0) ? -FAR : sg.lo, hi = (i === L0.segs.length - 1) ? FAR : sg.hi;
      if (kind === 'x') out.push([[-1, 0, 0, sg.c], [0, 0, 1, -lo], [0, 0, -1, hi]]);
      else out.push([[0, 0, -1, sg.c], [1, 0, 0, -lo], [-1, 0, 0, hi]]);
    });
    return out;
  }
  function secSetBand(i) {
    var P = secPlanes(), B = SEC.bands[i] || SEC.bands[0], k;
    if (!B) return;
    for (k = 0; k < 3; k++) { P[k].normal.set(B[k][0], B[k][1], B[k][2]); P[k].constant = B[k][3]; }
  }
  /* the renderer draws the model once per band */
  function secWrap() {
    var r = _st && _st.renderer;
    if (!r || r.__bpSecWrap) return;
    var orig = r.render.bind(r);
    r.render = function (scene, cam) {
      if (!SEC.on || SEC.bands.length < 2) { if (SEC.on) secSetBand(0); return orig(scene, cam); }
      var ac = r.autoClear, i;
      try {
        for (i = 0; i < SEC.bands.length; i++) { secSetBand(i); r.autoClear = (i === 0) ? ac : false; orig(scene, cam); }
      } finally { r.autoClear = ac; secSetBand(0); }
    };
    r.__bpSecWrap = true;
  }
  /* every material of the model clipped by the three planes and drawn
     double-sided while a section is on (a cut body shows its inside, the
     line drawing reads it as the cut); off, each goes back to its own side */
  function secMaterials() {
    if (!_st || !_st.group) return;
    var P = SEC.on ? secPlanes() : null, n = 0;
    _st.group.traverse(function (o) {
      if (!o.isMesh || !o.material) return;
      var mats = Array.isArray(o.material) ? o.material : [o.material], k;
      for (k = 0; k < mats.length; k++) {
        var m = mats[k]; if (!m) continue;
        if (P) {
          if (m.clippingPlanes === P) continue;
          if (m.userData.__bpSide === undefined) m.userData.__bpSide = m.side;
          m.side = global.THREE.DoubleSide; m.clippingPlanes = P; m.needsUpdate = true; n++;
        } else if (m.clippingPlanes === SEC.planes && SEC.planes) {
          if (m.userData.__bpSide !== undefined) { m.side = m.userData.__bpSide; delete m.userData.__bpSide; }
          m.clippingPlanes = null; m.needsUpdate = true; n++;
        }
      }
    });
    try { _st.renderer.localClippingEnabled = true; } catch (e) {}
    return n;
  }
  function secSet(kind) {
    secWrap();
    if (kind === 'y') {
      var T = global.THREE, bx = new T.Box3();
      try { bx.setFromObject(_st.group); SEC.yMid = (bx.min.y + bx.max.y) / 2; } catch (e) { SEC.yMid = 1.5; }
    }
    if (kind === 'x' || kind === 'z') secEnsure();
    SEC.kind = kind || null;
    SEC.bands = kind ? secBandsFor(kind) : [];
    SEC.on = SEC.bands.length > 0;
    if (SEC.on) secSetBand(0);
    var n = secMaterials();
    SEC.note = SEC.on ? ((kind === 'plan' ? 'plan cut at ' + Math.round(planCutY() * 1000) + ' mm over grade' :
               'section ' + (SEC_LETTER[kind] || kind) + ': ' + SEC.bands.length + ' band(s)' +
               (SEC.lines[kind] ? (' ' + SEC.lines[kind].segs.map(function (sg) { return Math.round(sg.c * 1000); }).join(' / ') + ' mm' + (SEC.lines[kind].auto ? ' (auto)' : '')) : '')) +
               ', ' + (n | 0) + ' material(s) clipped') : 'off';
    if (SEC.note !== SEC.said) { SEC.said = SEC.note; log('section ' + SEC.note); }
  }
  /* THE FLOOR PLAN IS A CUT (blueprints-v19): 1.2 m / 4 ft over the storey's
     floor unless the drawer says otherwise; since v26 the container's too
     (its storeys come from its anchors, anchorsOwn) */
  /* ---- STOREYS (v24): a house-line lib with an upper storey (GARAGE APT)
     gets a floor plan per storey, like the container. dimAnchors hands
     every opening and partition of the house: a plan takes only those of
     the storey it shows and stands on that storey's floor; an elevation
     puts an upstairs opening on its own floor and adds the floor's level.
     The container (planStoreys) brings its storeys in its anchors: see
     anchorsOwn. ---- */
  function storeyList() { try { return (_lib && _lib.storeys && !_lib.planStoreys) ? (_lib.storeys() || []) : []; } catch (e) { return []; } }
  function nPlans() {
    try { if (_lib && _lib.planStoreys) return Math.max(1, _lib.planStoreys() | 0); } catch (e) {}
    return Math.max(1, storeyList().length);
  }
  function planSt() { var m = /^plan(\d+)$/.exec(_view || ''); return m ? Math.max(0, (m[1] | 0) - 1) : 0; }
  /* the walls of an outline polygon with their outward normals (v26) */
  function polyEdges(P) {
    var E = [], i, n = P.length;
    function inside(x, z) {
      var c = false, j, k;
      for (j = 0, k = n - 1; j < n; k = j++) {
        var xi = P[j][0], zi = P[j][1], xk = P[k][0], zk = P[k][1];
        if (((zi > z) !== (zk > z)) && (x < (xk - xi) * (z - zi) / ((zk - zi) || 1e-12) + xi)) c = !c;
      }
      return c;
    }
    for (i = 0; i < n; i++) {
      var a = P[i], b = P[(i + 1) % n], dx = b[0] - a[0], dz = b[1] - a[1], L0 = Math.sqrt(dx * dx + dz * dz);
      if (L0 < 0.01) continue;
      var nx = dz / L0, nz = -dx / L0, mx = (a[0] + b[0]) / 2, mz = (a[1] + b[1]) / 2;
      if (inside(mx + nx * 0.02, mz + nz * 0.02)) { nx = -nx; nz = -nz; }
      E.push({ x0: a[0], z0: a[1], x1: b[0], z1: b[1], nx: Math.round(nx * 1000) / 1000, nz: Math.round(nz * 1000) / 1000 });
    }
    return E;
  }
  /* the wall an opening stands in: the nearest wall of its outline */
  function edgeNear(E, x, z) {
    var best = null, bd = 1e9, i;
    for (i = 0; i < E.length; i++) {
      var e = E[i], dx = e.x1 - e.x0, dz = e.z1 - e.z0, L2 = dx * dx + dz * dz || 1e-12;
      var t = Math.max(0, Math.min(1, ((x - e.x0) * dx + (z - e.z0) * dz) / L2)), px = e.x0 + dx * t - x, pz = e.z0 + dz * t - z, d = px * px + pz * pz;
      if (d < bd) { bd = d; best = e; }
    }
    return (best && bd < 0.5 * 0.5) ? best : null;
  }
  /* THE CONTAINER (v26): its anchors carry their storeys (floor, top, the
     boxes' rectangle) and every opening and partition its level; its
     partitions run 'x' / 'z' where the core says 'h' / 'v'. Brought into the
     core's shape here, so the plan per storey, the elevations and the
     sections read it like any house */
  function anchorsOwn(A, all) {
    var CS = A.storeys || [], i, byL = {};
    for (i = 0; i < CS.length; i++) byL[CS[i].lvl | 0] = CS[i];
    A.levels = CS.map(function (q) { return q.floor; });
    (A.partitions || []).forEach(function (q) { if (q.dir === 'x') q.dir = 'h'; else if (q.dir === 'z') q.dir = 'v'; q.st = q.lvl | 0; });
    var kP = (!all && /^plan/.test(_view || '')) ? planSt() : 0;
    var EB = {};
    function edgesOf(l) {
      if (EB[l]) return EB[l];
      var PP = null; try { PP = _lib.planPoly ? _lib.planPoly(l) : null; } catch (eP) { PP = null; }
      EB[l] = (PP && PP.length >= 3) ? polyEdges(PP) : [];
      return EB[l];
    }
    (A.openings || []).forEach(function (o) {
      o.st = o.lvl | 0; o.fy = (byL[o.st] || CS[0] || { floor: A.floor }).floor;
      var e = edgeNear(edgesOf(o.st), o.x, o.z); if (e) { o.nx = e.nx; o.nz = e.nz; }
    });
    if (edgesOf(kP).length) A.edges = edgesOf(kP);
    if (!all && /^plan/.test(_view || '')) {
      A.openings = A.openings.filter(function (q) { return q.st === kP; });
      A.partitions = A.partitions.filter(function (q) { return q.st === kP; });
      if (byL[kP]) { A.floor = byL[kP].floor; if (byL[kP].rect) A.rect = byL[kP].rect; }
      A.planSt = kP;
    }
    return A;
  }
  function anchors(all) {
    var A = null; try { A = (_lib && _lib.dimAnchors) ? _lib.dimAnchors() : null; } catch (e) { A = null; }
    if (!A || !A.rect) return A;
    if (_lib.planStoreys && A.storeys) return anchorsOwn(A, all);
    var SG = [], i; try { SG = (_lib.segments && !_lib.planStoreys) ? (_lib.segments() || []) : []; } catch (eS) { SG = []; }
    /* v25: THE OUTLINE AS IT IS, not its box -- every outside wall with its
       outward normal (a T or an L has walls set back from the box), and
       every opening knows which way its wall faces */
    for (i = 0; i < (A.openings || []).length; i++) {
      var sgN = SG[A.openings[i].seg];
      if (sgN && typeof sgN.nx === 'number') { A.openings[i].nx = sgN.nx; A.openings[i].nz = sgN.nz; }
    }
    var stE = (!all && /^plan\d+$/.test(_view || '')) ? planSt() : 0;
    A.edges = SG.filter(function (q) { return q && typeof q.nx === 'number' && (q.storey | 0) === stE && q.len > 0.01; })
                .map(function (q) { return { x0: q.x0, z0: q.z0, x1: q.x1, z1: q.z1, nx: q.nx, nz: q.nz }; });
    if (!A.edges.length) delete A.edges;
    var ST = storeyList(); if (ST.length < 2) return A;
    var PS = (_lib.STATE && _lib.STATE.parts) || [];
    A.levels = ST.map(function (q) { return q.y0; });
    for (i = 0; i < (A.openings || []).length; i++) {
      var o = A.openings[i], sg = SG[o.seg];
      o.st = sg ? (sg.storey | 0) : 0; o.fy = ST[o.st] ? ST[o.st].y0 : A.floor;
    }
    for (i = 0; i < (A.partitions || []).length; i++) A.partitions[i].st = PS[i] ? (PS[i].st | 0) : 0;
    if (!all && /^plan/.test(_view || '')) {
      var k = planSt();
      A.openings = A.openings.filter(function (q) { return q.st === k; });
      A.partitions = A.partitions.filter(function (q) { return q.st === k; });
      if (ST[k]) A.floor = ST[k].y0;
      A.planSt = k;
    }
    return A;
  }
  function floorY() {
    try { var A = anchors(); return (A && typeof A.floor === 'number') ? A.floor : 0; } catch (e) { return 0; }
  }
  function planCutH() { return (SEC.planH != null) ? SEC.planH : (isMetric() ? 1.2 : 4 * 0.3048); }
  function planCutY() { return floorY() + planCutH(); }
  var _planNote = '';
  /* ---- the section lines: automatic, straight, kept ---- */
  function secKey() { return 'leva-bp-sec-' + (readP() || '-'); }
  function secSave() {
    try { global.localStorage.setItem(secKey(), JSON.stringify({ x: SEC.lines.x, z: SEC.lines.z, planH: SEC.planH })); } catch (e) {}
  }
  function secLoad() {
    try {
      var o = JSON.parse(global.localStorage.getItem(secKey()) || 'null');
      if (!o) return;
      ['x', 'z'].forEach(function (k) { if (o[k] && o[k].segs && o[k].segs.length) SEC.lines[k] = o[k]; });
      if (typeof o.planH === 'number' && o.planH > 0.2 && o.planH < 4) SEC.planH = o.planH;
    } catch (e) {}
  }
  function secEnsure() {
    var A = anchors(true);
    if (!A || !A.rect) return;
    ['x', 'z'].forEach(function (k) {
      var L0 = SEC.lines[k], R = A.rect;
      var lo = (k === 'x') ? R.z0 : R.x0, hi = (k === 'x') ? R.z1 : R.x1, c0 = (k === 'x') ? R.x0 : R.z0, c1 = (k === 'x') ? R.x1 : R.z1;
      var bad = !L0 || !L0.segs || !L0.segs.length || L0.segs.some(function (sg) { return !(sg.c > c0 - 0.01 && sg.c < c1 + 0.01); });
      /* an automatic line follows the building: proposed again whenever the
         outline, the openings or the partitions change; a line moved by
         hand stays where it was put */
      if (!bad && L0.auto && L0.sig !== secSig(A)) bad = true;
      if (bad) SEC.lines[k] = secAuto(k, A);
      else { L0.segs[0].lo = lo; L0.segs[L0.segs.length - 1].hi = hi; }
    });
  }
  /* THE AUTOMATIC SECTION. Section A (kind x) cuts the two walls that run
     along x -- the outline's z0 and z1 sides -- and B the x0 / x1 sides. On
     each of the two walls the best opening is taken (a door before a window,
     the wider before the narrower, none closer than 0.3 m to a corner or
     along a partition); where the two do not line up the line steps between
     them, the jog in the middle of the room band nearest the centre of the
     building. No opening anywhere: straight through the middle, beside any
     partition there. */
  function secAuto(kind, A) {
    var R = A.rect, wt = A.wallThk || 0.15, pt = partThk(), OPS = A.openings || [], PA = A.partitions || [];
    var along = (kind === 'x') ? 'x' : 'z';
    var c0 = (kind === 'x') ? R.x0 : R.z0, c1 = (kind === 'x') ? R.x1 : R.z1;
    var lo = (kind === 'x') ? R.z0 : R.x0, hi = (kind === 'x') ? R.z1 : R.x1;
    /* partitions square to the cut would be cut along their length: avoided */
    var parDir = (kind === 'x') ? 'v' : 'h';
    function nearPart(c) { for (var i = 0; i < PA.length; i++) if (PA[i].dir === parDir && Math.abs(PA[i].at - c) < pt / 2 + 0.15) return true; return false; }
    function ok(c) { return c > c0 + wt + 0.3 && c < c1 - wt - 0.3 && !nearPart(c); }
    function best(wallAt) {
      var b = null, i;
      for (i = 0; i < OPS.length; i++) {
        var o = OPS[i]; if (o.along !== along) continue;
        var pos = (along === 'x') ? o.z : o.x;
        if (Math.abs(pos - wallAt) > 0.35) continue;
        var c = (along === 'x') ? o.x : o.z, sc = (o.kind === 'door' ? 100 : 50) + o.w;
        if (!ok(c)) { var c2 = c + o.w / 4; if (ok(c2)) c = c2; else continue; }
        if (!b || sc > b.sc) b = { c: c, sc: sc };
      }
      return b;
    }
    var b0 = best(lo), b1 = best(hi), segs;
    if (b0 && b1 && Math.abs(b0.c - b1.c) > 0.3) {
      /* the jog: between two room bands, nearest the middle */
      var parAcross = (kind === 'x') ? 'h' : 'v', marks = [lo, hi], i, mid = (lo + hi) / 2, j = mid, bd = 1e9;
      for (i = 0; i < PA.length; i++) if (PA[i].dir === parAcross) marks.push(PA[i].at);
      marks.sort(function (a, b) { return a - b; });
      for (i = 1; i < marks.length; i++) { var m = (marks[i - 1] + marks[i]) / 2; if (Math.abs(m - mid) < bd) { bd = Math.abs(m - mid); j = m; } }
      segs = [{ c: b0.c, lo: lo, hi: j }, { c: b1.c, lo: j, hi: hi }];
    } else {
      var c = b0 ? b0.c : b1 ? b1.c : (c0 + c1) / 2, k2;
      if (!b0 && !b1 && nearPart(c)) for (k2 = 1; k2 < 20; k2++) { if (!nearPart(c + k2 * 0.1)) { c += k2 * 0.1; break; } if (!nearPart(c - k2 * 0.1)) { c -= k2 * 0.1; break; } }
      segs = [{ c: c, lo: lo, hi: hi }];
    }
    return { segs: segs, auto: true, sig: secSig(A) };
  }
  function secSig(A) {
    function r(v) { return Math.round(v * 100); }
    var R = A.rect, s0 = [r(R.x0), r(R.x1), r(R.z0), r(R.z1)].join(',');
    (A.openings || []).forEach(function (o) { s0 += '|' + o.along + r(o.x) + ',' + r(o.z) + ',' + r(o.w) + (o.kind || ''); });
    (A.partitions || []).forEach(function (q) { s0 += '|' + q.dir + r(q.at) + ',' + r(q.a) + ',' + r(q.b); });
    return s0;
  }
  function secStraight(kind) {
    var L0 = SEC.lines[kind]; if (!L0) return;
    var s0 = L0.segs[0], s1 = L0.segs[L0.segs.length - 1];
    SEC.lines[kind] = { segs: [{ c: s0.c, lo: s0.lo, hi: s1.hi }], auto: false };
  }
  /* ---- THE GRIPS on the section lines: plan view, on screen only ----
     red on a cut segment (drag it across), dark on a jog (drag it along);
     released, the line is kept for the project in this browser */
  var GRIP = { drag: null, raf: 0 };
  function gripLayer() {
    var g = $('bp-grips');
    if (g) return g;
    var root = $('cf-root'); if (!root) return null;
    g = svgEl('svg', { id: 'bp-grips' });
    g.setAttribute('style', 'position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:6;overflow:visible;');
    root.appendChild(g);
    return g;
  }
  function drawGrips() {
    if (GRIP.drag) return;
    var g = gripLayer(); if (!g) return;
    while (g.firstChild) g.removeChild(g.firstChild);
    if (!/^plan/.test(_view) || !dimsWanted() || !_lib || !_lib.dimAnchors) return;
    var F = camFrame(); if (!F) return;
    var A = anchors(); if (!A || !A.rect) return;
    g.setAttribute('viewBox', '0 0 ' + F.W + ' ' + F.H);
    ['x', 'z'].forEach(function (kind) {
      var L0 = SEC.lines[kind]; if (!L0) return;
      var pts = secPolyline(kind, A.rect), n = L0.segs.length, i;
      for (i = 0; i < n; i++) {
        var p0 = pts[2 * i], p1 = pts[2 * i + 1];
        /* A's grips a little before the middle of a segment, B's a little after: the two lines' grips never sit on each other */
        var fr = (kind === 'x') ? 0.4 : 0.6;
        addGrip(g, F, [p0[0] + (p1[0] - p0[0]) * fr, p0[1] + (p1[1] - p0[1]) * fr], kind, 'seg', i);
        if (i + 1 < n) { var q0 = pts[2 * i + 1], q1 = pts[2 * i + 2]; addGrip(g, F, [(q0[0] + q1[0]) / 2, (q0[1] + q1[1]) / 2], kind, 'jog', i); }
      }
    });
  }
  function addGrip(g, F, w, kind, what, i) {
    var q = F.uv(w[0], 0, w[1]), p = F.px(q[0], q[1]);
    var c = svgEl('circle', { cx: p[0].toFixed(1), cy: p[1].toFixed(1), r: '12', fill: '#fff', stroke: what === 'seg' ? '#E8442A' : '#1A1C1D', 'stroke-width': '3.5' });
    c.setAttribute('style', 'pointer-events:all;touch-action:none;cursor:grab;');
    c.setAttribute('data-grip', kind + ':' + what + ':' + i);
    c.addEventListener('pointerdown', function (ev) { gripDown(ev, c, kind, what, i); });
    g.appendChild(c);
  }
  function gripDown(ev, el, kind, what, i) {
    ev.preventDefault(); ev.stopPropagation();
    var F = camFrame(), A = anchors();
    var L0 = SEC.lines[kind];
    if (!F || !A || !A.rect || !L0) return;
    try { el.setPointerCapture(ev.pointerId); } catch (e0) {}
    GRIP.drag = { kind: kind, what: what, i: i };
    var R = A.rect, n = L0.segs.length;
    var start = { x: ev.clientX, y: ev.clientY, c: L0.segs[i].c, j: (what === 'jog') ? L0.segs[i].hi : 0, cx: +el.getAttribute('cx'), cy: +el.getAttribute('cy') };
    /* the world axis the grip moves along, and how many pixels a metre is on it */
    var ax = (what === 'seg') ? (kind === 'x' ? [1, 0, 0] : [0, 0, 1]) : (kind === 'x' ? [0, 0, 1] : [1, 0, 0]);
    var u0 = F.uv(0, 0, 0), u1 = F.uv(ax[0], ax[1], ax[2]), p0 = F.px(u0[0], u0[1]), p1 = F.px(u1[0], u1[1]);
    var sx = p1[0] - p0[0], sy = p1[1] - p0[1], s2 = sx * sx + sy * sy || 1;
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
    function move(e) {
      var dx = e.clientX - start.x, dy = e.clientY - start.y, d = (dx * sx + dy * sy) / s2, moved = 0;
      if (what === 'seg') {
        var c0 = (kind === 'x') ? R.x0 : R.z0, c1 = (kind === 'x') ? R.x1 : R.z1, v = clamp(start.c + d, c0 + 0.05, c1 - 0.05);
        moved = v - start.c; L0.segs[i].c = v;
      } else {
        var lo = (i === 0) ? ((kind === 'x') ? R.z0 : R.x0) : L0.segs[i].lo, hi = (i + 1 === n - 1) ? ((kind === 'x') ? R.z1 : R.x1) : L0.segs[i + 1].hi;
        var w = clamp(start.j + d, lo + 0.3, hi - 0.3);
        moved = w - start.j; L0.segs[i].hi = w; L0.segs[i + 1].lo = w;
      }
      L0.auto = false;
      el.setAttribute('cx', (start.cx + sx * moved).toFixed(1)); el.setAttribute('cy', (start.cy + sy * moved).toFixed(1));
      if (!GRIP.raf) GRIP.raf = global.requestAnimationFrame(function () { GRIP.raf = 0; drawDims(); });
    }
    function up() {
      el.removeEventListener('pointermove', move); el.removeEventListener('pointerup', up); el.removeEventListener('pointercancel', up);
      GRIP.drag = null;
      secSave();
      log('section ' + SEC_LETTER[kind] + ' moved by hand: ' + L0.segs.map(function (sg) { return Math.round(sg.c * 1000) + ' [' + Math.round(sg.lo * 1000) + '..' + Math.round(sg.hi * 1000) + ']'; }).join(' / ') + ' mm');
      drawDims(); buildSecUI();
    }
    el.addEventListener('pointermove', move); el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up);
  }
  /* ---- THE DRAWER: Auto / Straight per section, the plan's cut height ---- */
  function buildSecUI() {
    var host = $('bp-sec'); if (!host || !_lib) return;
    host.innerHTML = '';
    var S = L.sec || {}, A = null;
    A = anchors(true);
    secEnsure();
    function again() { secSave(); if (/^sec[XZ]$/.test(_view) || /^plan/.test(_view)) setView(_view); else buildSecUI(); }
    ['x', 'z'].forEach(function (kind) {
      var L0 = SEC.lines[kind], row = document.createElement('div'); row.className = 'bp-secrow';
      var lt = document.createElement('span'); lt.className = 'bp-secl'; lt.textContent = SEC_LETTER[kind];
      var au = document.createElement('button'); au.type = 'button'; au.className = 'bp-btn' + (L0 && L0.auto ? ' on' : '');
      au.textContent = S.auto || 'Auto';
      au.onclick = function () { if (A && A.rect) { SEC.lines[kind] = secAuto(kind, A); log('section ' + SEC_LETTER[kind] + ' proposed again (auto)'); } again(); };
      var st = document.createElement('button'); st.type = 'button'; st.className = 'bp-btn' + (L0 && !L0.auto && L0.segs.length === 1 ? ' on' : '');
      st.textContent = S.straight || 'Straight';
      st.onclick = function () { secStraight(kind); log('section ' + SEC_LETTER[kind] + ' straight'); again(); };
      row.appendChild(lt); row.appendChild(au); row.appendChild(st);
      host.appendChild(row);
    });
    /* the plan's cut height over the floor */
    var hr = document.createElement('div'); hr.className = 'bp-secrow';
    var hl = document.createElement('span'); hl.className = 'bp-sech'; hl.textContent = cap(L.views.plan || 'Floor plan') + ' \u00B7 ' + cap(S.height || 'Height');
    var hv = document.createElement('span'); hv.className = 'bp-secv'; hv.textContent = fmtD(planCutH());
    hr.appendChild(hl); hr.appendChild(hv); host.appendChild(hr);
    var rg = document.createElement('input'); rg.type = 'range'; rg.style.width = '100%';
    var metric = isMetric(), stp = metric ? 0.05 : 0.0254;
    rg.min = String(metric ? 0.5 : 18 * 0.0254); rg.max = String(metric ? 2.4 : 96 * 0.0254); rg.step = String(stp);
    rg.value = String(planCutH());
    var t = 0;
    rg.oninput = function () {
      SEC.planH = Math.round(parseFloat(rg.value) / stp) * stp; hv.textContent = fmtD(SEC.planH);
      if (t) global.clearTimeout(t);
      t = global.setTimeout(function () { t = 0; secSave(); log('plan cut height ' + Math.round(SEC.planH * 1000) + ' mm over the floor'); if (/^plan/.test(_view)) setView(_view); }, 200);
    };
    host.appendChild(rg);
  }
  /* is partition q cut by the section on screen (in its own band)? */
  function secCuts(q, faceAlong) {
    var kind = SEC.kind; if (!SEC.on || (kind !== 'x' && kind !== 'z')) return false;
    var runsAlong = (q.dir === 'h') ? 'x' : 'z';
    if (runsAlong === faceAlong) return false;
    var L0 = SEC.lines[kind]; if (!L0) return false;
    for (var i = 0; i < L0.segs.length; i++) {
      var sg = L0.segs[i], lo = i === 0 ? -1e9 : sg.lo, hi = i === L0.segs.length - 1 ? 1e9 : sg.hi;
      if (q.at >= lo && q.at <= hi && sg.c >= Math.min(q.a, q.b) - 0.01 && sg.c <= Math.max(q.a, q.b) + 0.01) return true;
    }
    return false;
  }
  function setView(k) {
    _view = k;
    if (!_st) return;
    var sec = /^sec([XYZ])$/.exec(k);
    /* v26: every plan is the page's own cut, the container's too (its own
       2D plan was a canvas of its own the PDF never saw) */
    if (sec || /^plan\d*$/.test(k)) {
      try { if (_lib.STATE && _lib.STATE.view === '2d') _lib.setView('3d'); } catch (e0) {}
      /* the floorplan asset's rooms and doors follow the storey on show */
      if (!sec && nPlans() > 1) {
        if (_lib.setPlanStorey) { try { _lib.setPlanStorey(planSt()); } catch (eSP) {} }
        else { try { _lib.STATE.planStorey = planSt(); } catch (ePS) {} }
      }
      var kind = sec ? sec[1].toLowerCase() : 'plan';
      secSet(kind);
      var preset = (kind === 'x') ? 'right' : (kind === 'z') ? 'back' : 'top';
      try { _st.viewPreset(preset); } catch (e1) {}
      if (kind === 'plan') _planNote = SEC.note;
    } else {
      secSet(null);
      try { if (_lib.STATE && _lib.STATE.view === '2d') _lib.setView('3d'); } catch (e) {}
      try { _st.viewPreset(k === 'free' ? 'free' : k); } catch (e2) { log('preset ' + k + ' failed: ' + e2.message); }
    }
    buildViews();
    frame();
    watchControls();
    applyInk();
    if (!_inApply) buildSecUI();
    /* v27: anything that changes a view changes the sheets */
    scheduleSheets();
  }
  /* THE VIEWS BAR DOES NOT COVER THE DRAWING (blueprints-v18). A square-on
     view fits the model to the whole canvas, and the bar of view buttons
     lies over its top -- a two-storey container lost its roof under it. The
     ortho camera is widened by the bar's share of the height, the bottom
     kept, so the model sits in the canvas below the bar, undistorted. */
  function clearBar() {
    var cam = _st && _st.camera, bar = $('bp-views'), cv = _st && _st.renderer && _st.renderer.domElement;
    if (!cam || !cam.isOrthographicCamera || !bar || !cv) return;
    var br = bar.getBoundingClientRect(), cr = cv.getBoundingClientRect();
    var hPx = br.bottom - cr.top + 10;
    if (!(hPx > 0) || hPx > cr.height * 0.4) return;
    var k = 1 / (1 - hPx / cr.height), cx = (cam.left + cam.right) / 2, hw = (cam.right - cam.left) / 2 * k;
    cam.left = cx - hw; cam.right = cx + hw;
    cam.top = cam.bottom + (cam.top - cam.bottom) * k;
    cam.updateProjectionMatrix();
  }
  /* =========================================================================
     COLOUR TO LINES (blueprints-v20)

     The drawing is drawn by the graphics card, not traced from the meshes.
     Two hidden passes of the very camera on screen -- every body painted
     with its normal, then with a number of its own -- are read back and
     turned into ink here: a line wherever the number changes (an outline,
     the edge of one board against the next) or the surface folds (a crease
     inside one body), so whatever is hidden behind something nearer is never
     drawn, instanced studs and big merged bodies included. Inside a section
     a body is seen from inside (its back faces), and that is the cut: it is
     filled grey with a hatch and its outline drawn heavy, the way a section
     is drawn by hand. A faded layer draws its lines light grey.

     The slider lays this drawing over the coloured model: at 0 the colour
     alone, at 100 the drawing alone -- white bodies, black lines (Marek: the
     colour disappears, it is not a black-and-white photo). The model itself
     is never touched. The same routine draws the sheets of the PDF at the
     sheet's own resolution.
     ========================================================================= */
  var LN = { rtN: null, rtI: null, mats: null, uMode: { value: 0 }, uCap: { value: 0 }, canvas: null, t: 0, ms: 0, n: 0, note: '' };
  var LN_VS = [
    '#include <common>',
    '#include <clipping_planes_pars_vertex>',
    'varying vec3 vN;',
    'flat varying float vInst;',
    'void main() {',
    '  #include <beginnormal_vertex>',
    '  #include <defaultnormal_vertex>',
    '  vN = normalize( transformedNormal );',
    '  #include <begin_vertex>',
    '  #include <project_vertex>',
    '  #include <clipping_planes_vertex>',
    '#ifdef USE_INSTANCING',
    '  vInst = float( gl_InstanceID );',
    '#else',
    '  vInst = 0.0;',
    '#endif',
    '}'].join('\n');
  var LN_FS = [
    '#include <clipping_planes_pars_fragment>',
    'uniform float uMode;',
    'uniform float uCap;',
    'uniform float uId;',
    'uniform float uDim;',
    'varying vec3 vN;',
    'flat varying float vInst;',
    'void main() {',
    '  #include <clipping_planes_fragment>',
    '  bool front = gl_FrontFacing;',
    '#ifdef FLIP_SIDED',
    '  front = !front;',
    '#endif',
    '  if ( uMode < 0.5 ) {',
    '    vec3 n = normalize( vN );',
    '    if ( !gl_FrontFacing ) n = -n;',
    '    gl_FragColor = vec4( n * 0.5 + 0.5, 1.0 );',
    '  } else {',
    '    float id = mod( uId + vInst * 4099.0, 16777000.0 ) + 1.0;',
    '    float r = floor( id / 65536.0 );',
    '    float g = floor( mod( id, 65536.0 ) / 256.0 );',
    '    float b = mod( id, 256.0 );',
    '    float a = ( uCap > 0.5 && !front ) ? 0.3 : ( uDim > 0.5 ? 0.6 : 1.0 );',
    '    gl_FragColor = vec4( r / 255.0, g / 255.0, b / 255.0, a );',
    '  }',
    '}'].join('\n');
  function lnMat(o) {
    var T = global.THREE;
    if (!LN.mats) LN.mats = new WeakMap();
    var m = LN.mats.get(o);
    if (!m) {
      m = new T.ShaderMaterial({ vertexShader: LN_VS, fragmentShader: LN_FS, clipping: true,
        uniforms: { uMode: LN.uMode, uCap: LN.uCap, uId: { value: 0 }, uDim: { value: 0 } } });
      m.blending = T.NoBlending; m.transparent = false;
      LN.mats.set(o, m);
    }
    return m;
  }
  function lnTarget(old, W, H) {
    var T = global.THREE;
    if (old && old.width === W && old.height === H) return old;
    if (old) { try { old.dispose(); } catch (e) {} }
    return new T.WebGLRenderTarget(W, H, { depthBuffer: true, stencilBuffer: false, type: T.UnsignedByteType, format: T.RGBAFormat,
                                           minFilter: T.NearestFilter, magFilter: T.NearestFilter, generateMipmaps: false });
  }
  /* the two passes through camera cam at W x H device pixels */
  function lnBuffers(cam, W, H) {
    var T = global.THREE, r = _st.renderer, scene = _st.scene, group = _st.group;
    LN.rtN = lnTarget(LN.rtN, W, H); LN.rtI = lnTarget(LN.rtI, W, H);
    var hidden = [], swapped = [], idx = 0, i;
    for (i = 0; i < scene.children.length; i++) {
      var c = scene.children[i];
      if (c !== group && c.visible && !c.isLight) { hidden.push(c); c.visible = false; }
    }
    var cutOn = !!SEC.on;
    group.traverse(function (o) {
      if (!o.visible) return;
      if (o.isMesh) {
        var m0 = Array.isArray(o.material) ? o.material[0] : o.material;
        if (!m0 || m0.visible === false || m0.colorWrite === false || (o.userData && (o.userData.isEdge || o.userData.bpSkip))) { hidden.push(o); o.visible = false; return; }
        var lm = lnMat(o), side = (m0.side == null) ? T.FrontSide : m0.side, cp = m0.clippingPlanes || null;
        if (lm.side !== side || (lm.clippingPlanes ? lm.clippingPlanes.length : 0) !== (cp ? cp.length : 0)) lm.needsUpdate = true;
        lm.side = side; lm.clippingPlanes = cp; lm.clipIntersection = !!m0.clipIntersection;
        /* what decides who is in front stays the body's own: a board laid on a
           frame in the same plane wins by its polygon offset on screen, so it
           must here too */
        lm.polygonOffset = !!m0.polygonOffset; lm.polygonOffsetFactor = m0.polygonOffsetFactor || 0; lm.polygonOffsetUnits = m0.polygonOffsetUnits || 0;
        lm.depthTest = m0.depthTest !== false; lm.depthFunc = m0.depthFunc;
        lm.uniforms.uId.value = ++idx;
        lm.uniforms.uDim.value = (m0.userData && m0.userData.__dim !== undefined) ? 1 : 0;
        swapped.push([o, o.material]); o.material = lm;
      } else if ((o.isLine || o.isPoints || o.isSprite) && o.visible) { hidden.push(o); o.visible = false; }
    });
    var bg = scene.background, tgt = r.getRenderTarget(), cc = r.getClearColor(new T.Color()), ca = r.getClearAlpha(), ac = r.autoClear;
    var N = new Uint8Array(W * H * 4), I = new Uint8Array(W * H * 4);
    try {
      scene.background = null; r.setClearColor(0x000000, 0); r.autoClear = true;
      LN.uCap.value = cutOn ? 1 : 0;
      LN.uMode.value = 0; r.setRenderTarget(LN.rtN); r.clear(true, true, true); r.render(scene, cam);
      r.readRenderTargetPixels(LN.rtN, 0, 0, W, H, N);
      LN.uMode.value = 1; r.setRenderTarget(LN.rtI); r.clear(true, true, true); r.render(scene, cam);
      r.readRenderTargetPixels(LN.rtI, 0, 0, W, H, I);
    } finally {
      r.setRenderTarget(tgt); r.setClearColor(cc, ca); r.autoClear = ac; scene.background = bg;
      for (i = 0; i < swapped.length; i++) swapped[i][0].material = swapped[i][1];
      for (i = 0; i < hidden.length; i++) hidden[i].visible = true;
    }
    LN.n = idx;
    return { N: N, I: I, W: W, H: H };
  }
  /* the passes turned into ink: s is the thickness scale (1 on screen at
     its own pixel ratio, more on a sheet). The rows come bottom-up. */
  function lnCompose(B, s, out) {
    var W = B.W, H = B.H, N = B.N, I = B.I, x, y, k;
    var mark = new Uint8Array(W * H);
    /* the flags ride in alpha: 0 nothing, ~76 the cut (0.3 rounds either way
       on different cards), ~153 a faded layer, 255 the rest */
    function isCap(a) { return a > 20 && a < 115; }
    function isDim(a) { return a >= 115 && a < 205; }
    var COS = 0.86 * 127.5 * 127.5;
    function edge(i, j) {
      var a = I[i + 3], b = I[j + 3];
      if (a === 0 && b === 0) return 0;
      var e = 0;
      var ca = isCap(a), cb = isCap(b);
      if (a === 0 || b === 0 || I[i] !== I[j] || I[i + 1] !== I[j + 1] || I[i + 2] !== I[j + 2] || ca !== cb) e = 1;
      else if (!ca) {
        var d = (N[i] - 127.5) * (N[j] - 127.5) + (N[i + 1] - 127.5) * (N[j + 1] - 127.5) + (N[i + 2] - 127.5) * (N[j + 2] - 127.5);
        if (d < COS) e = 1;
      }
      if (!e) return 0;
      if (ca || cb) return 3;
      if ((isDim(a) || a === 0) && (isDim(b) || b === 0)) return 1;
      return 2;
    }
    for (y = 0; y < H; y++) {
      for (x = 0; x < W; x++) {
        var p = y * W + x, i = p * 4, e1 = 0, e2 = 0;
        if (x + 1 < W) e1 = edge(i, i + 4);
        if (y + 1 < H) e2 = edge(i, i + W * 4);
        var e = e1 > e2 ? e1 : e2;
        if (e) mark[p] = e;
      }
    }
    /* white, the cut hatched over light grey */
    var hs = Math.max(4, Math.round(7 * s)), hw = Math.max(1, Math.round(0.9 * s));
    for (y = 0; y < H; y++) {
      var oy = H - 1 - y;
      for (x = 0; x < W; x++) {
        var q = (y * W + x) * 4, o = (oy * W + x) * 4, v = 255;
        if (isCap(I[q + 3])) v = ((x + oy) % hs) < hw ? 120 : 222;
        out[o] = v; out[o + 1] = v; out[o + 2] = v; out[o + 3] = 255;
      }
    }
    /* the lines, light ones first, the cut last and heaviest */
    var tN = Math.max(1, Math.round(1.0 * s)), tC = Math.max(2, Math.round(2.2 * s));
    var lev, col = { 1: 175, 2: 26, 3: 0 }, th = { 1: tN, 2: tN, 3: tC };
    for (lev = 1; lev <= 3; lev++) {
      var t = th[lev], cv = col[lev], h0 = (t - 1) >> 1;
      for (y = 0; y < H; y++) {
        for (x = 0; x < W; x++) {
          if (mark[y * W + x] !== lev) continue;
          var oy2 = H - 1 - y;
          for (k = 0; k < t * t; k++) {
            var xx = x - h0 + (k % t), yy = oy2 - h0 + ((k / t) | 0);
            if (xx < 0 || yy < 0 || xx >= W || yy >= H) continue;
            var o2 = (yy * W + xx) * 4;
            if (out[o2] > cv) { out[o2] = cv; out[o2 + 1] = cv; out[o2 + 2] = cv; }
          }
        }
      }
    }
    return out;
  }
  function lnCanvas() {
    if (LN.canvas && LN.canvas.parentNode) return LN.canvas;
    var root = $('cf-root'); if (!root) return null;
    var c = document.createElement('canvas');
    c.id = 'bp-lines';
    c.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;opacity:0;';
    var svg = $('bp-dims-svg');
    if (svg && svg.parentNode === root) root.insertBefore(c, svg); else root.appendChild(c);
    LN.canvas = c;
    return c;
  }
  /* the drawing on screen, for the camera on screen */
  function drawLines() {
    var c = lnCanvas(); if (!c) return;
    c.style.opacity = String(_ink / 100);
    if (_ink <= 0 || !_st || !_st.renderer || !_st.camera || !_st.group) return;
    var cv = _st.renderer.domElement, W = cv.width | 0, H = cv.height | 0;
    if (W < 16 || H < 16) return;
    var t0 = Date.now();
    try {
      var B = lnBuffers(_st.camera, W, H), t1 = Date.now();
      if (c.width !== W) c.width = W;
      if (c.height !== H) c.height = H;
      var ctx = c.getContext('2d'), img = ctx.createImageData(W, H);
      lnCompose(B, Math.max(1, W / Math.max(1, cv.clientWidth)), img.data);
      ctx.putImageData(img, 0, 0);
      LN.ms = Date.now() - t0;
      LN.note = 'lines ' + W + ' x ' + H + ' px, ' + LN.n + ' bodies, ' + LN.ms + ' ms (passes ' + (t1 - t0) + ', ink ' + (Date.now() - t1) + '), cut ' + (LN.uCap.value ? 'on' : 'off');
    } catch (e) { LN.note = 'lines THREW ' + ((e && e.message) || e); }
    if (LN.note !== LN.said) { LN.said = LN.note; log('ink     ' + LN.note); }
  }
  function refreshLines(ms) {
    if (LN.t) global.clearTimeout(LN.t);
    LN.t = global.setTimeout(function () { LN.t = 0; drawLines(); }, ms == null ? 60 : ms);
  }
  function applyInk() {
    var c = lnCanvas(); if (c) c.style.opacity = String(_ink / 100);
    if (_ink > 0 && !_pdfBusy && !_building && _mode === 'live') refreshLines();
  }
  /* the free view turns under the finger: the drawing follows when it stops */
  function watchControls() {
    var C = _st && _st.controls;
    if (!C || C.__bpWatch || !C.addEventListener) return;
    C.__bpWatch = true;
    C.addEventListener('change', function () { if (_ink > 0 && _view === 'free') refreshLines(200); });
  }
  function refreshCut() {
    /* the page's own section (v22) follows the layers by itself */
  }
  function bindInk() {
    var r = $('bp-ink'); if (!r) return;
    r.oninput = function () { _ink = parseInt(r.value, 10) || 0; applyInk(); };
    r.onchange = r.oninput;
  }
  function hideGrid() {
    /* and the page scrolls over the model: the canvas gives vertical touch
       back to the page, the stage's controls stay off outside the 3D view */
    try { var cv = $('cf-canvas'); if (cv) cv.style.touchAction = 'pan-y'; } catch (e0) {}
    try {
      if (_st && _st._gridHelper) _st._gridHelper.visible = false;
      if (_st && _st._gridAxes) _st._gridAxes.visible = false;
      if (_st && _st.scene) _st.scene.traverse(function (o) { if (o.isGridHelper || (o.type === 'GridHelper')) o.visible = false; });
    } catch (e) {}
  }
  function layerLabel(ly) {
    if (ly && ly.label) return ly.label;
    var s = String(ly && ly.id || '').replace(/^[a-z]+-/, '').replace(/-/g, ' ');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  /* THE LAYERS, ONE TAP EACH (blueprints-v19, Marek: jednoduche zapinani /
     vypinani vrstev a s nimi i kot). A row is the layer's name in the page's
     language and one pill that steps on -> dim -> off; a layer that carries
     dimensions has a ruler next to it that takes its dimensions off (and on)
     on its own. A layer switched off takes its dimensions with it. */
  var RULER = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M3 15.5 15.5 3 21 8.5 8.5 21z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>' +
              '<path d="M7 11.5l1.8 1.8M9.5 9l2.5 2.5M12 6.5l1.8 1.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  function buildLayers() {
    var host = $('bp-layers'); if (!host || !_lib) return;
    host.innerHTML = '';
    var pk = _lib.blueprintPackage ? _lib.blueprintPackage() : { layers: [] };
    var modes = _lib.layerModes ? _lib.layerModes() : {};
    var DL = dimLayers(), carry = {}, k;
    for (k in DL) if (DL.hasOwnProperty(k) && DL[k]) carry[DL[k]] = true;
    var NEXT = { on: 'dim', dim: 'off', off: 'on' }, FIT = fitoutLayers();
    pk.layers.forEach(function (ly) {
      if (FIT.indexOf(ly.id) >= 0) return;   /* v37: the furniture never on the drawings */
      var row = document.createElement('div');
      row.className = 'bp-layer';
      var mode = modes[ly.id] || 'on';
      var nm = document.createElement('span'); nm.className = 'bp-lname' + (mode === 'off' ? ' off' : '');
      nm.textContent = layerLabel(ly);
      var step = function () { _lib.setLayerMode(ly.id, NEXT[modes[ly.id] || 'on']); buildLayers(); refreshCut(); redraw(); };
      nm.onclick = step;
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'bp-pill ' + mode;
      pill.textContent = cap(L.modes[mode] || mode);
      pill.onclick = step;
      var ru = document.createElement('button');
      ru.type = 'button';
      if (carry[ly.id]) {
        ru.className = 'bp-ruler' + ((_dimsLayer[ly.id] !== false && mode !== 'off') ? ' on' : '');
        ru.innerHTML = RULER;
        ru.onclick = function () { _dimsLayer[ly.id] = (_dimsLayer[ly.id] === false); buildLayers(); redraw(); };
      } else { ru.className = 'bp-ruler none'; }
      row.appendChild(nm); row.appendChild(pill); row.appendChild(ru);
      host.appendChild(row);
    });
  }
  function buildDims() {
    var host = $('bp-dims'); if (!host) return;
    host.innerHTML = '';
    var b = document.createElement('button');
    b.className = 'bp-btn' + (_dimsOn ? ' on' : '');
    b.textContent = L.dims.auto || 'Dimensions';
    b.onclick = function () { _dimsOn = !_dimsOn; buildDims(); if (_st && _lib) setView(_view); };
    host.appendChild(b);
    ['corner', 'walls'].forEach(function (m) {
      var c = document.createElement('button');
      c.className = 'bp-btn' + (_dimsMode === m ? ' on' : '');
      c.textContent = L.dims[m] || m;
      c.onclick = function () { _dimsMode = m; buildDims(); redraw(); };
      host.appendChild(c);
    });
  }

  /* =========================================================================
     THE DIMENSIONS (blueprints-v19)

     Read from the lib's dimAnchors() -- the outline, the openings, the
     partitions, the floor, the wall top and the roof -- so the page never
     measures the model itself, and drawn as SVG over the canvas through the
     square-on camera of the view. Every view with an orthographic camera
     gets them: the plan and section Y from above, the four elevations, the
     sections X and Z. The isometric and the free 3D get none.

     THE RULES (Marek: koty nesmi kolidovat, vzdy celkova kota a v jine
     linii vazane koty):
     - a side's strings stand outside everything drawn on that side, one
       line each, outward: the CHAINED string first (corners and the
       openings between them), the OVERALL string outermost. A side with
       nothing between its corners has no chain; every direction always has
       an overall.
     - a number stands centred above its line when it fits between its two
       ticks; one that does not is lifted out to a row of its own on the
       outer side with a short leader, rows taken first-free so no two
       numbers meet, and the next string is pushed out by the rows taken.
     - the view is framed again so the strings fit on the canvas under the
       bar of views.
     - each point belongs to a layer (corners -> the wall frame, openings ->
       windows & doors, partitions, floor, roof): a layer switched off, or
       its ruler off, takes its points out of every string.
     - openings and partitions: to their edges / faces in a metric drawing,
       to their centres in an inch drawing (the US framing habit).
     - "From the corner" = the strings outside; "Per wall" adds a string
       inside across the rooms through the partitions.
     ========================================================================= */
  var DS = { gap0: 30, gap: 26, tick: 4.5, over: 5, extGap: 5, extOver: 5, font: 12, rowH: 16, pad: 10, u: 1, tw: function (t) { return textW(t); } };
  var _dimsLayer = {};   /* layer id -> false when its dimensions are off */
  var _dimNote = '', _dimNoteSaid = '';
  var _mctx = null;
  function textW(s) {
    try {
      if (!_mctx) _mctx = document.createElement('canvas').getContext('2d');
      _mctx.font = '600 ' + DS.font + 'px Montserrat, sans-serif';
      return _mctx.measureText(s).width;
    } catch (e) { return s.length * DS.font * 0.62; }
  }
  function isMetric() { return !!(_lib && _lib.STATE && _lib.STATE.isMetric); }
  /* mm with no unit in a metric drawing; feet-inches-sixteenths, the
     configurator's own format, in an inch drawing */
  function fmtD(m) {
    if (isMetric()) return String(Math.round(m * 1000));
    var U = global.ConfiguratorUI;
    if (U && U.fmtDim) return U.fmtDim(m, false);
    return (Math.round(m / 0.0254 * 16) / 16) + '"';
  }
  /* which layer each kind of point belongs to: by role first, by name after */
  function dimLayers() {
    var pk = null; try { pk = _lib && _lib.blueprintPackage ? _lib.blueprintPackage() : null; } catch (e) { pk = null; }
    var Ls = (pk && pk.layers) || [], M = { wall: null, open: null, part: null, roof: null, floor: null }, i, id, r;
    for (i = 0; i < Ls.length; i++) { id = Ls[i].id; if (!M.wall && /stud-wall|frame/.test(id)) M.wall = id; }
    for (i = 0; i < Ls.length; i++) {
      id = Ls[i].id; r = Ls[i].role || '';
      if (!M.wall && r === 'nosna' && /wall/.test(id)) M.wall = id;
      if (!M.open && (r === 'otvory' || /joinery|opening/.test(id))) M.open = id;
      if (!M.part && (r === 'pricky' || /partition/.test(id))) M.part = id;
      if (!M.roof && (r === 'strecha' || /roof/.test(id))) M.roof = id;
      if (!M.floor && /floor/.test(id) && !/floorplan/.test(id)) M.floor = id;
    }
    return M;
  }
  function layerShows(id) {
    if (!id) return true;
    var modes = (_lib && _lib.layerModes) ? _lib.layerModes() : {};
    return (modes[id] || 'on') !== 'off' && _dimsLayer[id] !== false;
  }
  /* the square-on camera as a frame: u to the right, v up, in metres */
  function camFrame() {
    var cam = _st && _st.camera, cv = _st && _st.renderer && _st.renderer.domElement;
    if (!cam || !cam.isOrthographicCamera || !cv) return null;
    cam.updateMatrixWorld(true);
    var e = cam.matrixWorld.elements;
    var R = [e[0], e[1], e[2]], U = [e[4], e[5], e[6]], P = [e[12], e[13], e[14]], D = [-e[8], -e[9], -e[10]];
    var W = cv.clientWidth || 1, H = cv.clientHeight || 1;
    var z = cam.zoom || 1, dx = (cam.right - cam.left) / (2 * z), dy = (cam.top - cam.bottom) / (2 * z);
    var cx = (cam.right + cam.left) / 2, cy = (cam.top + cam.bottom) / 2;
    var pr = R[0] * P[0] + R[1] * P[1] + R[2] * P[2], pu = U[0] * P[0] + U[1] * P[1] + U[2] * P[2];
    return {
      cam: cam, R: R, U: U, D: D, W: W, H: H, ppm: W / (2 * dx), pr: pr, pu: pu,
      uv: function (x, y, zz) { return [R[0] * x + R[1] * y + R[2] * zz, U[0] * x + U[1] * y + U[2] * zz]; },
      px: function (u, v) { return [((u - pr - cx) / dx + 1) / 2 * W, (1 - (v - pu - cy) / dy) / 2 * H]; }
    };
  }
  function visibleUp(o) {
    while (o) { if (o.visible === false) return false; if (o === _st.group) return true; o = o.parent; }
    return true;
  }
  /* WHAT IS DRAWN, as a box in the view's u / v: every visible body, cut
     back to the kept side of the section (the plan's roof is not in it) */
  function visibleBox(F) {
    var T = global.THREE, mb = new T.Box3(), b0 = new T.Box3();
    var bands = SEC.on ? SEC.bands : [null], bi;
    var out = { u0: 1e9, u1: -1e9, v0: 1e9, v1: -1e9, n: 0 }, i, k;
    _st.group.traverse(function (o) {
      if (!o.isMesh || !o.geometry || (o.userData && o.userData.isEdge)) return;
      if (!visibleUp(o)) return;
      if (!o.geometry.boundingBox) { try { o.geometry.computeBoundingBox(); } catch (e) { return; } }
      if (!o.geometry.boundingBox) return;
      b0.copy(o.geometry.boundingBox).applyMatrix4(o.matrixWorld);
      if (!isFinite(b0.min.x) || !isFinite(b0.max.x)) return;
      /* each band of the section keeps its own part of the body */
      for (bi = 0; bi < bands.length; bi++) {
        mb.copy(b0);
        var B = bands[bi];
        for (i = 0; B && i < 3; i++) {
          var n = B[i], d = n[3];
          /* the planes are square to an axis: keep n.p + d >= 0 */
          if (n[0] < -0.9) mb.max.x = Math.min(mb.max.x, d); else if (n[0] > 0.9) mb.min.x = Math.max(mb.min.x, -d);
          if (n[1] < -0.9) mb.max.y = Math.min(mb.max.y, d); else if (n[1] > 0.9) mb.min.y = Math.max(mb.min.y, -d);
          if (n[2] < -0.9) mb.max.z = Math.min(mb.max.z, d); else if (n[2] > 0.9) mb.min.z = Math.max(mb.min.z, -d);
        }
        if (mb.min.x > mb.max.x || mb.min.y > mb.max.y || mb.min.z > mb.max.z) continue;
        for (k = 0; k < 8; k++) {
          var q = F.uv(k & 1 ? mb.max.x : mb.min.x, k & 2 ? mb.max.y : mb.min.y, k & 4 ? mb.max.z : mb.min.z);
          if (q[0] < out.u0) out.u0 = q[0]; if (q[0] > out.u1) out.u1 = q[0];
          if (q[1] < out.v0) out.v0 = q[1]; if (q[1] > out.v1) out.v1 = q[1];
        }
        out.n++;
      }
    });
    if (out.n && /^plan/.test(_view) && !_roomsMode) {   /* v47: the room plan draws no section lines */
      /* the section lines and their arrows and letters are part of the plan:
         the dimension strings stand outside them */
      try {
        var A0 = anchors(), R0 = A0 && A0.rect;
        if (R0) ['x', 'z'].forEach(function (kind) {
          var pts = secPolyline(kind, R0); if (!pts) return;
          /* v28: what the marks really take -- the line's end, the arrow
             sideways, the letter just beyond the end -- not a square
             round each end (that pushed the strings a metre out) */
          var dir = (kind === 'x') ? [-1, 0] : [0, -1];
          [pts[0], pts[pts.length - 1]].forEach(function (e, ei) {
            var al = (kind === 'x') ? [0, ei ? 1 : -1] : [ei ? 1 : -1, 0];
            var lc = [e[0] + dir[0] * SEC_ARROW * 0.5 + al[0] * 0.35, e[1] + dir[1] * SEC_ARROW * 0.5 + al[1] * 0.35];
            [e, [e[0] + dir[0] * SEC_ARROW, e[1] + dir[1] * SEC_ARROW], [lc[0] + 0.25, lc[1] + 0.25], [lc[0] - 0.25, lc[1] - 0.25]].forEach(function (w) {
              var q = F.uv(w[0], 0, w[1]);
              if (q[0] < out.u0) out.u0 = q[0]; if (q[0] > out.u1) out.u1 = q[0];
              if (q[1] < out.v0) out.v0 = q[1]; if (q[1] > out.v1) out.v1 = q[1];
            });
          });
        });
      } catch (eSB) {}
    }
    return out.n ? out : null;
  }
  /* A STRING: run 'u' (across the screen) or 'v' (up it); side names the
     group it stacks in; out is +1 / -1 along the perpendicular, away from
     the building; pts are { c: along the run, f: the perpendicular place of
     the thing measured (the extension line starts there) or null }. */
  function pushStr(list, side, run, out, tier, pts, inner) {
    var P = pts.filter(function (p) { return p && isFinite(p.c) && layerShows(p.L); })
               .sort(function (a, b) { return a.c - b.c; }), Q = [], i;
    for (i = 0; i < P.length; i++) {
      if (!Q.length || P[i].c - Q[Q.length - 1].c > 0.005) { Q.push(P[i]); continue; }
      /* v28: two points in one place -- the extension line from the nearer thing */
      var qL = Q[Q.length - 1];
      if (P[i].f != null && (qL.f == null || (out < 0 ? P[i].f < qL.f : P[i].f > qL.f))) Q[Q.length - 1] = { c: qL.c, f: P[i].f, L: qL.L };
    }
    if (Q.length < 2) return;
    list.push({ side: side, run: run, out: out, tier: tier, pts: Q, inner: (typeof inner === 'number') ? inner : null });
  }
  function sameStr(a, b) {
    if (!a || !b || a.pts.length !== b.pts.length) return false;
    for (var i = 0; i < a.pts.length; i++) if (Math.abs(a.pts[i].c - b.pts[i].c) > 0.005) return false;
    return true;
  }
  /* the strings of one view, in the view's u / v */
  function viewStrings(F, A, M) {
    var list = [], R = A.rect, wt = A.wallThk || 0, metric = isMetric(), i;
    var pt = 0.1; try { pt = (_lib.partThickness && _lib.partThickness()) || 0.1; } catch (ePT) { pt = 0.1; }
    var D = F.D;
    /* the four faces of the outline, by their outward normal */
    var SIDES = [
      { key: 'z0', n: [0, 0, -1], along: 'x', at: R.z0, a: R.x0, b: R.x1 },
      { key: 'z1', n: [0, 0, 1], along: 'x', at: R.z1, a: R.x0, b: R.x1 },
      { key: 'x0', n: [-1, 0, 0], along: 'z', at: R.x0, a: R.z0, b: R.z1 },
      { key: 'x1', n: [1, 0, 0], along: 'z', at: R.x1, a: R.z0, b: R.z1 }
    ];
    function onSide(o, S) {
      if (o.along !== S.along) return false;
      /* v25: by the way its wall faces (a T's set-back wall is a front too) */
      if (typeof o.nx === 'number') return o.nx * S.n[0] + o.nz * S.n[2] > 0.7;
      return S.along === 'x' ? Math.abs(o.z - S.at) < 0.35 : Math.abs(o.x - S.at) < 0.35;
    }
    function opPts(S, toC) {
      var P = [], j;
      for (j = 0; j < (A.openings || []).length; j++) {
        var o = A.openings[j]; if (!onSide(o, S)) continue;
        var c = S.along === 'x' ? o.x : o.z;
        if (metric) { P.push(toC(c - o.w / 2, o)); P.push(toC(c + o.w / 2, o)); } else P.push(toC(c, o));
      }
      return P;
    }
    /* v25: the corners a side sees -- both ends of every outside wall that
       faces it; a box gives its two corners, a T's front its four */
    function facing(S) {
      var P = [], j;
      if (!A.edges) return [{ x: S.along === 'x' ? S.a : S.at, z: S.along === 'x' ? S.at : S.a }, { x: S.along === 'x' ? S.b : S.at, z: S.along === 'x' ? S.at : S.b }];
      for (j = 0; j < A.edges.length; j++) {
        var e = A.edges[j]; if (e.nx * S.n[0] + e.nz * S.n[2] <= 0.7) continue;
        P.push({ x: e.x0, z: e.z0 }, { x: e.x1, z: e.z1 });
      }
      return P;
    }
    function w3(S, s, y) { return S.along === 'x' ? [s, y, S.at] : [S.at, y, s]; }
    var top = F.U[1] > 0.9, lookY = Math.abs(D[1]) > 0.9;
    var Y0 = 0, FL = (typeof A.floor === 'number') ? A.floor : 0, WT = A.wallTop || 0, RT = (A.roof && isFinite(A.roof.top)) ? A.roof.top : null;
    if (lookY) {
      /* ---- THE PLAN (and section Y): the four sides of the outline ---- */
      var hasOverall = { u: false, v: false }, ovBest = { u: null, v: null };
      for (i = 0; i < SIDES.length; i++) {
        var S = SIDES[i];
        var nUV = F.uv(S.n[0], S.n[1], S.n[2]), run = Math.abs(nUV[0]) > 0.7 ? 'v' : 'u', out = (run === 'u') ? (nUV[1] > 0 ? 1 : -1) : (nUV[0] > 0 ? 1 : -1);
        var faceP = F.uv.apply(null, w3(S, S.a, Y0)), f = (run === 'u') ? faceP[1] : faceP[0];
        var toC = function (s) { var q = F.uv.apply(null, w3(S, s, Y0)); return (run === 'u') ? q[0] : q[1]; };
        /* a point of the plan by its own place: its extension line starts at
           its own wall, a set-back one further in (v25) */
        var at3 = function (x, z, L) { var q = F.uv(x, Y0, z); return (run === 'u') ? { c: q[0], f: q[1], L: L } : { c: q[1], f: q[0], L: L }; };
        var corners = facing(S).map(function (p) { return at3(p.x, p.z, M.wall); });
        if (!corners.length) continue;
        var cMin = corners[0], cMax = corners[0], kq;
        for (kq = 1; kq < corners.length; kq++) { if (corners[kq].c < cMin.c) cMin = corners[kq]; if (corners[kq].c > cMax.c) cMax = corners[kq]; }
        var ops = opPts(S, function (s, o) { return S.along === 'x' ? at3(s, o.z, M.open) : at3(o.x, s, M.open); });
        var jogs = corners.filter(function (p, k7) { return corners.findIndex(function (p2) { return Math.abs(p2.c - p.c) < 0.005; }) === k7; }).length > 2;
        var before = list.length;
        if (ops.length || jogs) pushStr(list, S.key, run, out, 1, corners.concat(ops));
        var chained = list.length > before;
        /* v28: ONE OVERALL EACH WAY, beside the busiest chain -- the overall
           on every side spread the strings so far the plan itself came out
           small (Marek: optimalizovat umisteni kot) */
        if (chained && layerShows(M.wall)) {
          var npts = list[list.length - 1].pts.length;
          if (!ovBest[run] || npts > ovBest[run].n) ovBest[run] = { n: npts, key: S.key, out: out, pts: [cMin, cMax] };
        }
      }
      ['u', 'v'].forEach(function (rn) { var ob = ovBest[rn]; if (ob) { pushStr(list, ob.key, rn, ob.out, 3, ob.pts); hasOverall[rn] = true; } });
      /* every direction has its overall: under the plan and left of it */
      if (layerShows(M.wall)) {
        var bot = null, lef = null;
        for (i = 0; i < SIDES.length; i++) {
          var nn = F.uv(SIDES[i].n[0], SIDES[i].n[1], SIDES[i].n[2]);
          if (Math.abs(nn[1]) > 0.7 && nn[1] < 0) bot = SIDES[i];
          if (Math.abs(nn[0]) > 0.7 && nn[0] < 0) lef = SIDES[i];
        }
        [[bot, 'u', -1], [lef, 'v', -1]].forEach(function (e) {
          var S2 = e[0]; if (!S2 || hasOverall[e[1]]) return;
          var q0 = F.uv.apply(null, w3(S2, S2.a, Y0)), q1 = F.uv.apply(null, w3(S2, S2.b, Y0)), ix = e[1] === 'u' ? 0 : 1, fx = e[1] === 'u' ? 1 : 0;
          pushStr(list, S2.key, e[1], e[2], 3, [{ c: q0[ix], f: q0[fx], L: M.wall }, { c: q1[ix], f: q1[fx], L: M.wall }]);
        });
      }
      /* ---- PER WALL: one string across the rooms each way ---- */
      if (_dimsMode === 'walls' && layerShows(M.part)) {
        var PA = A.partitions || [];
        ['v', 'h'].forEach(function (dir) {
          /* dir v = walls running along z at x = at: the string runs along x */
          var lo = (dir === 'v') ? R.x0 + wt : R.z0 + wt, hi = (dir === 'v') ? R.x1 - wt : R.z1 - wt;
          var cross = [], k2;
          /* THE STRING'S LINE runs inside a room close to its wall, not through
             the middle of the rooms, where it would cross the other string's
             numbers: 0.6 m in from each wall of every room band the other way,
             the place that crosses the most partitions winning, the nearest to
             the outline on a tie */
          var e0 = (dir === 'v') ? R.z0 + wt : R.x0 + wt, e1 = (dir === 'v') ? R.z1 - wt : R.x1 - wt;
          var bands = [e0, e1];
          for (k2 = 0; k2 < PA.length; k2++) if (PA[k2].dir !== dir) bands.push(PA[k2].at);
          bands.sort(function (a, b) { return a - b; });
          var cands = [], best = null;
          for (k2 = 1; k2 < bands.length; k2++) {
            var bw = bands[k2] - bands[k2 - 1], inset = Math.min(0.6, bw / 2);
            if (bw < 0.3) continue;
            cands.push(bands[k2 - 1] + inset, bands[k2] - inset);
          }
          function crosses(ln) {
            var n = 0;
            for (var q = 0; q < PA.length; q++) { var pp = PA[q]; if (pp.dir === dir && ln >= Math.min(pp.a, pp.b) - 0.01 && ln <= Math.max(pp.a, pp.b) + 0.01) n++; }
            return n;
          }
          for (k2 = 0; k2 < cands.length; k2++) {
            var cn = crosses(cands[k2]), cd = Math.min(cands[k2] - e0, e1 - cands[k2]);
            if (!best || cn > best.n || (cn === best.n && cd < best.d - 1e-6)) best = { at: cands[k2], n: cn, d: cd };
          }
          if (!best || !best.n) return;
          var line = best.at;
          for (k2 = 0; k2 < PA.length; k2++) {
            var p = PA[k2]; if (p.dir !== dir) continue;
            if (line < Math.min(p.a, p.b) - 0.01 || line > Math.max(p.a, p.b) + 0.01) continue;
            /* a partition by its faces in a metric drawing, by its centre in an inch one */
            if (metric) cross.push(p.at - pt / 2, p.at + pt / 2); else cross.push(p.at);
          }
          if (!cross.length) return;
          var W3 = function (s) { return dir === 'v' ? F.uv(s, Y0, line) : F.uv(line, Y0, s); };
          var lq = W3(lo), hq = W3(hi), runI = Math.abs(hq[0] - lq[0]) > Math.abs(hq[1] - lq[1]) ? 'u' : 'v', ix2 = runI === 'u' ? 0 : 1, fx2 = runI === 'u' ? 1 : 0;
          var pts = [{ c: lq[ix2], f: null, L: M.part }, { c: hq[ix2], f: null, L: M.part }];
          for (k2 = 0; k2 < cross.length; k2++) pts.push({ c: W3(cross[k2])[ix2], f: null, L: M.part });
          pushStr(list, 'in-' + dir, runI, 1, 1, pts, lq[fx2]);
        });
      }
      return list;
    }
    /* ---- AN ELEVATION OR A SECTION: the face across, the heights up ---- */
    var secAx = (SEC.on && (SEC.kind === 'x' || SEC.kind === 'z')) ? SEC.kind : null;
    /* the face that looks at the camera */
    var face = null;
    for (i = 0; i < SIDES.length; i++) {
      var Sn = SIDES[i].n;
      if (Sn[0] * D[0] + Sn[1] * D[1] + Sn[2] * D[2] < -0.7) face = SIDES[i];
    }
    if (!face) return list;
    var g0 = F.uv(face.along === 'x' ? R.x0 : face.at, Y0, face.along === 'x' ? face.at : R.z0)[1];
    var hvE = function (y) { return F.uv(0, y, 0)[1]; };
    var tc = function (s) { return F.uv.apply(null, w3(face, s, Y0))[0]; };
    var crn = [{ c: tc(face.a), f: g0, L: M.wall }, { c: tc(face.b), f: g0, L: M.wall }];
    /* v25: the corners of every wall facing the camera, a T's set-back
       corners too; the overall stays the whole width */
    var crnAll = facing(face).map(function (p) { return { c: tc(face.along === 'x' ? p.x : p.z), f: g0, L: M.wall }; });
    if (crnAll.length) {
      var lo7 = crnAll[0], hi7 = crnAll[0];
      crnAll.forEach(function (p) { if (p.c < lo7.c) lo7 = p; if (p.c > hi7.c) hi7 = p; });
      crn = [lo7, hi7];
    } else crnAll = crn;
    var jogs2 = crnAll.filter(function (p, k7) { return crnAll.findIndex(function (p2) { return Math.abs(p2.c - p.c) < 0.005; }) === k7; }).length > 2;
    /* v25: a section measures the outside walls its line passes through --
       through a T's wing that is the wing's front, beside it the body's */
    if (secAx && A.edges) {
      var cw = [];
      A.edges.forEach(function (e) {
        var alongX = Math.abs(e.nz) > 0.7;
        var q7 = alongX ? { dir: 'h', at: e.z0, a: e.x0, b: e.x1 } : { dir: 'v', at: e.x0, a: e.z0, b: e.z1 };
        if (secCuts(q7, face.along)) cw.push({ c: tc(q7.at), f: g0, L: M.wall });
      });
      if (cw.length >= 2) {
        var lo8 = cw[0], hi8 = cw[0];
        cw.forEach(function (p) { if (p.c < lo8.c) lo8 = p; if (p.c > hi8.c) hi8 = p; });
        crn = [lo8, hi8]; crnAll = cw;
      }
    }
    if (secAx) {
      /* a section: the walls and partitions the cut passes through */
      var cuts = [], PA2 = A.partitions || [], k3;
      for (k3 = 0; k3 < PA2.length; k3++) {
        var q2 = PA2[k3];
        /* a partition runs along x when dir is h (at = its z) */
        if (!secCuts(q2, face.along)) continue;
        cuts.push({ c: tc(q2.at - pt / 2), f: hvE(FL), L: M.part }, { c: tc(q2.at + pt / 2), f: hvE(FL), L: M.part });
      }
      if (cuts.length || crnAll.length > 2) pushStr(list, 'bot', 'u', -1, 1, crnAll.concat(cuts));
    } else {
      /* v28: an opening's extension line reaches the opening, from its foot */
      var ops2 = opPts(face, function (s, o) { var fy0 = (typeof o.fy === 'number') ? o.fy : FL; return { c: tc(s), f: hvE(fy0 + (o.sill || 0)), L: M.open }; });
      if (ops2.length || jogs2) pushStr(list, 'bot', 'u', -1, 1, crnAll.concat(ops2));
    }
    if (layerShows(M.wall)) pushStr(list, 'bot', 'u', -1, 3, crn);
    /* the heights, left of the drawing: openings, then the levels, then the whole */
    var hv = hvE;
    /* v28 (Marek: odkazove cary kot az k objektum): every height's extension
       line starts at what it measures -- the building's near edge for a
       level, an opening's near side for its sill and head, the ridge where
       the roof's top is */
    var U0 = Math.min(crn[0].c, crn[1].c), ridgeU = U0;
    try {
      var RPs = _lib.roofPlanes ? _lib.roofPlanes() : [], bestU = null;
      RPs.forEach(function (pl) { (pl.pts || []).forEach(function (q) { if (RT != null && q[1] >= RT - 0.03) { var uq = F.uv(q[0], q[1], q[2])[0]; if (bestU == null || uq < bestU) bestU = uq; } }); });
      if (bestU != null) ridgeU = Math.max(U0, bestU);
    } catch (eRU) {}
    if (!secAx) {
      var H1 = [{ c: hv(FL), f: U0, L: M.floor }, { c: hv(WT), f: U0, L: M.wall }], k4, nOp = 0;
      for (k4 = 0; k4 < (A.openings || []).length; k4++) {
        var o4 = A.openings[k4]; if (!onSide(o4, face)) continue;
        nOp++;
        /* v24: an opening upstairs stands on its own floor */
        var fy4 = (typeof o4.fy === 'number') ? o4.fy : FL, cc4 = (o4.along === 'x') ? o4.x : o4.z;
        var uL = Math.min(tc(cc4 - o4.w / 2), tc(cc4 + o4.w / 2));
        if (fy4 > FL + 0.01) H1.push({ c: hv(fy4), f: U0, L: M.floor });
        if ((o4.sill || 0) > 0.01) H1.push({ c: hv(fy4 + o4.sill), f: uL, L: M.open });
        H1.push({ c: hv(fy4 + (o4.sill || 0) + o4.h), f: uL, L: M.open });
      }
      if (nOp) pushStr(list, 'lef', 'v', -1, 1, H1);
    }
    var H2 = [{ c: hv(Y0), f: U0, L: M.wall }, { c: hv(FL), f: U0, L: M.floor }, { c: hv(WT), f: U0, L: M.wall }];
    /* v24: every upper floor is a level too */
    (A.levels || []).forEach(function (y, k5) { if (k5 > 0 && y > FL + 0.01 && y < WT - 0.01) H2.push({ c: hv(y), f: U0, L: M.floor }); });
    if (RT != null) H2.push({ c: hv(RT), f: ridgeU, L: M.roof });
    pushStr(list, 'lef', 'v', -1, 2, H2);
    var H3 = [{ c: hv(Y0), f: U0, L: M.wall }, { c: hv(RT != null && layerShows(M.roof) ? RT : WT), f: (RT != null && layerShows(M.roof)) ? ridgeU : U0, L: M.wall }];
    pushStr(list, 'lef', 'v', -1, 3, H3);
    return list;
  }
  /* LAY THE STRINGS OUT in screen pixels: lines, ticks, extension lines and
     numbers, stacked per side; returns the primitives and their extent */
  function layout(F, list, VB, ST) {
    ST = ST || DS;
    var U1 = ST.u || 1;
    var prims = [], ext = { x0: 1e9, x1: -1e9, y0: 1e9, y1: -1e9 }, overflow = 0, i, j;
    function grow(x, y) { if (x < ext.x0) ext.x0 = x; if (x > ext.x1) ext.x1 = x; if (y < ext.y0) ext.y0 = y; if (y > ext.y1) ext.y1 = y; }
    function P(run, c, perp) { return run === 'u' ? F.px(c, perp) : F.px(perp, c); }
    /* drop a chain the same as the overall beside it */
    var bySide = {};
    for (i = 0; i < list.length; i++) (bySide[list[i].side] = bySide[list[i].side] || []).push(list[i]);
    var occ = [];   /* every number placed, and the lines of the strings inside, as screen boxes */
    function hits(r, own, numbersOnly) {
      for (var q = 0; q < occ.length; q++) {
        var o = occ[q]; if (own != null && o.own === own) continue;
        if (numbersOnly && o.line) continue;
        if (r.x0 < o.x1 && r.x1 > o.x0 && r.y0 < o.y1 && r.y1 > o.y0) return true;
      }
      return false;
    }
    function boxAt(x, y, run, tw) {
      var a = tw / 2 + 2 * U1, c = ST.font * 0.6;
      return run === 'u' ? { x0: x - a, x1: x + a, y0: y - c, y1: y + c } : { x0: x - c, x1: x + c, y0: y - a, y1: y + a };
    }
    var sideKeys = Object.keys(bySide).sort(function (a, b) { return (/^in-/.test(a) ? 1 : 0) - (/^in-/.test(b) ? 1 : 0); });
    /* the lines of the strings inside are obstacles for each other's numbers */
    sideKeys.forEach(function (sk) {
      bySide[sk].forEach(function (S0) {
        if (S0.inner == null) return;
        var e0 = P(S0.run, S0.pts[0].c, S0.inner), e1 = P(S0.run, S0.pts[S0.pts.length - 1].c, S0.inner);
        occ.push({ x0: Math.min(e0[0], e1[0]) - 2 * U1, x1: Math.max(e0[0], e1[0]) + 2 * U1, y0: Math.min(e0[1], e1[1]) - 2 * U1, y1: Math.max(e0[1], e1[1]) + 2 * U1, own: sk, line: true });
      });
    });
    sideKeys.forEach(function (sk) {
      var G = bySide[sk].sort(function (a, b) { return a.tier - b.tier; }), keep = [];
      /* where two strings are the same, the outer (the overall) is the one kept */
      for (j = 0; j < G.length; j++) {
        if (keep.length && sameStr(keep[keep.length - 1], G[j])) keep[keep.length - 1] = G[j];
        else keep.push(G[j]);
      }
      var run = keep.length ? keep[0].run : 'u', out = keep.length ? keep[0].out : 1;
      /* the base: outside everything drawn on this side */
      var base = run === 'u' ? (out > 0 ? VB.v1 : VB.v0) : (out > 0 ? VB.u1 : VB.u0);
      var dist = ST.gap0;   /* pixels out from the base to the string's line */
      for (j = 0; j < keep.length; j++) {
        var S = keep[j], inner = S.inner != null;
        var lineM = inner ? S.inner : base + S.out * dist / F.ppm;
        var a0 = P(run, S.pts[0].c, lineM), a1 = P(run, S.pts[S.pts.length - 1].c, lineM);
        /* screen directions: along the run, out from the building, the text's side */
        var dirR = run === 'u' ? [1, 0] : [0, -1];
        var nOut = run === 'u' ? [0, -S.out] : [S.out, 0];
        var nTxt = run === 'u' ? [0, -1] : [-1, 0];
        var txtOuter = (nTxt[0] * nOut[0] + nTxt[1] * nOut[1]) > 0;
        var lp = function (c) { return P(run, c, lineM); };
        /* the line, a little past the end ticks */
        prims.push({ t: 'l', a: [a0[0] - dirR[0] * ST.over, a0[1] - dirR[1] * ST.over], b: [a1[0] + dirR[0] * ST.over, a1[1] + dirR[1] * ST.over], w: 1, s: 'dim' });
        grow(a0[0] - dirR[0] * ST.over, a0[1] - dirR[1] * ST.over); grow(a1[0] + dirR[0] * ST.over, a1[1] + dirR[1] * ST.over);
        var slots = [], used = 0, k;
        for (k = 0; k < S.pts.length; k++) {
          var p = S.pts[k], q = lp(p.c);
          /* the tick: a slash across the line */
          prims.push({ t: 'l', a: [q[0] - ST.tick, q[1] + ST.tick], b: [q[0] + ST.tick, q[1] - ST.tick], w: 1.6, s: 'tick' });
          if (!inner) {
            /* the extension line, from the thing measured past the line */
            var fromPx;
            if (p.f != null) { var fq = P(run, p.c, p.f); fromPx = [fq[0] + nOut[0] * ST.extGap, fq[1] + nOut[1] * ST.extGap]; }
            else fromPx = [q[0] - nOut[0] * 9 * U1, q[1] - nOut[1] * 9 * U1];
            prims.push({ t: 'l', a: fromPx, b: [q[0] + nOut[0] * ST.extOver, q[1] + nOut[1] * ST.extOver], w: 0.8, s: 'ext' });
          }
        }
        for (k = 0; k + 1 < S.pts.length; k++) {
          var c0 = S.pts[k].c, c1 = S.pts[k + 1].c, len = c1 - c0;
          var txt = fmtD(len), tw = ST.tw(txt) + 6 * U1, segPx = len * F.ppm, mid = lp((c0 + c1) / 2);
          var along = run === 'u' ? mid[0] : mid[1];
          var base0 = 3 * U1 + ST.font * 0.5;
          if (tw <= segPx - 4 * U1) {
            /* centred over its line; slid along its own segment when something
               is already there (the strings inside cross each other) */
            var slack = (segPx - tw) / 2 - 2 * U1, tries = [0, 0.5, -0.5, 1, -1], placed = false, ti;
            for (ti = 0; ti < tries.length && !placed; ti++) {
              var sh = tries[ti] * slack;
              var tx = mid[0] + nTxt[0] * base0 + dirR[0] * sh, ty = mid[1] + nTxt[1] * base0 + dirR[1] * sh;
              var bx0 = boxAt(tx, ty, run, tw - 6 * U1);
              if (hits(bx0, sk)) continue;
              occ.push({ x0: bx0.x0, x1: bx0.x1, y0: bx0.y0, y1: bx0.y1, own: sk });
              prims.push({ t: 't', s: txt, x: tx, y: ty, rot: run === 'v' });
              grow(mid[0] + nTxt[0] * (base0 + ST.font), mid[1] + nTxt[1] * (base0 + ST.font));
              placed = true;
            }
            if (placed) continue;
          }
          /* it does not fit: the first free row out from the line */
          overflow++;
          var r = 0, half = tw / 2 + 3 * U1, free, off, lx, ly;
          for (;;) {
            free = true;
            var row = slots[r] || [];
            for (var z = 0; z < row.length; z++) if (along + half > row[z][0] && along - half < row[z][1]) { free = false; break; }
            off = base0 + (r + (txtOuter ? 1 : 0)) * ST.rowH;
            lx = mid[0] + nOut[0] * off; ly = mid[1] + nOut[1] * off;
            if (free && r < 3 && hits(boxAt(lx, ly, run, tw - 6 * U1), sk, true)) free = false;
            if (free) break;
            r++;
          }
          (slots[r] = slots[r] || []).push([along - half, along + half]);
          var bl = boxAt(lx, ly, run, tw - 6 * U1); bl.own = sk; occ.push(bl);
          if (r + 1 > used) used = r + 1;
          prims.push({ t: 'l', a: [mid[0], mid[1]], b: [lx - nOut[0] * ST.font * 0.55, ly - nOut[1] * ST.font * 0.55], w: 0.7, s: 'lead' });
          prims.push({ t: 't', s: txt, x: lx, y: ly, rot: run === 'v' });
          grow(lx + nOut[0] * ST.font, ly + nOut[1] * ST.font);
          grow(lx + dirR[0] * half, ly + dirR[1] * half); grow(lx - dirR[0] * half, ly - dirR[1] * half);
        }
        if (!inner) dist += ST.gap + used * ST.rowH;
        S.rows = used;
      }
      bySide[sk] = keep;
    });
    var kept = [];
    Object.keys(bySide).forEach(function (sk) { kept = kept.concat(bySide[sk]); });
    return { prims: prims, ext: ext, overflow: overflow, strings: kept };
  }
  /* FRAMED FOR THE STRINGS: the drawing and its dimensions fitted into the
     canvas under the bar of views, centred, the scale the same both ways */
  function fitTo(F, VB, ext) {
    var cam = F.cam, bar = $('bp-views'), cv = _st.renderer.domElement;
    var top = 8;
    try { var br = bar.getBoundingClientRect(), cr = cv.getBoundingClientRect(); top = Math.max(8, br.bottom - cr.top + 10); } catch (e) {}
    var mb = F.px(VB.u0, VB.v1), mt = F.px(VB.u1, VB.v0);
    var x0 = Math.min(ext.x0, mb[0]), x1 = Math.max(ext.x1, mt[0]), y0 = Math.min(ext.y0, mb[1]), y1 = Math.max(ext.y1, mt[1]);
    var needW = (x1 - x0) / F.ppm, needH = (y1 - y0) / F.ppm;
    var availW = F.W - 2 * DS.pad, availH = F.H - top - DS.pad;
    if (!(needW > 0) || !(needH > 0) || availW < 50 || availH < 50) return false;
    var ppm = Math.min(availW / needW, availH / needH);
    /* the centre of what has to fit, in u / v, onto the centre of the room */
    var cxPx = (x0 + x1) / 2, cyPx = (y0 + y1) / 2;
    var cu = (cxPx / F.W * 2 - 1) * ((cam.right - cam.left) / (2 * (cam.zoom || 1))) + (cam.right + cam.left) / 2 + F.pr;
    var cvv = (1 - cyPx / F.H * 2) * ((cam.top - cam.bottom) / (2 * (cam.zoom || 1))) + (cam.top + cam.bottom) / 2 + F.pu;
    var ax = F.W / 2, ay = top + availH / 2;
    cam.zoom = 1;
    cam.left = (cu - F.pr) - ax / ppm; cam.right = cam.left + F.W / ppm;
    cam.top = (cvv - F.pu) + ay / ppm; cam.bottom = cam.top - F.H / ppm;
    cam.updateProjectionMatrix();
    return true;
  }
  function svgEl(n, attrs) {
    var e = document.createElementNS('http://www.w3.org/2000/svg', n), k;
    for (k in attrs) if (attrs.hasOwnProperty(k)) e.setAttribute(k, attrs[k]);
    return e;
  }
  /* THE KINDS OF LINE (blueprints-v21, Marek: vizualizovat lepe hrany, ke
     kterym se koty vztahuji, ruzny typ car, s legendou). What a dimension
     measures to is drawn over the drawing in blue, each kind in its own
     line type: the face of the frame (long dashes), the edges of a window
     or door (solid), the faces of a partition (short dashes), a centre line
     (dash-dot), a level (dash-dot-dot); the ground line heavy black. The
     dimensions themselves stay black. w / d on screen in pixels, pw / pd on
     paper in mm. */
  var BLUE = '#2563EB';
  var STY = {
    dim:     { c: '#1A1C1D', w: 1, pw: 0.18 },
    tick:    { c: '#1A1C1D', w: 1.6, pw: 0.35 },
    ext:     { c: '#1A1C1D', w: 0.8, pw: 0.13 },
    lead:    { c: '#1A1C1D', w: 0.7, pw: 0.13 },
    ref:     { c: BLUE, w: 1.8, pw: 0.35, d: [9, 4], pd: [3, 1.4] },
    edge:    { c: BLUE, w: 1.8, pw: 0.35 },
    pface:   { c: BLUE, w: 1.4, pw: 0.25, d: [3, 3], pd: [1, 1] },
    axis:    { c: BLUE, w: 1.2, pw: 0.25, d: [14, 3, 2, 3], pd: [5, 1, 0.6, 1] },
    level:   { c: BLUE, w: 1.2, pw: 0.25, d: [14, 3, 2, 3, 2, 3], pd: [5, 1, 0.6, 1, 0.6, 1] },
    grade:   { c: '#1A1C1D', w: 2.8, pw: 0.6 },
    visible: { c: '#1A1C1D', w: 1, pw: 0.18 },
    sec:     { c: '#1A1C1D', w: 2.4, pw: 0.5, d: [18, 4, 3, 4], pd: [7, 1.5, 1, 1.5] },
    secarrow: { c: '#1A1C1D', w: 2.4, pw: 0.5 },
    swing:   { c: '#1A1C1D', w: 1, pw: 0.18 },
    cut:     { c: '#000000', w: 2.6, pw: 0.5 }
  };
  var LEGEND_ORDER = ['cut', 'visible', 'ref', 'edge', 'pface', 'axis', 'level', 'grade', 'sec'];
  function partThk() { var pt = 0.1; try { pt = (_lib.partThickness && _lib.partThickness()) || 0.1; } catch (e) { pt = 0.1; } return pt; }
  function facThk() { var f = 0.15; try { f = (_lib.facadeThk && _lib.facadeThk()) || 0.15; } catch (e) { f = 0.15; } return f; }
  /* the edges the dimensions measure to, as lines in the view's u / v */
  function refPrims(F, A, M, VB) {
    var prims = [], used = { visible: 1 }, R = A.rect, wt = A.wallThk || 0, metric = isMetric(), pt = partThk(), fac = facThk(), i;
    var D = F.D, lookY = Math.abs(D[1]) > 0.9, cutOn = !!SEC.on;
    if (cutOn) used.cut = 1;
    function seg(s, p0, p1) { prims.push({ t: 'l', a: F.px(p0[0], p0[1]), b: F.px(p1[0], p1[1]), s: s }); used[s] = 1; }
    function W(x, y, z) { return F.uv(x, y, z); }
    var Y0 = 0, FL = (typeof A.floor === 'number') ? A.floor : 0, WT = A.wallTop || 0, RT = (A.roof && isFinite(A.roof.top)) ? A.roof.top : null;
    var OPS = A.openings || [], PA = A.partitions || [];
    function sideOf(o) {
      /* v25: by the wall's own normal and place (a T's set-back wall) */
      if (typeof o.nx === 'number') {
        if (o.along === 'x') return o.nz < 0 ? { k: 'z0', at: o.z, sg: 1 } : { k: 'z1', at: o.z, sg: -1 };
        return o.nx < 0 ? { k: 'x0', at: o.x, sg: 1 } : { k: 'x1', at: o.x, sg: -1 };
      }
      if (o.along === 'x') return Math.abs(o.z - R.z0) <= Math.abs(o.z - R.z1) ? { k: 'z0', at: R.z0, sg: 1 } : { k: 'z1', at: R.z1, sg: -1 };
      return Math.abs(o.x - R.x0) <= Math.abs(o.x - R.x1) ? { k: 'x0', at: R.x0, sg: 1 } : { k: 'x1', at: R.x1, sg: -1 };
    }
    if (lookY) {
      if (layerShows(M.wall)) {
        /* the face of the frame all round: the outline's own walls (v25) */
        if (A.edges) A.edges.forEach(function (e) { seg('ref', W(e.x0, Y0, e.z0), W(e.x1, Y0, e.z1)); });
        else {
          var C = [[R.x0, R.z0], [R.x1, R.z0], [R.x1, R.z1], [R.x0, R.z1]];
          for (i = 0; i < 4; i++) seg('ref', W(C[i][0], Y0, C[i][1]), W(C[(i + 1) % 4][0], Y0, C[(i + 1) % 4][1]));
        }
      }
      if (layerShows(M.open)) {
        for (i = 0; i < OPS.length; i++) {
          var o = OPS[i], sd = sideOf(o), c = (o.along === 'x') ? o.x : o.z;
          var P3 = function (along, across) { return o.along === 'x' ? W(along, Y0, across) : W(across, Y0, along); };
          if (metric) {
            [c - o.w / 2, c + o.w / 2].forEach(function (e) { seg('edge', P3(e, sd.at - sd.sg * 0.06), P3(e, sd.at + sd.sg * (wt + 0.06))); });
          } else seg('axis', P3(c, sd.at - sd.sg * (fac + 0.35)), P3(c, sd.at + sd.sg * (wt + 0.35)));
        }
      }
      if (_dimsMode === 'walls' && layerShows(M.part)) {
        for (i = 0; i < PA.length; i++) {
          var q = PA[i], a0 = Math.min(q.a, q.b), b0 = Math.max(q.a, q.b);
          var P4 = function (across, along) { return q.dir === 'v' ? W(across, Y0, along) : W(along, Y0, across); };
          if (metric) { seg('pface', P4(q.at - pt / 2, a0), P4(q.at - pt / 2, b0)); seg('pface', P4(q.at + pt / 2, a0), P4(q.at + pt / 2, b0)); }
          else seg('axis', P4(q.at, a0 - 0.2), P4(q.at, b0 + 0.2));
        }
      }
      /* THE SECTION LINES (v22): A and B as heavy chain lines, stepped where
         the section steps, an arrow at each end towards what the section
         looks at and its letter by the arrow */
      if (/^plan/.test(_view)) {
        if (!_roomsMode) secMarks(F, R, seg, prims, used);
        /* v23: the plan reads like a plan -- every room named with its clear
           size, every door with its swing */
        /* the container hands the asset its rooms box-relative and per editor
           storey: its rooms and doors are not read from there (v26) */
        if (!_lib.planStoreys) {
          try { planRooms(F, A, M, prims); } catch (eR) { log('rooms THREW ' + ((eR && eR.message) || eR)); }
          try { planSwings(F, A, M, seg); } catch (eS) { log('swings THREW ' + ((eS && eS.message) || eS)); }
        } else { SEC.rooms = 0; SEC.roomsSkipped = 0; }
      }
      return { prims: prims, used: used };
    }
    /* an elevation or a section */
    var SIDES = [
      { n: [0, 0, -1], along: 'x', at: R.z0, a: R.x0, b: R.x1, k: 'z0' }, { n: [0, 0, 1], along: 'x', at: R.z1, a: R.x0, b: R.x1, k: 'z1' },
      { n: [-1, 0, 0], along: 'z', at: R.x0, a: R.z0, b: R.z1, k: 'x0' }, { n: [1, 0, 0], along: 'z', at: R.x1, a: R.z0, b: R.z1, k: 'x1' }];
    var face = null;
    for (i = 0; i < SIDES.length; i++) { var Sn = SIDES[i].n; if (Sn[0] * D[0] + Sn[1] * D[1] + Sn[2] * D[2] < -0.7) face = SIDES[i]; }
    if (!face) return { prims: prims, used: used };
    var tc = function (s) { return face.along === 'x' ? W(s, Y0, face.at)[0] : W(face.at, Y0, s)[0]; };
    var hv = function (y) { return W(0, y, 0)[1]; };
    var ua = tc(face.a), ub = tc(face.b), U0 = Math.min(ua, ub), U1 = Math.max(ua, ub);
    seg('grade', [VB.u0 - 0.3, hv(Y0)], [VB.u1 + 0.3, hv(Y0)]);
    if (layerShows(M.wall)) {
      seg('ref', [ua, hv(Y0)], [ua, hv(WT)]); seg('ref', [ub, hv(Y0)], [ub, hv(WT)]);
      /* v25: a set-back corner seen from here (a T's wing) */
      if (A.edges && !(SEC.on && (SEC.kind === 'x' || SEC.kind === 'z'))) A.edges.forEach(function (e) {
        if (e.nx * face.n[0] + e.nz * face.n[2] <= 0.7) return;
        [face.along === 'x' ? e.x0 : e.z0, face.along === 'x' ? e.x1 : e.z1].forEach(function (cc) {
          var uu = tc(cc); if (Math.abs(uu - ua) > 0.01 && Math.abs(uu - ub) > 0.01) seg('ref', [uu, hv(Y0)], [uu, hv(WT)]);
        });
      });
    }
    var lv = [[FL, M.floor], [WT, M.wall]];
    (A.levels || []).forEach(function (y, k5) { if (k5 > 0 && y > FL + 0.01 && y < WT - 0.01) lv.push([y, M.floor]); });
    if (RT != null) lv.push([RT, M.roof]);
    for (i = 0; i < lv.length; i++) if (layerShows(lv[i][1])) seg('level', [U0 - 0.25, hv(lv[i][0])], [U1 + 0.25, hv(lv[i][0])]);
    var secOn = SEC.on && (SEC.kind === 'x' || SEC.kind === 'z');
    if (!secOn) {
      if (layerShows(M.open)) {
        for (i = 0; i < OPS.length; i++) {
          var o2 = OPS[i]; if (sideOf(o2).k !== face.k) continue;
          var c2 = (o2.along === 'x') ? o2.x : o2.z, e0 = tc(c2 - o2.w / 2), e1 = tc(c2 + o2.w / 2), ys = ((typeof o2.fy === 'number') ? o2.fy : FL) + (o2.sill || 0), yh = ys + o2.h;
          seg('edge', [e0, hv(ys)], [e1, hv(ys)]); seg('edge', [e1, hv(ys)], [e1, hv(yh)]);
          seg('edge', [e1, hv(yh)], [e0, hv(yh)]); seg('edge', [e0, hv(yh)], [e0, hv(ys)]);
          if (!metric) seg('axis', [tc(c2), hv(ys - 0.25)], [tc(c2), hv(yh + 0.25)]);
        }
      }
    } else if (layerShows(M.part)) {
      for (i = 0; i < PA.length; i++) {
        var q2 = PA[i];
        if (!secCuts(q2, face.along)) continue;
        if (metric) { seg('pface', [tc(q2.at - pt / 2), hv(FL)], [tc(q2.at - pt / 2), hv(WT)]); seg('pface', [tc(q2.at + pt / 2), hv(FL)], [tc(q2.at + pt / 2), hv(WT)]); }
        else seg('axis', [tc(q2.at), hv(FL - 0.2)], [tc(q2.at), hv(WT + 0.2)]);
      }
    }
    return { prims: prims, used: used };
  }
  /* ---- ROOM NAMES (v23): the floorplan asset's own rooms and names, the
     name in the page's language in capitals, under it the clear size (inch
     drawing: width x length; metric: the area); a closet takes no name ---- */
  function roomT(k, def) { var RM = global.BLUEPRINT_ROOMS || {}; var v = RM[k]; return (typeof v === 'string' && v) ? v : def; }
  function planRooms(F, A, M, prims) {
    if (_roomsMode) return;   /* v47: the room plan writes its codes itself */
    var FL = global.FloorplanLib; if (!FL || !FL.plan || !FL.plan.rooms) return;
    var RM = FL.plan.rooms() || [], R = A.rect, wt = A.wallThk || 0.15, pt = partThk(), metric = isMetric(), i, n = 0;
    /* a name keeps off the section lines: moved up or down until clear */
    var SEGS = [], u1 = F.paper ? 0.3 * _ts : 1;
    ['x', 'z'].forEach(function (kind) {
      var pts = secPolyline(kind, R), j; if (!pts) return;
      for (j = 0; j + 1 < pts.length; j++) { var a0 = F.uv(pts[j][0], 0, pts[j][1]), a1 = F.uv(pts[j + 1][0], 0, pts[j + 1][1]); SEGS.push([F.px(a0[0], a0[1]), F.px(a1[0], a1[1])]); }
    });
    function hitsAt(x, y, hw, hh, pad) {
      var n0 = 0;
      for (var q = 0; q < SEGS.length; q++) {
        var a = SEGS[q][0], b = SEGS[q][1];
        var sx0 = Math.min(a[0], b[0]) - pad, sx1 = Math.max(a[0], b[0]) + pad, sy0 = Math.min(a[1], b[1]) - pad, sy1 = Math.max(a[1], b[1]) + pad;
        if (x + hw > sx0 && x - hw < sx1 && y + hh > sy0 && y - hh < sy1) n0++;
      }
      return n0;
    }
    function clear(x, y, hw, hh) { return hitsAt(x, y, hw, hh, 14 * u1) === 0; }
    /* the names already placed: two never overlap */
    var PLACED = [], skipped = 0;
    function hitsTxt(x, y, hw, hh, pad) {
      var n0 = 0, q;
      for (q = 0; q < PLACED.length; q++) { var b = PLACED[q]; if (Math.abs(x - b.x) < hw + b.hw + pad && Math.abs(y - b.y) < hh + b.hh + pad) n0++; }
      return n0;
    }
    /* v24: the big rooms first, so a closet-size room never pushes a
       living room off its own centre */
    var ORD = RM.map(function (r0, k0) { return k0; }), oq;
    function areaOf(r0) { var a0 = 0; (r0 && r0.rects || []).forEach(function (q0) { a0 += (q0.x1 - q0.x0) * (q0.z1 - q0.z0); }); return a0 || (r0 && r0.area) || 0; }
    ORD.sort(function (a0, b0) { return areaOf(RM[b0]) - areaOf(RM[a0]); });
    for (oq = 0; oq < ORD.length; oq++) {
      i = ORD[oq];
      var r = RM[i]; if (!r || r.closet) continue;
      var nm = '';
      try { nm = (FL.draw && FL.draw.roomName && FL.plan.roomNameIdx) ? String(FL.draw.roomName(FL.plan.roomNameIdx(r, i), roomT) || '') : ''; } catch (eN) { nm = ''; }
      if (!nm) continue;
      var sub = '';
      if (r.rects && r.rects.length === 1) {
        var q = r.rects[0];
        var x0 = q.x0 + (Math.abs(q.x0 - R.x0) < 0.02 ? wt : pt / 2), x1 = q.x1 - (Math.abs(q.x1 - R.x1) < 0.02 ? wt : pt / 2);
        var z0 = q.z0 + (Math.abs(q.z0 - R.z0) < 0.02 ? wt : pt / 2), z1 = q.z1 - (Math.abs(q.z1 - R.z1) < 0.02 ? wt : pt / 2);
        sub = metric ? (((x1 - x0) * (z1 - z0)).toFixed(1) + ' m\u00B2') : (fmtD(x1 - x0) + ' x ' + fmtD(z1 - z0));
      } else if (r.area > 0) sub = metric ? (r.area.toFixed(1) + ' m\u00B2') : (Math.round(r.area * 10.7639) + ' sq ft');
      /* the room's home box: its one rectangle, or the largest of an L
         (the centre of an L can lie outside it) */
      var rq = null, ai, bestA = -1;
      for (ai = 0; ai < (r.rects || []).length; ai++) { var qq = r.rects[ai], aa = (qq.x1 - qq.x0) * (qq.z1 - qq.z0); if (aa > bestA) { bestA = aa; rq = qq; } }
      var cx = rq ? (rq.x0 + rq.x1) / 2 : ((typeof r.cx === 'number') ? r.cx : 0);
      var cz = rq ? (rq.z0 + rq.z1) / 2 : ((typeof r.cz === 'number') ? r.cz : 0);
      if (r.rects && r.rects.length === 1 && typeof r.cx === 'number') { cx = r.cx; cz = r.cz; }
      var u = F.uv(cx, 0, cz), p0 = F.px(u[0], u[1]), p = p0;
      var rb = null, tol = 4 * u1;
      if (rq) {
        var qa = F.uv(rq.x0, 0, rq.z0), qb = F.uv(rq.x1, 0, rq.z1), pa = F.px(qa[0], qa[1]), pb = F.px(qb[0], qb[1]);
        rb = { x0: Math.min(pa[0], pb[0]), x1: Math.max(pa[0], pb[0]), y0: Math.min(pa[1], pb[1]), y1: Math.max(pa[1], pb[1]) };
      }
      /* v24: four ways to write it, tried in turn -- name + size, the name
         alone, both smaller, the name alone smaller -- the first that finds
         a clear spot inside the room (off the section lines and the names
         already placed) wins; a room too small for any keeps the smallest
         on a white tag */
      var VAR = [
        { solo: false, small: false, hw: Math.max(nm.length * 8.5, sub.length * 5) / 2, hh: 17 },
        { solo: false, small: true, hw: Math.max(nm.length * 6.8, sub.length * 4.2) / 2, hh: 14 },
        { solo: true, small: false, hw: nm.length * 8.5 / 2, hh: 9 },
        { solo: true, small: true, hw: nm.length * 6.8 / 2, hh: 7 }
      ];
      if (!sub) VAR = [VAR[2], VAR[3]];
      var found = false, best = null, vi, vv = VAR[VAR.length - 1], offs = [0, -1, 1, -1.8, 1.8, -2.6, 2.6], oi, oj;
      for (vi = 0; vi < VAR.length && !found; vi++) {
        var V = VAR[vi], hw = V.hw * u1, hh = V.hh * u1, fits = !rb || (2 * hw <= rb.x1 - rb.x0 + 2 * tol && 2 * hh <= rb.y1 - rb.y0 + 2 * tol);
        if (!fits) continue;
        for (oj = 0; oj < 5 && !found; oj++) {
          var dx = [0, -1, 1, -2, 2][oj] * hw * 0.55;
          for (oi = 0; oi < offs.length; oi++) {
            var X = p0[0] + dx, Y = p0[1] + offs[oi] * 13 * u1 * (V.solo ? 1 : 2);
            if (rb && (X - hw < rb.x0 - tol || X + hw > rb.x1 + tol || Y - hh < rb.y0 - tol || Y + hh > rb.y1 + tol)) continue;
            var nTxt = hitsTxt(X, Y, hw, hh, 3 * u1);
            if (!nTxt && clear(X, Y, hw, hh)) { p = [X, Y]; vv = V; found = true; break; }
            /* no clear place: the one that crosses the fewest lines and names */
            var sc = nTxt * 5000 + hitsAt(X, Y, hw, hh, 0) * 1000 + vi * 10 + Math.abs(offs[oi]) + Math.abs(dx) / 50;
            if (!best || sc < best.sc) best = { sc: sc, p: [X, Y], V: V };
          }
        }
      }
      if (!found && best) { p = best.p; vv = best.V; }
      /* no spot without another name under it, or none inside the room:
         a room that small keeps no name rather than one over another */
      if (!found && (!best || best.sc >= 5000)) { skipped++; continue; }
      var hwF = vv.hw * u1, hhF = vv.hh * u1;
      PLACED.push({ x: p[0], y: p[1], hw: hwF, hh: hhF });
      /* still on a line: a white tag under the name hides it there */
      if (!found) prims.push({ t: 'tag', x: p[0], y: p[1], hw: hwF + 4 * u1, hh: hhF });
      prims.push({ t: 't', s: nm.toLocaleUpperCase(), x: p[0], y: p[1], room: true, solo: vv.solo || !sub, small: vv.small });
      if (sub && !vv.solo) prims.push({ t: 't', s: sub, x: p[0], y: p[1], roomSub: true, small: vv.small });
      n++;
    }
    SEC.rooms = n + skipped; SEC.roomsSkipped = skipped;
  }
  /* ---- DOOR SWINGS (v23): the leaf open at a right angle and the quarter
     circle it sweeps, for the doors in the outside walls and in the
     partitions; a pair has two leaves; sliding, folding and garage doors
     and a plain doorway have no swing ---- */
  function planSwings(F, A, M, seg) {
    var W2 = function (q) { return F.uv(q[0], 0, q[1]); }, nS = 0;
    function leaf(h, closed, open, w) {
      var K = 12, k, prev = null;
      seg('swing', W2(h), W2([h[0] + open[0] * w, h[1] + open[1] * w]));
      for (k = 0; k <= K; k++) {
        var a = (Math.PI / 2) * k / K, pnt = [h[0] + (closed[0] * Math.cos(a) + open[0] * Math.sin(a)) * w, h[1] + (closed[1] * Math.cos(a) + open[1] * Math.sin(a)) * w];
        if (prev) seg('swing', W2(prev), W2(pnt));
        prev = pnt;
      }
      nS++;
    }
    var wt = A.wallThk || 0.15, pt = partThk();
    /* the doors in the outside walls */
    if (layerShows(M.open) && _lib.segments) {
      var SG = _lib.segments(), i, j;
      for (i = 0; i < SG.length; i++) {
        var sg = SG[i]; if ((sg.storey | 0) !== planSt()) continue;
        for (j = 0; j < (sg.openings || []).length; j++) {
          var o = sg.openings[j];
          if ((o.sill || 0) > 0.05 || (o.kind !== 'door' && o.kind !== 'french') || o.slide) continue;
          var ux = (sg.x1 - sg.x0) / sg.len, uz = (sg.z1 - sg.z0) / sg.len, sgn = o.out ? 1 : -1;
          var face = o.out ? 0 : -wt;   /* hinge on the face the leaf opens to */
          var op = [sg.nx * sgn, sg.nz * sgn];
          var P = function (s) { return [sg.x0 + ux * s + sg.nx * face, sg.z0 + uz * s + sg.nz * face]; };
          var pair = o.kind === 'french' || o.w > 1.5 || (o.leaves | 0) >= 2;
          if (pair) { leaf(P(o.at - o.w / 2), [ux, uz], op, o.w / 2); leaf(P(o.at + o.w / 2), [-ux, -uz], op, o.w / 2); }
          else if (o.hand === 'R') leaf(P(o.at + o.w / 2), [-ux, -uz], op, o.w);
          else leaf(P(o.at - o.w / 2), [ux, uz], op, o.w);
        }
      }
    }
    /* the doors in the partitions, as the plan asset draws them */
    var FL = global.FloorplanLib;
    if (layerShows(M.part) && FL && FL.plan && FL.plan.doorsLive) {
      var DL = FL.plan.doorsLive() || [], k2;
      for (k2 = 0; k2 < DL.length; k2++) {
        var d = DL[k2].d, pw = DL[k2].p, w = d.w || 0.8;
        if (d.pass || d.slide || d.kind === 'bifold' || d.kind === 'bypass') continue;
        var sw = d.sw | 0, sy = (sw & 2) ? -1 : 1, hs = (sw & 1) ? 1 : -1;
        if (pw.o === 'v') {
          var hz = d.u + hs * w / 2, hxv = pw.c - sy * pt / 2;
          if (d.kind === 'pair') { leaf([hxv, d.u - w / 2], [0, 1], [sy, 0], w / 2); leaf([hxv, d.u + w / 2], [0, -1], [sy, 0], w / 2); }
          else leaf([hxv, hz], [0, -hs], [sy, 0], w);
        } else {
          var hx = d.u + hs * w / 2, hzh = pw.c + sy * pt / 2;
          if (d.kind === 'pair') { leaf([d.u - w / 2, hzh], [1, 0], [0, -sy], w / 2); leaf([d.u + w / 2, hzh], [-1, 0], [0, -sy], w / 2); }
          else leaf([hx, hzh], [-hs, 0], [0, -sy], w);
        }
      }
    }
    SEC.swings = nS;
  }
  function secPolyline(kind, R) {
    var L0 = SEC.lines[kind]; if (!L0 || !L0.segs || !L0.segs.length) return null;
    var OUT = SEC_OUT, n = L0.segs.length, pts = [], i;
    var lo0 = (kind === 'x') ? R.z0 - OUT : R.x0 - OUT, hi0 = (kind === 'x') ? R.z1 + OUT : R.x1 + OUT;
    function P(c, a) { return kind === 'x' ? [c, a] : [a, c]; }   /* [x, z] */
    for (i = 0; i < n; i++) {
      var sg = L0.segs[i], a0 = (i === 0) ? lo0 : sg.lo, a1 = (i === n - 1) ? hi0 : sg.hi;
      pts.push(P(sg.c, a0)); pts.push(P(sg.c, a1));
    }
    return pts;   /* consecutive pairs: cuts; between pairs: the jogs */
  }
  function secMarks(F, R, seg, prims, used) {
    ['x', 'z'].forEach(function (kind) {
      var pts = secPolyline(kind, R); if (!pts) return;
      var W2 = function (q) { return F.uv(q[0], 0, q[1]); }, i;
      for (i = 0; i + 1 < pts.length; i++) seg('sec', W2(pts[i]), W2(pts[i + 1]));
      /* the arrows: section A looks along -x, B along -z */
      var dir = (kind === 'x') ? [-1, 0] : [0, -1], L = SEC_ARROW, H = 0.2;
      [pts[0], pts[pts.length - 1]].forEach(function (e) {
        var tip = [e[0] + dir[0] * L, e[1] + dir[1] * L], side = [-dir[1], dir[0]];
        seg('secarrow', W2(e), W2(tip));
        seg('secarrow', W2(tip), W2([tip[0] - dir[0] * H + side[0] * H * 0.7, tip[1] - dir[1] * H + side[1] * H * 0.7]));
        seg('secarrow', W2(tip), W2([tip[0] - dir[0] * H - side[0] * H * 0.7, tip[1] - dir[1] * H - side[1] * H * 0.7]));
        var at = W2([e[0] + dir[0] * L * 0.5 - (kind === 'x' ? 0 : 0.35 * (e === pts[0] ? 1 : -1)), e[1] + dir[1] * L * 0.5 - (kind === 'x' ? 0.35 * (e === pts[0] ? 1 : -1) : 0)]);
        var px = F.px(at[0], at[1]);
        prims.push({ t: 't', s: SEC_LETTER[kind], x: px[0], y: px[1], big: true });
      });
      used.sec = 1;
    });
  }
  function paint(svg, F, prims) {
    svg.setAttribute('width', F.W); svg.setAttribute('height', F.H);
    svg.setAttribute('viewBox', '0 0 ' + F.W + ' ' + F.H);
    var g = svgEl('g', { fill: 'none', 'stroke-linecap': 'butt' }), gb = svgEl('g', {}), i;
    var gt = svgEl('g', { fill: '#1A1C1D', 'font-family': 'Montserrat, sans-serif', 'font-weight': '600', 'font-size': String(DS.font),
                          'text-anchor': 'middle', 'dominant-baseline': 'central', stroke: '#f5f5f5', 'stroke-width': '3', 'paint-order': 'stroke', 'stroke-linejoin': 'round' });
    for (i = 0; i < prims.length; i++) {
      var p = prims[i];
      if (p.t === 'l') {
        var st = STY[p.s || 'dim'] || STY.dim, at = { x1: p.a[0].toFixed(1), y1: p.a[1].toFixed(1), x2: p.b[0].toFixed(1), y2: p.b[1].toFixed(1), stroke: st.c, 'stroke-width': st.w };
        if (st.d) at['stroke-dasharray'] = st.d.join(' ');
        g.appendChild(svgEl('line', at));
      } else if (p.t === 'tag') {
        gb.appendChild(svgEl('rect', { x: (p.x - p.hw).toFixed(1), y: (p.y - p.hh).toFixed(1), width: (2 * p.hw).toFixed(1), height: (2 * p.hh).toFixed(1), rx: '4', fill: '#ffffff', 'fill-opacity': '0.92' }));
      } else {
        var t = svgEl('text', { x: p.x.toFixed(1), y: p.y.toFixed(1) });
        if (p.big) { t.setAttribute('font-size', '18'); t.setAttribute('font-weight', '800'); }
        if (p.room) { t.setAttribute('font-size', p.small ? '10' : '13'); t.setAttribute('font-weight', '800'); t.setAttribute('y', (p.y - (p.solo ? 0 : p.small ? 6 : 8)).toFixed(1)); }
        if (p.roomSub) { t.setAttribute('font-size', p.small ? '9' : '11'); t.setAttribute('font-weight', '600'); t.setAttribute('y', (p.y + (p.small ? 6 : 8)).toFixed(1)); t.setAttribute('fill', '#4B5563'); }
        if (p.rot) t.setAttribute('transform', 'rotate(-90 ' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')');
        t.textContent = p.s;
        gt.appendChild(t);
      }
    }
    svg.appendChild(g); svg.appendChild(gb); svg.appendChild(gt);
  }
  /* THE LEGEND in the drawer: only the kinds this view shows */
  function legendLabel(k) { var G = L.legend || {}; if (k === 'sec') return (L.views && L.views.section) || 'Section'; return G[k] || k; }
  function buildLegend(used) {
    var host = $('bp-legend');
    if (!host) {
      var dims = $('bp-dims'); if (!dims || !dims.parentNode) return;
      host = document.createElement('div'); host.id = 'bp-legend'; host.className = 'bp-legend';
      dims.parentNode.insertBefore(host, dims.nextSibling);
    }
    host.innerHTML = '';
    if (!used) return;
    var h = document.createElement('div'); h.className = 'bp-h'; h.textContent = legendLabel('title'); host.appendChild(h);
    LEGEND_ORDER.forEach(function (k) {
      if (!used[k]) return;
      var st = STY[k], row = document.createElement('div'); row.className = 'bp-leg';
      var sv = svgEl('svg', { width: '44', height: '14', viewBox: '0 0 44 14' });
      if (k === 'cut') {
        sv.appendChild(svgEl('rect', { x: '2', y: '2', width: '40', height: '10', fill: '#DEDEDE', stroke: '#000', 'stroke-width': '2.2' }));
        for (var hx = 4; hx < 44; hx += 7) sv.appendChild(svgEl('line', { x1: String(hx), y1: '12', x2: String(hx + 8 > 42 ? 42 : hx + 8), y2: String(hx + 8 > 42 ? 12 - (42 - hx) : 4), stroke: '#787878', 'stroke-width': '1' }));
      } else {
        var la = { x1: '2', y1: '7', x2: '42', y2: '7', stroke: st.c, 'stroke-width': String(Math.min(st.w, 2.4)) };
        if (st.d) la['stroke-dasharray'] = st.d.join(' ');
        sv.appendChild(svgEl('line', la));
      }
      var tx = document.createElement('span'); tx.textContent = cap(legendLabel(k));
      row.appendChild(sv); row.appendChild(tx); host.appendChild(row);
    });
  }
  function dimsWanted() { return _dimsOn && _view !== 'iso' && _view !== 'free'; }
  /* FRAMED ONCE PER VIEW: setView puts the camera square on and calls this;
     with the strings wanted the view is fitted to the drawing and its
     strings, otherwise only the bar of views is cleared */
  function frame() {
    var F = null;
    try { F = camFrame(); } catch (e) { F = null; }
    if (!dimsWanted() || !F || !_lib || !_lib.dimAnchors) { try { clearBar(); } catch (eC) {} drawDims(); return; }
    try {
      var A = anchors(), M = dimLayers(), it;
      if (!A || !A.rect || !visibleBox(F)) { clearBar(); drawDims(); return; }
      /* three passes: the numbers are pixels, the drawing is metres */
      for (it = 0; it < 3; it++) {
        F = camFrame();
        var VB = visibleBox(F), Lo = layout(F, viewStrings(F, A, M), VB);
        if (!fitTo(F, VB, Lo.ext)) break;
      }
    } catch (e2) { log('dims frame THREW ' + ((e2 && e2.message) || e2)); }
    drawDims();
  }
  /* anything that changes the strings (a layer, a ruler, the mode, a
     rebuild): the view framed again when it carries strings */
  function redraw() {
    if (dimsWanted() && _st && _lib) setView(_view); else { drawDims(); applyInk(); scheduleSheets(); }
  }
  function drawDims() {
    var svg = $('bp-dims-svg'); if (!svg) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    if (!dimsWanted() || !_lib || !_lib.dimAnchors) { _dimNote = _dimsOn ? ('none in view ' + _view) : 'off'; buildLegend(null); try { drawGrips(); } catch (eG0) {} return; }
    try {
      var F = camFrame(); if (!F) { _dimNote = 'no square-on camera in view ' + _view; return; }
      var A = anchors(), M = dimLayers(), VB = visibleBox(F);
      if (!A || !A.rect || !VB) { _dimNote = 'no anchors / nothing drawn'; return; }
      var Lo = layout(F, viewStrings(F, A, M), VB), RP = refPrims(F, A, M, VB);
      paint(svg, F, RP.prims.concat(Lo.prims));
      buildLegend(RP.used);
      var off = [], k;
      for (k in M) if (M.hasOwnProperty(k) && M[k] && !layerShows(M[k])) off.push(k + '=' + M[k]);
      _dimNote = 'view ' + _view + ' | ' + (isMetric() ? 'metric' : 'imperial') + ' | ' + Math.round(F.ppm) + ' px/m | strings ' +
        Lo.strings.map(function (s) { return s.side + ':' + (s.tier === 3 ? 'overall' : s.tier === 2 ? 'levels' : (s.inner != null ? 'inside' : 'chain')) + ' ' + (s.pts.length - 1) + (s.rows ? (' (' + s.rows + ' row' + (s.rows > 1 ? 's' : '') + ' lifted)') : ''); }).join(', ') +
        ' | numbers lifted ' + Lo.overflow + ' | mode ' + _dimsMode + ' | layers off ' + (off.length ? off.join(' ') : '-') +
        ' | outline ' + Math.round((A.rect.x1 - A.rect.x0) * 1000) + ' x ' + Math.round((A.rect.z1 - A.rect.z0) * 1000) + ' mm, openings ' + (A.openings || []).length + ', partitions ' + (A.partitions || []).length +
        (/^plan\d*$/.test(_view) && _planNote ? (' | ' + _planNote + ' | rooms ' + (SEC.rooms || 0) + (SEC.roomsSkipped ? (' (' + SEC.roomsSkipped + ' too small for a name)') : '') + (nPlans() > 1 ? (' | storey ' + (planSt() + 1) + ' / ' + nPlans()) : '')) : '');
    } catch (e) { _dimNote = 'THREW ' + ((e && e.message) || e); }
    if (_dimNote !== _dimNoteSaid) { _dimNoteSaid = _dimNote; log('dims    ' + _dimNote); }
    try { drawGrips(); } catch (eG) { log('grips THREW ' + ((eG && eG.message) || eG)); }
  }

  /* =========================================================================
     THE TITLE BLOCK (blueprints-v23, Marek: uzivatel nahraje vlastni logo a
     zakladni udaje a system je zapise do layoutu; layout se prenasi na nove
     projekty). The company, name, address, phone, e-mail, web and a logo
     are filled in once in the drawer and kept in this browser for every
     project; every sheet carries them at the top of its title block, LEVA
     stays as a small line at its foot. Nothing filled in: LEVA at the top
     as before.
     ========================================================================= */
  var TB_KEY = 'leva-bp-titleblock';
  var TB_FIELDS = ['company', 'name', 'address', 'phone', 'email', 'web'];
  function tbLoad() { try { var o = JSON.parse(global.localStorage.getItem(TB_KEY) || '{}'); return (o && typeof o === 'object') ? o : {}; } catch (e) { return {}; } }
  function tbSave(o) {
    try { global.localStorage.setItem(TB_KEY, JSON.stringify(o)); scheduleSheets(); return true; }
    catch (e) { log('title block NOT kept: ' + ((e && e.message) || e)); status('Logo too large to keep'); return false; }
  }
  function tbHas(o) { return !!(o && (o.logo || o.company || o.name || o.address || o.phone || o.email || o.web)); }
  /* a logo is kept small: at most 900 x 300 px, PNG while that stays light,
     JPEG on white otherwise */
  function tbLogo(file, done) {
    var rd = new global.FileReader();
    rd.onload = function () {
      var im = new global.Image();
      im.onload = function () {
        var k = Math.min(1, 900 / im.width, 300 / im.height), w = Math.max(1, Math.round(im.width * k)), h = Math.max(1, Math.round(im.height * k));
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d'); ctx.drawImage(im, 0, 0, w, h);
        var url = c.toDataURL('image/png');
        if (url.length > 350000) { ctx.globalCompositeOperation = 'destination-over'; ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h); url = c.toDataURL('image/jpeg', 0.9); }
        done(url, w, h);
      };
      im.onerror = function () { done(null); };
      im.src = rd.result;
    };
    rd.onerror = function () { done(null); };
    rd.readAsDataURL(file);
  }
  function buildTitleUI() {
    var host = $('bp-tb'); if (!host) return;
    host.innerHTML = '';
    var T0 = tbLoad(), LB = L.tb || {}, t = 0;
    if (!tbHas(T0) && BOOT.customerName) T0.name = BOOT.customerName;
    function keep() { if (t) global.clearTimeout(t); t = global.setTimeout(function () { t = 0; tbSave(T0); log('title block kept: ' + TB_FIELDS.filter(function (f) { return !!T0[f]; }).join(', ') + (T0.logo ? ', logo ' + T0.logoW + ' x ' + T0.logoH : '')); }, 400); }
    TB_FIELDS.forEach(function (f) {
      var el = document.createElement(f === 'address' ? 'textarea' : 'input');
      if (f !== 'address') el.type = (f === 'email') ? 'email' : (f === 'phone') ? 'tel' : 'text';
      else el.rows = 2;
      el.className = 'bp-in'; el.placeholder = cap(LB[f] || f); el.value = T0[f] || '';
      el.oninput = function () { T0[f] = el.value; keep(); };
      host.appendChild(el);
    });
    var row = document.createElement('div'); row.className = 'bp-row'; row.style.marginTop = '6px'; row.style.alignItems = 'center';
    if (T0.logo) { var im = document.createElement('img'); im.src = T0.logo; im.className = 'bp-logo'; row.appendChild(im); }
    var fi = document.createElement('input'); fi.type = 'file'; fi.accept = 'image/*'; fi.style.display = 'none';
    fi.onchange = function () {
      var f0 = fi.files && fi.files[0]; if (!f0) return;
      tbLogo(f0, function (url, w, h) {
        if (!url) { status('logo could not be read'); return; }
        T0.logo = url; T0.logoW = w; T0.logoH = h;
        if (tbSave(T0)) log('title block logo ' + w + ' x ' + h + ' px, ' + Math.round(url.length / 1024) + ' kB');
        buildTitleUI();
      });
    };
    var up = document.createElement('button'); up.type = 'button'; up.className = 'bp-btn'; up.textContent = LB.upload || 'Upload logo';
    up.onclick = function () { fi.click(); };
    row.appendChild(up); row.appendChild(fi);
    if (T0.logo) {
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'bp-btn'; rm.textContent = LB.remove || 'Remove';
      rm.onclick = function () { delete T0.logo; delete T0.logoW; delete T0.logoH; tbSave(T0); buildTitleUI(); };
      row.appendChild(rm);
    }
    host.appendChild(row);
  }

  /* =========================================================================
     THE PDF (blueprints-v21, Marek: na jedno kliknuti PDF s klasickym
     vzhledem vykresu, idealne s rameckem)

     One tap makes the whole set: the views on the sheet list (+ PDF), or,
     when the list is empty, isometric, floor plan, the four elevations and
     sections X and Z. One view per sheet, A3 landscape for a metric project,
     ANSI B (17 x 11 in) for an inch one: a frame, the drawing, its title
     and scale under it, and on the right the title block -- LEVA, the
     project, the legend of the lines on that sheet, the units, the scale
     with a scale bar, the date and the sheet number (A-001 the isometric,
     A-101 the plan, A-201... the elevations, A-301... the sections). Every
     square-on sheet is drawn at one common scale, the largest standard one
     at which all of them fit, so plan and elevations compare.

     The drawing is the line drawing above, rendered for the sheet at 6 px
     per mm; the dimensions, the blue reference lines and every word are
     vectors. Montserrat is embedded, so Czech, Polish ... print as they
     are; a language whose script the font has not (Arabic, Hebrew, Greek,
     Japanese, Korean, Chinese) prints its words in English instead.
     ========================================================================= */
  var JSPDF_URL = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js';
  var FONT_URL = { normal: 'https://cdn.jsdelivr.net/npm/@expo-google-fonts/montserrat@0.4.2/600SemiBold/Montserrat_600SemiBold.ttf',
                   bold: 'https://cdn.jsdelivr.net/npm/@expo-google-fonts/montserrat@0.4.2/700Bold/Montserrat_700Bold.ttf' };
  var PDF_EN = { title: 'Legend', cut: 'Cut', visible: 'Visible edge', ref: 'Face of frame', edge: 'Windows & doors', pface: 'Partitions',
                 axis: 'Centerline', level: 'Level', grade: 'Ground level', scale: 'Scale', date: 'Generated', project: 'Project',
                 mm: 'Dimensions in mm', ftin: 'Dimensions in feet and inches', iso: 'Isometric', front: 'Front', back: 'Back', left: 'Left',
                 right: 'Right', plan: 'Floor plan', section: 'Section', sec: 'Section', free: '3D',
                 footprint: 'Footprint', floor: 'Floor area', storeys: 'Storeys', roof: 'Roof', ridge: 'Ridge height', foundation: 'Foundation',
                 openings: 'Windows & doors', rooms: 'Rooms', boq: 'Bill of quantities', index: 'Sheet index',
                 /* v29: the parts of the package in the list of pages */
                 pk_blueprints: 'Blueprints', pk_boq: 'Bill of quantities', pk_shopping: 'Shopping list', pk_cut: 'Cut list', pk_setout: 'Foundation',
                 pk_joinery: 'Windows & doors', pk_elec: 'Services', pk_roofplan: 'Roof', pk_truss: 'Trusses', pk_panels: 'Wall panels', pk_views: '3D visualisation' };
  var DPMM = 6;
  var SCALES_M = [[20, '1:20'], [25, '1:25'], [50, '1:50'], [75, '1:75'], [100, '1:100'], [150, '1:150'], [200, '1:200'], [250, '1:250'], [500, '1:500']];
  var SCALES_I = [[12, '1" = 1\'-0"'], [16, '3/4" = 1\'-0"'], [24, '1/2" = 1\'-0"'], [32, '3/8" = 1\'-0"'], [48, '1/4" = 1\'-0"'],
                  [64, '3/16" = 1\'-0"'], [96, '1/8" = 1\'-0"'], [128, '3/32" = 1\'-0"'], [192, '1/16" = 1\'-0"']];
  var _pdfBusy = false, _pdfFont = 'helvetica', _pdfNote = '', _pdfNotes = [];
  function notesAdd(m) { _pdfNotes.push(String(m)); }
  function fontOk(s) {
    s = String(s == null ? '' : s);
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      if (c > 0x24F && !(c >= 0x2010 && c <= 0x2026) && c !== 0x2032 && c !== 0x2033 && c !== 0x00D7) return false;
    }
    return true;
  }
  /* a word for the sheet: the page's own when the font can write it */
  function pw(key, val) {
    val = String(val == null ? '' : val);
    /* v27: on the page the browser writes every script */
    if (_svgOut) return val || PDF_EN[key] || '';
    if (_pdfFont === 'helvetica') val = val.replace(/\u2032/g, "'").replace(/\u2033/g, '"');
    if (val && fontOk(val) && (_pdfFont !== 'helvetica' || !/[^\x00-\xFF]/.test(val))) return val;
    return PDF_EN[key] || val.replace(/[^\x20-\x7E]/g, '');
  }
  function loadJs(src) {
    return new Promise(function (res, rej) {
      if (global.jspdf && global.jspdf.jsPDF) { res(); return; }
      var sc = document.createElement('script'); sc.src = src;
      sc.onload = function () { res(); }; sc.onerror = function () { rej(new Error('could not load ' + src)); };
      document.head.appendChild(sc);
    });
  }
  var _fontB64 = {};
  function fetchFont(kind) {
    if (_fontB64[kind]) return Promise.resolve(_fontB64[kind]);
    return global.fetch(FONT_URL[kind]).then(function (r) { if (!r.ok) throw new Error('font HTTP ' + r.status); return r.arrayBuffer(); })
      .then(function (ab) {
        var u8 = new Uint8Array(ab), str = '', i, CH = 0x8000;
        for (i = 0; i < u8.length; i += CH) str += String.fromCharCode.apply(null, u8.subarray(i, i + CH));
        return (_fontB64[kind] = global.btoa(str));
      });
  }
  function sheetGeom(metric) {
    var W = metric ? 420 : 431.8, H = metric ? 297 : 279.4;
    var fr = { x0: 15, y0: 10, x1: W - 10, y1: H - 10 };
    var tb = { x0: fr.x1 - 64, y0: fr.y0, x1: fr.x1, y1: fr.y1 };
    var area = { x0: fr.x0 + 7, y0: fr.y0 + 7, x1: tb.x0 - 7, y1: fr.y1 - 20 };
    area.w = area.x1 - area.x0; area.h = area.y1 - area.y0; area.cx = (area.x0 + area.x1) / 2; area.cy = (area.y0 + area.y1) / 2;
    return { W: W, H: H, fr: fr, tb: tb, area: area };
  }
  function paperFrame(cam, k, area, uc, vc) {
    cam.updateMatrixWorld(true);
    var e = cam.matrixWorld.elements;
    var R = [e[0], e[1], e[2]], U = [e[4], e[5], e[6]], P = [e[12], e[13], e[14]], D = [-e[8], -e[9], -e[10]];
    return { cam: cam, R: R, U: U, D: D, W: area.w, H: area.h, ppm: k, paper: true,
      pr: R[0] * P[0] + R[1] * P[1] + R[2] * P[2], pu: U[0] * P[0] + U[1] * P[1] + U[2] * P[2],
      uv: function (x, y, z) { return [R[0] * x + R[1] * y + R[2] * z, U[0] * x + U[1] * y + U[2] * z]; },
      px: function (u, v) { return [area.cx + (u - uc) * k, area.cy - (v - vc) * k]; } };
  }
  /* the paper style of the strings: millimetres */
  function paperStyle(doc) {
    var k = _ts;   /* v27: a clean sheet writes larger */
    return { gap0: 5.5 * k, gap: 5.6 * k, tick: 1.1 * k, over: 1.4 * k, extGap: 1.2 * k, extOver: 1.4 * k, font: 2.4 * k, rowH: 3.6 * k, pad: 0, u: 0.3 * k,
             tw: function (t) { doc.setFont(_pdfFont, 'normal'); doc.setFontSize(2.4 * k / 0.3528); return doc.getTextWidth(pw('', t)); } };
  }
  /* what one sheet needs at scale denominator s: the frame centred on it,
     its strings and whether it fits */
  function sheetFit(G, s, A, M, DP, wantDims) {
    var cam = _st.camera, k = 1000 / s, Fs = camFrame(), VB = visibleBox(Fs);
    if (!VB) return null;
    var uc = (VB.u0 + VB.u1) / 2, vc = (VB.v0 + VB.v1) / 2, F, Lo, it, box;
    for (it = 0; it < 2; it++) {
      F = paperFrame(cam, k, G.area, uc, vc);
      Lo = wantDims ? layout(F, viewStrings(F, A, M), VB, DP) : { prims: [], ext: { x0: 1e9, x1: -1e9, y0: 1e9, y1: -1e9 }, strings: [] };
      var mb = F.px(VB.u0, VB.v1), mt = F.px(VB.u1, VB.v0);
      box = { x0: Math.min(Lo.ext.x0, mb[0]), x1: Math.max(Lo.ext.x1, mt[0]), y0: Math.min(Lo.ext.y0, mb[1]), y1: Math.max(Lo.ext.y1, mt[1]) };
      uc += ((box.x0 + box.x1) / 2 - G.area.cx) / k;
      vc -= ((box.y0 + box.y1) / 2 - G.area.cy) / k;
    }
    F = paperFrame(cam, k, G.area, uc, vc);
    Lo = wantDims ? layout(F, viewStrings(F, A, M), VB, DP) : Lo;
    return { F: F, Lo: Lo, VB: VB, uc: uc, vc: vc, k: k, fits: (box.x1 - box.x0) <= G.area.w + 0.01 && (box.y1 - box.y0) <= G.area.h + 0.01,
             rw: (box.x1 - box.x0) / G.area.w, rh: (box.y1 - box.y0) / G.area.h };
  }
  /* the sheet's drawing: the line drawing through a camera framed on the sheet */
  function sheetImage(G, fit, dpmm) { return linesCanvas(G, fit, dpmm).toDataURL('image/jpeg', 0.9); }
  function linesCanvas(G, fit, dpmm) {
    var area = G.area, cam = sheetCam(area, fit), dd = dpmm || DPMM;
    var W = Math.round(area.w * dd), H = Math.round(area.h * dd);
    var B = lnBuffers(cam, W, H), c = document.createElement('canvas');
    c.width = W; c.height = H;
    var ctx = c.getContext('2d'), img = ctx.createImageData(W, H);
    lnCompose(B, 1.4 * dd / DPMM < 1 ? 1 : 1.4 * dd / DPMM, img.data);
    ctx.putImageData(img, 0, 0);
    /* v34: the linework in the design's ink (black to brown, white stays) */
    if (_dz.ink) { ctx.globalCompositeOperation = 'lighten'; ctx.fillStyle = _dz.ink; ctx.fillRect(0, 0, W, H); ctx.globalCompositeOperation = 'source-over'; }
    return c;
  }
  function hexRGB(h) { var n = parseInt(String(h).replace('#', ''), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function pdfLine(doc, st, x1, y1, x2, y2) {
    var c = hexRGB(st.c); doc.setDrawColor(c[0], c[1], c[2]); doc.setLineWidth(st.pw);
    doc.setLineDashPattern(st.pd || [], 0); doc.line(x1, y1, x2, y2);
  }
  function pdfText(doc, t, x, y, size, opts) {
    opts = opts || {};
    doc.setFont(_pdfFont, opts.bold ? 'bold' : 'normal'); doc.setFontSize(size / 0.3528);
    var c = hexRGB(opts.c || _txtC || '#1A1C1D'); doc.setTextColor(c[0], c[1], c[2]);
    var w = doc.getTextWidth(t), ch = size * 0.72;
    if (opts.rot) {
      if (opts.halo) { doc.setFillColor(255, 255, 255); doc.rect(x - ch / 2 - 0.4, y - w / 2 - 0.4, ch + 0.8, w + 0.8, 'F'); }
      doc.text(t, x + ch / 2, y + w / 2, { angle: 90 });
    } else {
      var x0 = opts.align === 'left' ? x : opts.align === 'right' ? x - w : x - w / 2;
      if (opts.halo) { doc.setFillColor(255, 255, 255); doc.rect(x0 - 0.4, y - ch / 2 - 0.4, w + 0.8, ch + 0.8, 'F'); }
      doc.text(t, x0, y + ch / 2);
    }
    return w;
  }
  function pdfPrims(doc, prims) {
    var i;
    for (i = 0; i < prims.length; i++) {
      var p = prims[i];
      if (p.t === 'l') pdfLine(doc, styOf(p.s || 'dim'), p.a[0], p.a[1], p.b[0], p.b[1]);
      else if (p.t === 'tag') { doc.setFillColor(255, 255, 255); doc.rect(p.x - p.hw, p.y - p.hh, 2 * p.hw, 2 * p.hh, 'F'); }
    }
    for (i = 0; i < prims.length; i++) {
      var q = prims[i];
      if (q.t !== 't') continue;
      var k = _ts;
      if (q.code) { pdfText(doc, pw('', q.s), q.x, q.y, 3.6 * k, { bold: true, c: '#2E241B' }); continue; }   /* v47 the room plan's code */
      if (q.room) pdfText(doc, pw('', q.s), q.x, q.y - (q.solo ? 0 : q.small ? 1.4 : 1.8) * k, (q.small ? 2.2 : 2.8) * k, { halo: !_roomsMode, bold: true });
      else if (q.roomSub) pdfText(doc, pw('', q.s), q.x, q.y + (q.small ? 1.4 : 1.8) * k, (q.small ? 1.8 : 2.2) * k, { halo: !_roomsMode, c: _roomsMode ? '#2E241B' : '#4B5563', bold: _roomsMode });
      else pdfText(doc, pw('', q.s), q.x, q.y, (q.big ? 4.6 : 2.4) * k, { rot: q.rot, halo: true, bold: !!q.big, c: (q.big ? _dz.secText : _dz.dimText) || null });
    }
    doc.setLineDashPattern([], 0);
  }
  function viewName(v, it) {
    if(it && it.technical) return {key:"",s:it.technical.title};
    var mP = /^plan(\d+)$/.exec(v);
    if (it && it.rooms) return { key: 'rooms', s: cap(L.views.rooms || 'Rooms') + (mP ? (' ' + mP[1]) : '') };   /* v46 */
    if (mP) return { key: 'plan', s: cap(L.views.plan || 'Floor plan') + ' ' + mP[1] };
    var mS = /^sec([XYZ])$/.exec(v);
    if (mS) return { key: 'section', s: cap(L.views.section || 'Section') + ' ' + SEC_LETTER[mS[1].toLowerCase()] };
    return { key: v, s: cap(L.views[v] || v) };
  }
  function sheetNumber(v, n, it) {
    if(it && it.technical) return it.technical.number;
    if (it && it.rooms) return 'A-1' + pad2(++n.a1);   /* v46: the room plans first in the plan series */
    if (v === 'iso' || v === 'free') return 'A-00' + (++n.a0);
    if (/^plan/.test(v)) return 'A-1' + pad2(++n.a1);
    if (/^sec/.test(v)) return 'A-3' + pad2(++n.a3);
    return 'A-2' + pad2(++n.a2);
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  /* the title block on the right of a sheet */
  /* =========================================================================
     THE LOOK OF A SHEET (v34, Marek 2026-10-28: zkus zatraktivnit design
     blueprints -- barvy spis v tonu LEVA, tabulky bez ohraniceni poli; na
     ruzne stranky ruzne designy, pak napisu co se mi libi). A study: every
     sheet is drawn in design A (as before) unless the address asks --
     [v35, Marek 2026-10-28 on ?design=c: toto se mi libi nejvic, aplikovat
     na cele PDF; dve hnede -- puvodni a doplnkova mirne tmavsi: C is now
     every sheet's design, its titles in the LEVA brown #463529, its values
     and numbers in the darker #2E241B; the letters stay for comparison]
     ?design=mix gives each sheet its own (C B E D A in turn, the letter top
     right of the sheet), ?design=b (a..e) gives every sheet that one. The
     drawing, the dimensions and the data stay; only colours, the frame, the
     title block and the tables change -- on the page and in the PDF alike.
       A  classic: black frame, black lines, blue references
       B  sand: warm paper title block under a dark brown band, brown frame
          and dimensions, sand-gold references, whitespace instead of rules
       C  table: no frame; the title block and the cover's facts as tables
          without cell borders (warm zebra rows, a sand rule on top); brown
          linework, olive references, LEVA red section marks
       D  dark: the title block dark brown with white and sand type, sand
          references, a thin brown frame
       E  colour codes: the classic block, the drawing's kinds in LEVA colours
          (brown dimensions, sand faces of frame, red windows, doors and
          section marks, olive levels and partitions), brown linework
     ========================================================================= */
  var DZS = {
    A: { id: 'A', name: 'Classic' },
    B: { id: 'B', name: 'Sand', frame: { c: '#463529', pw: 0.4 }, edge: null, fill: '#F7F1E8', band: { bg: '#463529', fg: '#FFFFFF', sub: '#D2A878' },
         sep: null, label: '#A07D52', text: '#2E241B', num: '#463529', caption: '#463529', under: '#D2A878',
         sty: { dim: '#463529', tick: '#463529', ext: '#7A6650', lead: '#463529', ref: '#B8894E', edge: '#B8894E', pface: '#B8894E', axis: '#B8894E', level: '#B8894E' },
         dimText: '#463529' },
    C: { id: 'C', name: 'Table', frame: null, edge: null, table: true, zebra: '#F6F1E9', rule: '#D2A878', label: '#8C7A66', text: '#2E241B', num: '#2E241B',
         caption: '#463529', brand: '#463529', under: '#D2A878', ink: '#3B2F25',
         sty: { dim: '#6B4F36', tick: '#6B4F36', ext: '#A8957F', lead: '#6B4F36', ref: '#5A6B47', edge: '#5A6B47', pface: '#5A6B47', axis: '#5A6B47', level: '#5A6B47', sec: '#E8442A', secarrow: '#E8442A' },
         dimText: '#6B4F36', secText: '#E8442A' },
    D: { id: 'D', name: 'Dark', frame: { c: '#2E241B', pw: 0.3 }, edge: null, fill: '#2E241B', dark: true, sep: { c: '#5C4A3A', pw: 0.25 },
         label: '#D2A878', text: '#FFFFFF', num: '#D2A878', caption: '#2E241B', under: '#D2A878',
         sty: { ref: '#B8894E', edge: '#B8894E', pface: '#B8894E', axis: '#B8894E', level: '#B8894E' } },
    E: { id: 'E', name: 'Colour codes', ink: '#2E241B', under: '#E8442A',
         sty: { dim: '#6B4F36', tick: '#6B4F36', ext: '#B9A48D', lead: '#6B4F36', ref: '#D2A878', edge: '#E8442A', pface: '#5A6B47', axis: '#5A6B47', level: '#5A6B47', sec: '#E8442A', secarrow: '#E8442A' },
         dimText: '#6B4F36', secText: '#E8442A' }
  };
  var DZ_MIX = ['C', 'B', 'E', 'D', 'A'];
  var _dz = DZS.A, _txtC = null;
  function dzMode() { var v = ''; try { v = String(new URL(global.location.href).searchParams.get('design') || '').toLowerCase(); } catch (e) { v = ''; } return v === 'mix' ? 'mix' : (DZS[v.toUpperCase()] ? v.toUpperCase() : ''); }
  function dzFor(n) { var m = dzMode(); if (m === 'mix') return DZS[DZ_MIX[n % DZ_MIX.length]]; return DZS[m] || DZS.C; }
  /* a kind of line in the sheet's design; on the dark block the dark ones light */
  function styOf(k, onDark) {
    var s = STY[k] || STY.dim, c = (_dz.sty && _dz.sty[k]) || s.c;
    if (onDark && /^#(1A1C1D|2E241B|463529|6B4F36|000000)$/i.test(c)) c = '#FFFFFF';
    if (c === s.c) return s;
    var o = {}, q; for (q in s) if (s.hasOwnProperty(q)) o[q] = s[q]; o.c = c; return o;
  }
  function fillRect(doc, c, x, y, w, h) { var k = hexRGB(c); doc.setFillColor(k[0], k[1], k[2]); doc.rect(x, y, w, h, 'F'); }
  /* the frame round the sheet and the line between the drawing and the block */
  function dzFrame(doc, G) {
    if (G.clean || !G.fr) return;
    var f = (_dz.frame === undefined) ? { c: '#000000', pw: 0.7 } : _dz.frame, e = (_dz.edge === undefined) ? { c: '#000000', pw: 0.5 } : _dz.edge;
    doc.setLineDashPattern([], 0);
    if (f) { var fc = hexRGB(f.c); doc.setDrawColor(fc[0], fc[1], fc[2]); doc.setLineWidth(f.pw); doc.rect(G.fr.x0, G.fr.y0, G.fr.x1 - G.fr.x0, G.fr.y1 - G.fr.y0); }
    if (e && G.tb) { var ec = hexRGB(e.c); doc.setDrawColor(ec[0], ec[1], ec[2]); doc.setLineWidth(e.pw); if (G.tbBottom) doc.line(G.tb.x0, G.tb.y0, G.tb.x1, G.tb.y0); else doc.line(G.tb.x0, G.tb.y0, G.tb.x0, G.tb.y1); }
  }
  /* the design's letter, top right, in the study only */
  function dzTag(doc, G) {
    if (!dzMode()) return;
    pdfText(doc, 'DESIGN ' + _dz.id + '  -  ' + _dz.name.toUpperCase(), G.W - 8, 4.6, 2.0, { bold: true, align: 'right', c: '#B08A5A' });
  }
  /* the legend's sample of a kind of line (the cut: a hatched strip) */
  function legendSample(doc, kk, x, y, len, hgt, dark) {
    if (kk === 'cut') {
      if (dark) { doc.setFillColor(140, 120, 100); doc.setDrawColor(210, 168, 120); } else { doc.setFillColor(222, 222, 222); doc.setDrawColor(0, 0, 0); }
      doc.setLineWidth(0.4); doc.setLineDashPattern([], 0);
      doc.rect(x, y - hgt / 2, len, hgt, 'FD');
      for (var hx = 0; hx < len; hx += 2) pdfLine(doc, { c: dark ? '#D2A878' : '#787878', pw: 0.15 }, x + hx, y + hgt / 2, x + Math.min(len, hx + hgt), y + hgt / 2 - Math.min(hgt, len - hx));
    } else pdfLine(doc, styOf(kk, dark), x, y, x + len, y);
  }
  /* the scale bar: whole metres or feet, at most maxLen mm long */
  function scaleBar(doc, info, x, y, maxLen, hgt, txt) {
    var dz = _dz, dark = !!dz.dark;
    var unitM = info.metric ? 1 : 0.3048, steps = info.metric ? [1, 2, 5, 10, 20, 50] : [2, 4, 8, 16, 32, 64], tot = steps[0], i2;
    for (i2 = 0; i2 < steps.length; i2++) if (steps[i2] * unitM * info.k <= maxLen) tot = steps[i2];
    var len = tot * unitM * info.k, nB = 4, bw = len / nB, on = hexRGB(dark ? '#D2A878' : (dz.num || '#1A1C1D')), off = hexRGB(dark ? dz.fill : '#FFFFFF');
    doc.setDrawColor(on[0], on[1], on[2]); doc.setLineWidth(0.2); doc.setLineDashPattern([], 0);
    for (i2 = 0; i2 < nB; i2++) { var k = (i2 % 2 === 0) ? on : off; doc.setFillColor(k[0], k[1], k[2]); doc.rect(x + i2 * bw, y, bw, hgt, 'FD'); }
    pdfText(doc, '0', x, y + hgt + 2.4, txt, { align: 'center' });
    pdfText(doc, tot + (info.metric ? ' m' : "'"), x + len, y + hgt + 2.4, txt, { align: 'center' });
  }
  /* DESIGN C: the title block as tables without cell borders -- down the
     side: the maker on top, a sand rule, then label | value rows on warm
     zebra stripes, the legend in the same rows, the sheet at the foot;
     across the foot (a portrait sheet): the same rows in three tables */
  function titleBlockTable(doc, G, info) {
    var dz = _dz, tb = G.tb, T0 = info.tb || {}, gray = dz.label, side = !G.tbBottom;
    _txtC = dz.text;
    var rows = [];
    rows.push({ l: pw('project', L.pdf.project), v: info.project, b: true });
    if (info.customer) rows.push({ l: '', v: info.customer });
    rows.push({ l: '', v: 'theleva.com/pages/blueprints?p=' + info.id, small: true });
    var leg = [];
    LEGEND_ORDER.forEach(function (kk) { if (info.used[kk]) leg.push({ k: kk, v: cap(pw(kk, legendLabel(kk))) }); });
    var meta = [{ l: '', v: (info.unitsLabel || pw(info.metric ? 'mm' : 'ftin', info.metric ? L.pdf.mm : L.pdf.ftin)), small: true }];
    if (info.scaleLabel) meta.push({ l: pw('scale', L.pdf.scale), v: info.scaleLabel, b: true, bar: true });
    meta.push({ l: pw('date', L.pdf.date), v: info.date });
    function maker(x, y, w) {
      if (tbHas(T0)) {
        if (T0.logo && T0.logoW && T0.logoH) { var ks = Math.min(w / T0.logoW, 12 / T0.logoH); try { doc.addImage(T0.logo, /^data:image\/png/.test(T0.logo) ? 'PNG' : 'JPEG', x, y - 3, T0.logoW * ks, T0.logoH * ks); } catch (eL) { notesAdd('logo: ' + (eL && eL.message)); } return; }
        pdfText(doc, pw('', T0.company || T0.name || ''), x, y + 3, 3.6, { bold: true, align: 'left' });
        return;
      }
      pdfText(doc, 'LEVA', x, y + 3, 8, { bold: true, align: 'left', c: dz.brand });
      pdfText(doc, 'theleva.com', x + 22, y + 3.4, 2.4, { align: 'left', c: gray });
    }
    function table(list, x, y, w, rh, lw) {
      list.forEach(function (r, i) {
        if (i % 2 === 0) fillRect(doc, dz.zebra, x, y - rh / 2, w, rh);
        if (r.k) { legendSample(doc, r.k, x + 2, y, lw - 6, 2.4, false); pdfText(doc, r.v, x + lw, y, 2.2, { align: 'left' }); }
        else {
          if (r.l) pdfText(doc, String(r.l).toUpperCase(), x + 2, y, 1.7, { align: 'left', c: gray });
          pdfText(doc, r.v, r.l ? x + lw : x + 2, y, r.small ? 1.8 : (r.b ? 2.6 : 2.3), { bold: !!r.b, align: 'left', c: r.small ? gray : null });
        }
        y += rh;
      });
      return y;
    }
    if (side) {
      var x = tb.x0 + 3, w = tb.x1 - tb.x0 - 6, y = tb.y0 + 8;
      maker(x + 2, y, w - 4);
      y += 12; pdfLine(doc, { c: dz.rule, pw: 0.6 }, x, y, x + w, y);
      y += 6;
      y = table(rows, x, y, w, 6, 18);
      y += 4; pdfText(doc, pw('title', legendLabel('title')).toUpperCase(), x + 2, y, 1.7, { align: 'left', c: gray }); y += 5;
      y = table(leg, x, y, w, 5.2, 18);
      y += 3;
      meta.forEach(function (r, i) {
        if (i % 2 === 0) fillRect(doc, dz.zebra, x, y - 3, w, 6);
        if (r.l) pdfText(doc, String(r.l).toUpperCase(), x + 2, y, 1.7, { align: 'left', c: gray });
        pdfText(doc, r.v, r.l ? x + 18 : x + 2, y, r.small ? 1.8 : (r.b ? 2.6 : 2.3), { bold: !!r.b, align: 'left', c: r.small ? gray : null });
        y += 6;
        if (r.bar) { scaleBar(doc, info, x + 18, y - 2.4, w - 22, 1.4, 1.7); y += 5; }
      });
      var yb = tb.y1 - 22;
      pdfLine(doc, { c: dz.rule, pw: 0.6 }, x, yb, x + w, yb);
      pdfText(doc, info.title.toUpperCase(), x + 2, yb + 6, 2.6, { bold: true, align: 'left', c: dz.brand });
      pdfText(doc, info.number, x + 2, yb + 15, 7.5, { bold: true, align: 'left', c: dz.num });
      pdfText(doc, info.page + ' / ' + info.pages, x + w - 2, yb + 15, 2.4, { align: 'right', c: gray });
    } else {
      var W0 = tb.x1 - tb.x0, cx = [tb.x0, tb.x0 + W0 * 0.34, tb.x0 + W0 * 0.62, tb.x1];
      pdfLine(doc, { c: dz.rule, pw: 0.6 }, tb.x0, tb.y0 + 1, tb.x1, tb.y0 + 1);
      maker(cx[0] + 3, tb.y0 + 6, cx[1] - cx[0] - 8);
      table(rows, cx[0] + 1, tb.y0 + 17, cx[1] - cx[0] - 5, 5.4, 16);
      table(leg.concat(meta.filter(function (r) { return !r.bar; })), cx[1] + 2, tb.y0 + 6, cx[2] - cx[1] - 6, 4.6, 14);
      var x4 = cx[2] + 3, w4 = cx[3] - cx[2] - 4, y4 = tb.y0 + 6;
      if (info.scaleLabel) {
        fillRect(doc, dz.zebra, x4 - 1, y4 - 3, w4, 6);
        pdfText(doc, pw('scale', L.pdf.scale).toUpperCase(), x4 + 1, y4, 1.7, { align: 'left', c: gray });
        pdfText(doc, info.scaleLabel, x4 + 15, y4, 2.4, { bold: true, align: 'left' });
        scaleBar(doc, info, x4 + 1, y4 + 4, w4 - 6, 1.3, 1.6);
      }
      pdfText(doc, info.title.toUpperCase(), x4 + 1, tb.y1 - 14, 2.3, { bold: true, align: 'left', c: dz.brand });
      pdfText(doc, info.number, x4 + 1, tb.y1 - 5, 6.2, { bold: true, align: 'left', c: dz.num });
      pdfText(doc, info.page + ' / ' + info.pages, tb.x1 - 2, tb.y1 - 5, 2.0, { align: 'right', c: gray });
    }
    _txtC = null;
  }
  function titleBlock(doc, G, info) {
    if (_dz.table) { titleBlockTable(doc, G, info); return; }
    var dz = _dz, tb = G.tb, x = tb.x0 + 5, r = tb.x1 - 5, y = tb.y0 + 13, gray = dz.label || '#6B7280', T0 = info.tb || {}, dark = !!dz.dark;
    _txtC = dz.text || null;
    if (dz.fill) fillRect(doc, dz.fill, tb.x0, tb.y0, tb.x1 - tb.x0, tb.y1 - tb.y0);
    function hr(yy) { if (dz.sep === null) return; pdfLine(doc, dz.sep || { c: '#1A1C1D', pw: 0.25 }, tb.x0, yy, tb.x1, yy); }
    function lab(t, yy) { pdfText(doc, t.toUpperCase(), x, yy, 1.9, { align: 'left', c: gray }); }
    if (tbHas(T0) && dz.band) fillRect(doc, dz.band.bg, tb.x0, tb.y0, tb.x1 - tb.x0, 3);
    if (!tbHas(T0) && dz.band) {
      /* B: the maker in the dark band at the top of the block */
      fillRect(doc, dz.band.bg, tb.x0, tb.y0, tb.x1 - tb.x0, 22);
      pdfText(doc, 'LEVA', x, tb.y0 + 9, 9, { bold: true, align: 'left', c: dz.band.fg });
      pdfText(doc, 'theleva.com', x, tb.y0 + 16, 2.6, { align: 'left', c: dz.band.sub });
      y = tb.y0 + 22;
    } else if (tbHas(T0)) {
      /* the user's own block: logo, company, name, address, contacts */
      y = tb.y0 + 6;
      if (T0.logo && T0.logoW && T0.logoH) {
        var ks = Math.min((tb.x1 - tb.x0 - 10) / T0.logoW, 18 / T0.logoH), lw = T0.logoW * ks, lh = T0.logoH * ks;
        try { doc.addImage(T0.logo, /^data:image\/png/.test(T0.logo) ? 'PNG' : 'JPEG', x, y, lw, lh); } catch (eL) { notesAdd('logo: ' + (eL && eL.message)); }
        y += lh + 5;
      } else y += 4;
      if (T0.company) { pdfText(doc, pw('', T0.company), x, y, 3.6, { bold: true, align: 'left' }); y += 5; }
      if (T0.name) { pdfText(doc, pw('', T0.name), x, y, 2.8, { align: 'left' }); y += 4.4; }
      if (T0.address) {
        doc.setFont(_pdfFont, 'normal'); doc.setFontSize(2.4 / 0.3528);
        String(T0.address).split(/\n/).forEach(function (ln) { doc.splitTextToSize(pw('', ln), tb.x1 - tb.x0 - 10).forEach(function (l2) { pdfText(doc, l2, x, y, 2.4, { align: 'left' }); y += 3.6; }); });
      }
      ['phone', 'email', 'web'].forEach(function (f) { if (T0[f]) { pdfText(doc, pw('', T0[f]), x, y, 2.4, { align: 'left' }); y += 3.6; } });
      y += 1;
    } else {
      pdfText(doc, 'LEVA', x, y, 9, { bold: true, align: 'left' });
      pdfText(doc, 'theleva.com', x, y + 7, 2.6, { align: 'left', c: gray });
      y += 13;
    }
    hr(y);
    y += 6; lab(pw('project', L.pdf.project), y);
    y += 5; pdfText(doc, info.project, x, y, 3.4, { bold: true, align: 'left' });
    if (info.customer) { y += 5; pdfText(doc, info.customer, x, y, 2.8, { align: 'left' }); }
    y += 5; pdfText(doc, 'theleva.com/pages/blueprints?p=' + info.id, x, y, 2.0, { align: 'left', c: gray });
    y += 6; hr(y);
    /* the legend: the kinds of line on this sheet */
    y += 6; lab(pw('title', legendLabel('title')), y);
    LEGEND_ORDER.forEach(function (kk) {
      if (!info.used[kk]) return;
      y += 4.6;
      if (kk === 'cut') legendSample(doc, kk, x, y, 12, 3, dark);
      else pdfLine(doc, styOf(kk, dark), x, y, x + 12, y);
      pdfText(doc, cap(pw(kk, legendLabel(kk))), x + 15, y, 2.4, { align: 'left' });
    });
    y += 6; hr(y);
    y += 6; pdfText(doc, (info.unitsLabel || pw(info.metric ? 'mm' : 'ftin', info.metric ? L.pdf.mm : L.pdf.ftin)), x, y, 2.4, { align: 'left' });
    if (info.scaleLabel) {
      y += 6; lab(pw('scale', L.pdf.scale), y);
      y += 5; pdfText(doc, info.scaleLabel, x, y, 3.4, { bold: true, align: 'left' });
      /* the scale bar: whole metres or feet, at most 50 mm long */
      y += 5;
      scaleBar(doc, info, x, y, 50, 1.6, 2.0);
      y += 5;
    }
    y += 6; lab(pw('date', L.pdf.date), y);
    y += 5; pdfText(doc, info.date, x, y, 2.8, { align: 'left' });
    /* the sheet: its title and number at the foot of the block */
    var yb = tb.y1 - 26;
    if (tbHas(T0)) pdfText(doc, 'LEVA  \u00B7  theleva.com', x, yb - 3, 2.0, { align: 'left', c: gray });
    hr(yb);
    pdfText(doc, info.title.toUpperCase(), x, yb + 6, 2.8, { bold: true, align: 'left' });
    pdfText(doc, info.number, x, yb + 16, 8, { bold: true, align: 'left', c: dz.num || null });
    pdfText(doc, info.page + ' / ' + info.pages, r, yb + 16, 2.6, { align: 'right', c: gray });
    _txtC = null;
  }
  function busy(on, txt) {
    var o = $('bp-busy');
    if (!o) {
      o = document.createElement('div'); o.id = 'bp-busy';
      o.style.cssText = 'position:absolute;inset:0;z-index:40;display:flex;align-items:center;justify-content:center;background:rgba(245,245,245,0.86);' +
        'font:700 18px Montserrat,sans-serif;color:#1A1C1D;text-align:center;padding:20px;';
      ($('bp-wrap') || document.body).appendChild(o);
    }
    o.style.display = on ? 'flex' : 'none';
    if (txt != null) o.textContent = txt;
  }
  function wait(ms) { return new Promise(function (r) { global.setTimeout(r, ms); }); }
  /* THE COVER SHEET (A-000): the product and its size, the isometric, the
     project's facts from the model and the bill, and the sheet index */
  /* the rooms of every storey (v24): the floorplan asset lists the rooms of
     the storey the plan shows, so each storey is asked in turn */
  /* the product's own title from the store (v24, BLUEPRINT_TITLES in the
     section, translated by Shopify), not its slug: GARAGE APARTMENT, not
     GARAGEAPT */
  function prodTitle() {
    if (!_proj) return 'LEVA';
    var T = global.BLUEPRINT_TITLES || {}, t = T[_proj.product];
    return String((typeof t === 'string' && t) ? t : _proj.product).toUpperCase();
  }
  /* on a sheet: a title the font cannot write (Japanese ...) falls back
     to the product's slug */
  function pdfTitle() {
    var t = pw('', prodTitle()).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
    return t || (_proj ? _proj.product.toUpperCase() : 'LEVA');
  }
  function roomCount() {
    var FL = global.FloorplanLib; if (!FL || !FL.plan || !FL.plan.rooms) return SEC.rooms || 0;
    if (_lib && _lib.planStoreys) return 0;   /* the container: its rooms are not read from the asset (v26) */
    var N = storeyList().length > 1 ? storeyList().length : 1, n = 0, k, keep = 0;
    try { keep = _lib.STATE.planStorey | 0; } catch (e0) { keep = 0; }
    for (k = 0; k < N; k++) {
      if (N > 1) { try { _lib.STATE.planStorey = k; } catch (e1) {} }
      try { (FL.plan.rooms() || []).forEach(function (r) { if (r && !r.closet) n++; }); } catch (e2) {}
    }
    if (N > 1) { try { _lib.STATE.planStorey = keep; } catch (e3) {} }
    return n;
  }
  /* the project's facts from the model and the bill, as label key + value */
  function factRows(metric, A) {
    var CV = L.cover || {};
    var Fx = {}; try { Fx = (_lib.facts && _lib.facts()) || {}; } catch (eF) { Fx = {}; }
    function area(m2) { return metric ? (m2.toFixed(1) + ' m\u00B2') : (Math.round(m2 * 10.7639) + ' sq ft'); }
    var ROOF = { gable: 'roof_v1', hip: 'roof_v2', flat: 'roof_v3', mono: 'roof_v4' };
    var FOUND = { piers: 'piers', pads: 'pads', strips: 'strips', slab: 'slab', screws: 'screws' };
    var rows = [];
    /* the size as the drawings measure it (facts round it to the centimetre) */
    var fw = (A && A.rect) ? (A.rect.x1 - A.rect.x0) : Fx.width, fl = (A && A.rect) ? (A.rect.z1 - A.rect.z0) : Fx.length;
    if (fw && fl) rows.push(['footprint', fmtD(fw) + ' x ' + fmtD(fl) + (Fx.footprintArea ? ('  \u00B7  ' + area(Fx.footprintArea)) : '')]);
    if (Fx.floorArea) rows.push(['floor', area(Fx.floorArea)]);
    if (Fx.storeys) rows.push(['storeys', String(Fx.storeys)]);
    if (Fx.roof) rows.push(['roof', ((CV.roofTypes || {})[ROOF[Fx.roof.type]] || Fx.roof.type || '') + (Fx.roof.pitch != null ? ('  ' + Fx.roof.pitch + '\u00B0') : '')]);
    if (Fx.ridgeHeight) rows.push(['ridge', fmtD(Fx.ridgeHeight)]);
    if (Fx.foundation) rows.push(['foundation', (CV.foundations || {})[FOUND[Fx.foundation]] || Fx.foundation]);
    if (A) rows.push(['openings', String((A.openings || []).length)]);
    var nRooms = roomCount(); if (nRooms) rows.push(['rooms', String(nRooms)]);
    try { var bq = _lib.boq ? _lib.boq() : null; if (bq && bq.rows) rows.push(['boq', bq.rows.length + ' ' + (CV.items || 'items')]); } catch (eB) {}
    return rows;
  }
  function coverSheet(doc, G, base, index, dpmm) {
    var a = G.area, CV = L.cover || {}, gray = _dz.label || '#6B7280', metric = base.metric, tbl = !!_dz.table;
    var A = anchors(true);
    pdfText(doc, pdfTitle(), a.x0, a.y0 + 8, 11, { bold: true, align: 'left', c: _dz.caption || null });
    if (A && A.rect) pdfText(doc, fmtD(A.rect.x1 - A.rect.x0) + ' x ' + fmtD(A.rect.z1 - A.rect.z0), a.x0, a.y0 + 19, 5, { align: 'left', c: gray });
    /* the isometric, on the left two thirds */
    var iw = a.w * 0.58, box = { x0: a.x0, y0: a.y0 + 26, x1: a.x0 + iw, y1: a.y1 };
    box.w = box.x1 - box.x0; box.h = box.y1 - box.y0; box.cx = (box.x0 + box.x1) / 2; box.cy = (box.y0 + box.y1) / 2;
    try { picInto(doc, { area: box }, null, dpmm, 'cover', box.x0, box.y0, box.w, box.h); } catch (eI) { notesAdd('cover image: ' + (eI && eI.message)); }
    /* the facts */
    var x = a.x0 + iw + 8, y = a.y0 + 6, i, rows = factRows(metric, A), fw = a.x1 - x;
    for (i = 0; i < rows.length; i++) {
      if (tbl) {
        /* C: the facts as a table without cell borders */
        if (i % 2 === 0) fillRect(doc, _dz.zebra, x - 2, y - 3.6, fw + 2, 7.2);
        pdfText(doc, pw(rows[i][0], CV[rows[i][0]] || rows[i][0]).toUpperCase(), x, y, 1.9, { align: 'left', c: gray });
        pdfText(doc, pw('', rows[i][1]), x + fw - 2, y, 2.8, { bold: true, align: 'right', c: _dz.text });
        y += 7.2;
        continue;
      }
      pdfText(doc, pw(rows[i][0], CV[rows[i][0]] || rows[i][0]).toUpperCase(), x, y, 2.0, { align: 'left', c: gray });
      pdfText(doc, pw('', rows[i][1]), x, y + 4.2, 3.2, { bold: true, align: 'left', c: _dz.num || null });
      y += 9.6;
    }
    /* the sheet index */
    y += 4;
    pdfText(doc, pw('index', CV.index || 'Sheet index').toUpperCase(), x, y, 2.0, { align: 'left', c: gray });
    y += 5;
    var idx = [{ n: 'A-000', s: cap(pw('project', L.pdf.project)) }].concat(index.map(function (q) { return { n: q.n, s: pw(q.t.key, q.t.s) }; }));
    for (i = 0; i < idx.length; i++) {
      if (tbl && i % 2 === 0) fillRect(doc, _dz.zebra, x - 2, y - 2.3, fw + 2, 4.6);
      pdfText(doc, idx[i].n, x, y, 2.8, { bold: true, align: 'left', c: _dz.num || null });
      pdfText(doc, idx[i].s, x + 18, y, 2.8, { align: 'left', c: _dz.text || null });
      y += 4.6;
    }
    var title = pw('project', cap(L.pdf.project || 'Project'));
    titleBlock(doc, G, { project: base.project, customer: base.customer, id: base.id, used: { visible: 1 }, tb: base.tb, metric: metric,
                         scaleLabel: '', k: 0, date: base.date, title: title, number: 'A-000', page: 1, pages: base.pages });
    dzFrame(doc, G);
    dzTag(doc, G);
  }
  /* THE LIST OF PAGES (v29, Marek: prvni strana zustane product image, na
     druhou stranu seznam stran -- blueprints 3-8, bill of quantities,
     shopping list, cut list ...): the second page of the package. The
     product and its size, the isometric and the facts on the left; on the
     right every part of the document with its pages, the drawings one by
     one under Blueprints */
  function pgRange(a, b) { return (a === b) ? String(a) : (a + ((_svgOut || _pdfFont !== 'helvetica') ? '\u2013' : '-') + b); }
  function contentsSheet(doc, G, base, index, dpmm, PK) {
    var a = G.area, CV = L.cover || {}, PL = L.pkg || {}, gray = _dz.label || '#6B7280', metric = base.metric, A = anchors(true), i, tbl = !!_dz.table;
    pdfText(doc, pdfTitle(), a.x0, a.y0 + 8, 11, { bold: true, align: 'left', c: _dz.caption || null });
    if (A && A.rect) pdfText(doc, fmtD(A.rect.x1 - A.rect.x0) + ' x ' + fmtD(A.rect.z1 - A.rect.z0), a.x0, a.y0 + 19, 5, { align: 'left', c: gray });
    /* the isometric and the facts under it, on the left half */
    var lw = a.w * 0.5, rows = factRows(metric, A), fh = Math.ceil(rows.length / 2) * 9.6;
    var box = { x0: a.x0, y0: a.y0 + 26, x1: a.x0 + lw, y1: Math.max(a.y0 + 60, a.y1 - fh - 8) };
    box.w = box.x1 - box.x0; box.h = box.y1 - box.y0; box.cx = (box.x0 + box.x1) / 2; box.cy = (box.y0 + box.y1) / 2;
    try { picInto(doc, { area: box }, null, dpmm, 'cover', box.x0, box.y0, box.w, box.h); } catch (eI) { notesAdd('contents image: ' + (eI && eI.message)); }
    var y = box.y1 + 7;
    for (i = 0; i < rows.length; i++) {
      var fx = a.x0 + (i % 2) * (lw / 2), fy = y + Math.floor(i / 2) * 9.6;
      if (tbl && i % 2 === 0 && Math.floor(i / 2) % 2 === 0) fillRect(doc, _dz.zebra, a.x0 - 2, fy - 3.4, lw + 2, 9.6);
      pdfText(doc, pw(rows[i][0], CV[rows[i][0]] || rows[i][0]).toUpperCase(), fx, fy, 2.0, { align: 'left', c: gray });
      pdfText(doc, pw('', rows[i][1]), fx, fy + 4.2, 3.0, { bold: true, align: 'left', c: _dz.num || null });
    }
    /* the list: each part with its pages, the drawings under Blueprints */
    /* v38: the product's own documentation first (TAURUS: Matt's drawings) */
    var nL = PK.nL || 0, L2 = [];
    if (nL) L2.push({ l: pw('pk_lead', PK.leadLabel || 'Documentation'), p: pgRange(1, nL) });
    L2.push({ l: pw('project', PL.cover || L.pdf.project || 'Project'), p: String(nL + 1) }, { l: pw('index', CV.index || 'Sheet index'), p: String(nL + 2) });
    var nI = PK.nI || 0;
    (PK.introGroups || []).forEach(function (g) { L2.push({ l: pw('pk_' + g.key, g.label), p: pgRange(g.from, g.to) }); });
    if (index.length) {
      L2.push({ l: pw('pk_blueprints', PL.blueprints || 'Blueprints'), p: pgRange(nL + nI + 3, nL + nI + 2 + index.length) });
      index.forEach(function (it, k) { L2.push({ sub: true, n: it.n, l: pw(it.t.key, it.t.s), p: String(nL + nI + 3 + k) }); });
    }
    PK.groups.forEach(function (g) { L2.push({ l: pw('pk_' + g.key, g.label), p: pgRange(g.from, g.to) }); });
    var need = 7, x1 = a.x0 + lw + 10, xr = a.x1 - 2;
    L2.forEach(function (r) { need += r.sub ? 4.4 : 6.6; });
    var k = Math.min(1, (a.h - 4) / need), yy = a.y0 + 6;
    pdfText(doc, pw('index', CV.index || 'Sheet index').toUpperCase(), x1, yy, 2.0, { align: 'left', c: gray });
    yy += 7 * k;
    var zi = 0;
    L2.forEach(function (r) {
      if (r.sub) {
        if (tbl && (zi++ % 2 === 0)) fillRect(doc, _dz.zebra, x1 + 2, yy - 2.2 * k, xr - x1 - 2, 4.4 * k);
        pdfText(doc, r.n, x1 + 4, yy, 2.4, { bold: true, align: 'left', c: gray });
        pdfText(doc, r.l, x1 + 21, yy, 2.4, { align: 'left', c: _dz.text || null });
        pdfText(doc, r.p, xr - (tbl ? 2 : 0), yy, 2.4, { align: 'right', c: gray });
        yy += 4.4 * k;
        return;
      }
      zi = 0;
      yy += 1.2 * k;
      if (tbl) fillRect(doc, _dz.zebra, x1, yy - 2.6 * k, xr - x1, 5.2 * k);
      pdfText(doc, r.l, x1 + (tbl ? 2 : 0), yy, 3.0, { bold: true, align: 'left', c: _dz.num || null });
      pdfText(doc, r.p, xr - (tbl ? 2 : 0), yy, 3.0, { bold: true, align: 'right', c: _dz.num || null });
      if (!tbl) pdfLine(doc, { c: _dz.under || '#C9CDD2', pw: 0.2 }, x1, yy + 1.8, xr, yy + 1.8);
      yy += 5.4 * k;
    });
    var title = pw('index', CV.index || 'Sheet index');
    dzTag(doc, G);
    if (G.clean) { pdfText(doc, (nL + 2) + ' / ' + PK.total, a.x1, a.y1 + 6.5, 3.0, { bold: true, align: 'right' }); return; }
    titleBlock(doc, G, { project: base.project, customer: base.customer, id: base.id, used: { visible: 1 }, tb: base.tb, metric: metric,
                         scaleLabel: '', k: 0, date: base.date, title: title, number: 'A-000', page: nL + 2, pages: PK.total });
    dzFrame(doc, G);
  }
  /* =========================================================================
     THE SHEETS ON THE PAGE (blueprints-v27, Marek: misto prepinani banneru
     nahore rovnou vsechny vykresy v bloku pod sebou; v plovoucim menu
     barevne / cernobile, s rameckem a razitkem a bez -- uzivatel jen
     scrolluje dolu)

     The page shows the whole set at once, one sheet under the other, the
     way the PDF prints it -- the PDF is now these very sheets. Every sheet
     is drawn by the same routines into an SVG on the page (SvgDoc below
     answers the few calls of jsPDF they make) or into the PDF. The floating
     menu sets the look of all of them: in colour (the model as rendered)
     or black and white (the line drawing), with the frame and the title
     block, or clean (no frame, a smaller sheet with larger type, made for
     the screen). A tap on a sheet opens that view live -- the model turns,
     the section lines take their grips -- and the arrow brings the sheets
     back, drawn again if anything changed meanwhile.
     ========================================================================= */
  var LOOK_KEY = 'leva-bp-look';
  function lookLoad() {
    var o = null; try { o = JSON.parse(global.localStorage.getItem(LOOK_KEY) || 'null'); } catch (e) { o = null; }
    /* v31: no colour switch any more (each sheet has its slider): every sheet
       starts as the line drawing */
    return { color: false, frame: !(o && o.frame === false) };
  }
  function lookSave() { try { global.localStorage.setItem(LOOK_KEY, JSON.stringify(_look)); } catch (e) {} }
  /* THE SHEET'S SIZE (v28, Marek: formaty A4 na vysku i na sirku podle
     vykresu, razitko na boku nebo dole): A4 for a metric project, Letter
     for an inch one, each sheet turned the way its drawing fits best --
     landscape with the title block down the right side, portrait with it
     across the foot; what the block leaves is the drawing's area. Without
     the frame the whole sheet but its margins is the drawing. */
  function sheetGeomP(metric, portrait, framed, foot) {
    var a = metric ? [297, 210] : [279.4, 215.9];
    var W = portrait ? a[1] : a[0], H = portrait ? a[0] : a[1], area, G = { W: W, H: H, portrait: !!portrait, clean: !framed, fr: null, tb: null };
    /* the block at the foot: always on a portrait sheet, on a landscape one
       when the drawing is long (foot) */
    var bottom = !!portrait || !!foot;
    if (framed) {
      var fr = { x0: 14, y0: 8, x1: W - 8, y1: H - 8 };
      var tb = bottom ? { x0: fr.x0, y0: fr.y1 - 38, x1: fr.x1, y1: fr.y1 } : { x0: fr.x1 - 58, y0: fr.y0, x1: fr.x1, y1: fr.y1 };
      area = bottom ? { x0: fr.x0 + 3, y0: fr.y0 + 3, x1: fr.x1 - 3, y1: tb.y0 - 14 } : { x0: fr.x0 + 3, y0: fr.y0 + 3, x1: tb.x0 - 3, y1: fr.y1 - 14 };
      G.fr = fr; G.tb = tb; G.tbBottom = bottom;
    } else area = { x0: 8, y0: 8, x1: W - 8, y1: H - 16 };
    area.w = area.x1 - area.x0; area.h = area.y1 - area.y0; area.cx = (area.x0 + area.x1) / 2; area.cy = (area.y0 + area.y1) / 2;
    G.area = area;
    return G;
  }
  function sheetGeomFor(metric, portrait) { return sheetGeomP(metric, !!portrait, _look.frame); }

  /* ---- SvgDoc: the part of jsPDF the sheet routines use, drawn as SVG.
     Millimetres throughout (the viewBox is the sheet), font sizes in points
     as jsPDF takes them, the text measured on a canvas in the page's own
     Montserrat ---- */
  var _measureCtx = null;
  function textWidthMm(t, bold, sizeMm) {
    if (!_measureCtx) { var c0 = document.createElement('canvas'); _measureCtx = c0.getContext('2d'); }
    _measureCtx.font = (bold ? '700' : '600') + ' 100px Montserrat, sans-serif';
    return _measureCtx.measureText(String(t)).width / 100 * sizeMm;
  }
  function SvgDoc(W, H) {
    var NS = 'http://www.w3.org/2000/svg';
    this.NS = NS; this.W = W; this.H = H;
    this.root = document.createElementNS(NS, 'svg');
    this.root.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    this.root.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    this.st = { draw: 'rgb(0,0,0)', fill: 'rgb(0,0,0)', text: 'rgb(0,0,0)', lw: 0.2, dash: null, bold: false, pt: 10 };
    this.el('rect', { x: 0, y: 0, width: W, height: H, fill: '#ffffff' });
  }
  SvgDoc.prototype = {
    el: function (tag, at) { var e = document.createElementNS(this.NS, tag), k; for (k in at) if (at.hasOwnProperty(k)) e.setAttribute(k, String(at[k])); this.root.appendChild(e); return e; },
    rgb: function (r, g, b) { return 'rgb(' + (r | 0) + ',' + ((g == null ? r : g) | 0) + ',' + ((b == null ? r : b) | 0) + ')'; },
    setDrawColor: function (r, g, b) { this.st.draw = this.rgb(r, g, b); },
    setFillColor: function (r, g, b) { this.st.fill = this.rgb(r, g, b); },
    setTextColor: function (r, g, b) { this.st.text = this.rgb(r, g, b); },
    setLineWidth: function (w) { this.st.lw = w; },
    setLineDashPattern: function (a) { this.st.dash = (a && a.length) ? a.join(' ') : null; },
    setFont: function (f, s) { this.st.bold = s === 'bold'; },
    setFontSize: function (pt) { this.st.pt = pt; },
    getTextWidth: function (t) { return textWidthMm(t, this.st.bold, this.st.pt * 0.3528); },
    splitTextToSize: function (t, w) {
      var words = String(t).split(/\s+/), out = [], cur = '', i;
      for (i = 0; i < words.length; i++) {
        var nx = cur ? (cur + ' ' + words[i]) : words[i];
        if (cur && this.getTextWidth(nx) > w) { out.push(cur); cur = words[i]; } else cur = nx;
      }
      if (cur) out.push(cur);
      return out;
    },
    stroke: function (at) { at.stroke = this.st.draw; at['stroke-width'] = this.st.lw; if (this.st.dash) at['stroke-dasharray'] = this.st.dash; return at; },
    line: function (x1, y1, x2, y2) { this.el('line', this.stroke({ x1: x1, y1: y1, x2: x2, y2: y2, fill: 'none' })); },
    rect: function (x, y, w, h, style) {
      var at = { x: x, y: y, width: w, height: h };
      if (style === 'F') at.fill = this.st.fill;
      else if (style === 'FD' || style === 'DF') { at.fill = this.st.fill; this.stroke(at); }
      else { at.fill = 'none'; this.stroke(at); }
      this.el('rect', at);
    },
    text: function (t, x, y, o) {
      var e = this.el('text', { x: x, y: y, fill: this.st.text, 'font-family': 'Montserrat, sans-serif', 'font-weight': this.st.bold ? 700 : 600,
                                'font-size': (this.st.pt * 0.3528).toFixed(3) });
      if (o && o.angle) e.setAttribute('transform', 'rotate(' + (-o.angle) + ' ' + x + ' ' + y + ')');
      e.textContent = String(t);
    },
    addImage: function (url, fmt, x, y, w, h) {
      var e = this.el('image', { x: x, y: y, width: w, height: h, preserveAspectRatio: 'none' });
      e.setAttribute('href', url);
      try { e.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', url); } catch (eX) {}
      return e;
    }
  };

  /* the camera of a sheet: the view's own, framed on the sheet's drawing area */
  function sheetCam(area, fit) {
    var cam = _st.camera.clone();
    if (cam.isOrthographicCamera && fit) {
      var F = fit.F, k = fit.k;
      cam.left = (fit.uc + (area.x0 - area.cx) / k) - F.pr; cam.right = (fit.uc + (area.x1 - area.cx) / k) - F.pr;
      cam.top = (fit.vc + (area.cy - area.y0) / k) - F.pu; cam.bottom = (fit.vc - (area.y1 - area.cy) / k) - F.pu;
      cam.zoom = 1;
    } else if (cam.isPerspectiveCamera) cam.aspect = area.w / area.h;
    cam.updateProjectionMatrix(); cam.updateMatrixWorld(true);
    return cam;
  }
  /* the sheet in colour: the model as the configurator renders it, on white */
  function colorImage(G, fit, dpmm) { return colorCanvas(G, fit, dpmm).toDataURL('image/jpeg', 0.88); }
  function colorCanvas(G, fit, dpmm) {
    var T = global.THREE, r = _st.renderer, area = G.area, cam = sheetCam(area, fit);
    var W = Math.round(area.w * dpmm), H = Math.round(area.h * dpmm);
    var keep = r.getSize(new T.Vector2()), pr = r.getPixelRatio(), bg = _st.scene.background, tgt = r.getRenderTarget();
    var cc = r.getClearColor(new T.Color()), ca = r.getClearAlpha();
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    try {
      /* white paper: the clear colour, not a background the tone mapping greys */
      r.setRenderTarget(null); r.setPixelRatio(1); r.setSize(W, H, false);
      _st.scene.background = null; r.setClearColor(0xffffff, 1);
      r.render(_st.scene, cam);
      var g = c.getContext('2d'); g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, H);
      g.drawImage(r.domElement, 0, 0, W, H);
    } finally {
      _st.scene.background = bg; r.setClearColor(cc, ca); r.setPixelRatio(pr); r.setSize(keep.x, keep.y, false); r.setRenderTarget(tgt);
    }
    return c;
  }
  /* HOW MUCH COLOUR A SHEET SHOWS (v28, Marek: na kazde strance posuvnik od
     black and white po full color, netiskne se): 0 the line drawing, 100
     the model in colour, between the two laid over each other. Every sheet
     has its own, the menu's colour icon sets them all; the PDF prints each
     sheet as it is set. On the page both pictures are in the sheet and the
     slider only changes how much of the drawing lies over the colour. */
  var _blend = {};
  function blendOf(key) { return (_blend[key] != null) ? _blend[key] : (_look.color ? 100 : 0); }
  function picInto(doc, G, fit, dpmm, key, x, y, w, h) {
    var bl = blendOf(key), lines = linesCanvas(G, fit, dpmm);
    if (doc instanceof SvgDoc) {
      doc.addImage(colorCanvas(G, fit, dpmm).toDataURL('image/jpeg', 0.88), 'JPEG', x, y, w, h);
      var e = doc.addImage(lines.toDataURL('image/jpeg', 0.9), 'JPEG', x, y, w, h);
      e.setAttribute('opacity', String(1 - bl / 100)); e.setAttribute('data-ink', key);
      return;
    }
    var out = lines;
    if (bl > 0) {
      var col = colorCanvas(G, fit, dpmm);
      out = document.createElement('canvas'); out.width = col.width; out.height = col.height;
      var g = out.getContext('2d'); g.drawImage(col, 0, 0);
      if (bl < 100) { g.globalAlpha = 1 - bl / 100; g.drawImage(lines, 0, 0, col.width, col.height); g.globalAlpha = 1; }
    }
    doc.addImage(out.toDataURL('image/jpeg', 0.9), 'JPEG', x, y, w, h);
  }

  /* =========================================================================
     THE ROOM PLAN (v46, Marek 2026-10-29 21:45: "u vsech projektu floorplan
     mistnosti, vcetne barevneho cleneni mistnosti (dle ux.liquid section) a
     legendy, vcetne vymer u jednotlivych mistnosti. Bez fitouts. Mel by byt
     mezi prvnimi vykresy. Plati pro vsechny projekty s floorplans")
     One sheet per storey right after the isometric: the floor plan's cut
     (no fitouts, no dimension strings, no section marks), every room filled
     in its colour from the floorplan asset's table (FloorplanLib.draw --
     the colours the ux page shows, a bathroom the same blue in every
     product) at 40 % on the paper, a closet in the asset's closet grey; the
     line drawing over it (multiplied, so the walls stay crisp); each room's
     name and its clear floor area (inside the walls: the outline's walls,
     half a partition); the legend beside the plan (a landscape sheet) or
     under it (a portrait one): the colour, the name and the area of every
     room, largest first, and the inner floor area of the storey. Its own
     scale (the largest the plan fits beside its legend), no slider.
     Products whose rooms the asset does not hold (the container) get none.
     ========================================================================= */
  var CLOSET_FILL_BP = '#EEF0F2';   /* the asset's CLOSET_FILL */
  function roomsHere() {
    if (_lib && _lib.planStoreys) return false;
    var FL = global.FloorplanLib, RM = [];
    if (!FL || !FL.plan || !FL.plan.rooms || !FL.draw) return false;
    try { RM = FL.plan.rooms() || []; } catch (e) { RM = []; }
    return RM.some(function (r) { return r && r.rects && r.rects.length; });
  }
  function areaTxt(a) { return isMetric() ? (a.toFixed(1) + ' m\u00B2') : (Math.round(a * 10.7639) + ' sq ft'); }
  function tint40(h) { var c = hexRGB(h); return '#' + c.map(function (v) { var w = Math.round(0.4 * v + 0.6 * 255).toString(16); return w.length < 2 ? '0' + w : w; }).join(''); }
  /* a room's clear boxes: each rectangle less the outline's wall on an
     outside side, half a partition on an inside one, nothing where it runs
     on into another rectangle of the same room */
  function roomBoxes(r, A) {
    var R = A.rect, wt = A.wallThk || 0.15, pt = partThk(), Q = r.rects || [], out = [];
    function onOutline(vert, at, a, b) {
      if (A.edges && A.edges.length) {
        for (var k = 0; k < A.edges.length; k++) {
          var e = A.edges[k];
          if (vert && Math.abs(e.x0 - e.x1) < 0.01 && Math.abs(e.x0 - at) < 0.03 && Math.min(e.z0, e.z1) < b - 0.01 && Math.max(e.z0, e.z1) > a + 0.01) return true;
          if (!vert && Math.abs(e.z0 - e.z1) < 0.01 && Math.abs(e.z0 - at) < 0.03 && Math.min(e.x0, e.x1) < b - 0.01 && Math.max(e.x0, e.x1) > a + 0.01) return true;
        }
        return false;
      }
      return vert ? (Math.abs(at - R.x0) < 0.02 || Math.abs(at - R.x1) < 0.02) : (Math.abs(at - R.z0) < 0.02 || Math.abs(at - R.z1) < 0.02);
    }
    function joined(q, side) {
      for (var k = 0; k < Q.length; k++) {
        var o = Q[k]; if (o === q) continue;
        var oz = o.z0 < q.z1 - 0.01 && o.z1 > q.z0 + 0.01, ox = o.x0 < q.x1 - 0.01 && o.x1 > q.x0 + 0.01;
        if (side === 'x0' && oz && Math.abs(o.x1 - q.x0) < 0.02) return true;
        if (side === 'x1' && oz && Math.abs(o.x0 - q.x1) < 0.02) return true;
        if (side === 'z0' && ox && Math.abs(o.z1 - q.z0) < 0.02) return true;
        if (side === 'z1' && ox && Math.abs(o.z0 - q.z1) < 0.02) return true;
      }
      return false;
    }
    function ins(q, side, vert, at, a, b) { return joined(q, side) ? 0 : (onOutline(vert, at, a, b) ? wt : pt / 2); }
    Q.forEach(function (q) {
      var b = { x0: q.x0 + ins(q, 'x0', true, q.x0, q.z0, q.z1), x1: q.x1 - ins(q, 'x1', true, q.x1, q.z0, q.z1),
                z0: q.z0 + ins(q, 'z0', false, q.z0, q.x0, q.x1), z1: q.z1 - ins(q, 'z1', false, q.z1, q.x0, q.x1) };
      if (b.x1 > b.x0 + 0.01 && b.z1 > b.z0 + 0.01) out.push(b);
    });
    return out;
  }
  /* the storey's rooms: name, colour, boxes, clear area */
  function roomList(A) {
    var FL = global.FloorplanLib, RM = [], out = [];
    if (!FL || !FL.plan || !FL.plan.rooms || !FL.draw) return out;
    try { RM = FL.plan.rooms() || []; } catch (e) { RM = []; }
    var T = (FL.draw.roomTable ? FL.draw.roomTable() : FL.draw.ROOMS) || [], n = T.length || 1;
    RM.forEach(function (r, i) {
      if (!r || !r.rects || !r.rects.length) return;
      var ix = 0, nm = '';
      try { ix = FL.plan.roomNameIdx ? FL.plan.roomNameIdx(r, i) : (r.nameIdx | 0); } catch (eI) { ix = r.nameIdx | 0; }
      try { nm = String(FL.draw.roomName(ix, roomT) || ''); } catch (eN) { nm = ''; }
      var row = T[(((ix | 0) % n) + n) % n] || {}, col = r.closet ? CLOSET_FILL_BP : (row.col || '#9CCC9E');
      var bx = roomBoxes(r, A), a = 0;
      bx.forEach(function (b) { a += (b.x1 - b.x0) * (b.z1 - b.z0); });
      out.push({ i: i, name: nm, col: col, fill: r.closet ? col : tint40(col), boxes: bx, area: a, closet: !!r.closet });
    });
    roomCodes(out);
    return out;
  }
  /* v47 (Marek 2026-10-29 22:22: dvojpismenou zkratku na stred mistnosti,
     stejnou zkratku do legendy): two letters from the room's own name in
     the page's language -- the initials of a name of two words or more,
     else its first two letters; a different name that would get the same
     two keeps its first letter and takes the next one free; a name twice
     on the storey is numbered by size (BE1, BE2) */
  function roomCodes(list) {
    var words = function (nm) { return String(nm || '').toLocaleUpperCase().split(/[^\p{L}\p{N}]+/u).filter(Boolean); };
    var cnt = {}, taken = {}, byName = {}, seen = {};
    list.forEach(function (r) { var k = String(r.name || '-'); cnt[k] = (cnt[k] || 0) + 1; });
    list.slice().sort(function (a, b) { return b.area - a.area; }).forEach(function (r) {
      var k = String(r.name || '-');
      if (!byName[k]) {
        var W = words(k), ch = W.length ? Array.from(W.join('')) : ['?'], c0 = ch[0], code = null, j;
        var first = (W.length >= 2) ? (Array.from(W[0])[0] + Array.from(W[1])[0]) : (c0 + (ch[1] || ''));
        if (!taken[first]) code = first;
        for (j = 1; !code && j < ch.length; j++) if (!taken[c0 + ch[j]]) code = c0 + ch[j];
        for (j = 2; !code; j++) if (!taken[first + j]) code = first + j;
        taken[code] = 1; byName[k] = code;
      }
      seen[k] = (seen[k] || 0) + 1;
      r.code = byName[k] + (cnt[k] > 1 ? String(seen[k]) : '');
    });
  }
  /* the picture: white paper, the rooms in their colours, the line drawing
     multiplied over them */
  function roomsCanvas(G2, fit, dpmm, list, A) {
    var lines = linesCanvas(G2, fit, dpmm), W = lines.width, H = lines.height, T = global.THREE;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var g = c.getContext('2d'); g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, H);
    var cam = sheetCam(G2.area, fit), V = new T.Vector3(), y = (typeof A.floor === 'number') ? A.floor : 0;
    var px = function (x, z) { V.set(x, y, z).project(cam); return [(V.x + 1) / 2 * W, (1 - V.y) / 2 * H]; };
    list.forEach(function (rm) {
      g.fillStyle = rm.fill;
      rm.boxes.forEach(function (b) {
        var p0 = px(b.x0, b.z0), p1 = px(b.x1, b.z1);
        g.fillRect(Math.min(p0[0], p1[0]), Math.min(p0[1], p1[1]), Math.abs(p1[0] - p0[0]), Math.abs(p1[1] - p0[1]));
      });
    });
    g.globalCompositeOperation = 'multiply'; g.drawImage(lines, 0, 0, W, H); g.globalCompositeOperation = 'source-over';
    return c;
  }
  /* the legend (v47: one column right of the plan, the rooms one under
     another): colour, code, name, area; the storey's inner floor area */
  function roomsLegend(doc, bx, rows) {
    var dz = _dz, lab = dz.label || '#6B7280', rule = dz.rule || '#1A1C1D', zebra = dz.zebra || null, txt = dz.text || '#1A1C1D';
    var x = bx.x0, y = bx.y0, RH = 6.6, tot = 0;
    pdfText(doc, pw('title', legendLabel('title')).toUpperCase(), x, y + 2, 1.9, { align: 'left', c: lab });
    y += 4.5; pdfLine(doc, { c: rule, pw: 0.5 }, x, y, bx.x1, y); y += 1.2;
    rows.forEach(function (r, k) {
      tot += r.area;
      var yy = y + k * RH;
      if (zebra && k % 2 === 0) fillRect(doc, zebra, x, yy, bx.x1 - x, RH);
      fillRect(doc, r.fill, x + 1.5, yy + 1.3, 7, RH - 2.6);
      var bc = hexRGB(r.closet ? '#C9CDD2' : r.col); doc.setDrawColor(bc[0], bc[1], bc[2]); doc.setLineWidth(0.25); doc.setLineDashPattern([], 0); doc.rect(x + 1.5, yy + 1.3, 7, RH - 2.6);
      pdfText(doc, pw('', r.code || '-'), x + 10.5, yy + RH / 2, 2.6, { bold: true, align: 'left', c: txt });
      /* a long name (another language) written smaller to keep off the area */
      var at = areaTxt(r.area), nmL = pw('', (r.name || '-').toLocaleUpperCase()), room = bx.x1 - 1.5 - textWidthMm(at, true, 2.2) - 2 - (x + 19), fs = 2.1;
      while (fs > 1.4 && textWidthMm(nmL, false, fs) > room) fs -= 0.1;
      pdfText(doc, nmL, x + 19, yy + RH / 2, fs, { align: 'left', c: txt });
      pdfText(doc, at, bx.x1 - 1.5, yy + RH / 2, 2.2, { bold: true, align: 'right', c: txt });
    });
    y += rows.length * RH + 1.5; pdfLine(doc, { c: rule, pw: 0.5 }, x, y, bx.x1, y); y += 4;
    pdfText(doc, pw('area', (L.legend && L.legend.area) || 'Inner floor area').toUpperCase(), x, y, 1.9, { align: 'left', c: lab });
    pdfText(doc, areaTxt(tot), bx.x1 - 1.5, y, 2.8, { bold: true, align: 'right', c: txt });
  }
  /* v47 (Marek 2026-10-29 22:22: floorplan spise na landscape a legendu na
     pravou stranu, klasicke zobrazeni = mistnosti pod sebe): the plan left,
     the legend a column at the right of the drawing area; the sheet is
     landscape (sheetRun picks the side or the foot title block, whichever
     draws the plan the larger) */
  var ROOMS_LW = 60, _roomsNote = '';   /* the legend column, mm (5 mm from the plan's area) */
  function roomsPlace(G, A, R) {
    var ar = G.area, a = { x0: ar.x0, y0: ar.y0, x1: ar.x1 - ROOMS_LW - 5, y1: ar.y1 }, b = { x0: ar.x1 - ROOMS_LW, y0: ar.y0 + 2, x1: ar.x1, y1: ar.y1 }, k;
    a.w = a.x1 - a.x0; a.h = a.y1 - a.y0; a.cx = (a.x0 + a.x1) / 2; a.cy = (a.y0 + a.y1) / 2;
    var G2 = {}; for (k in G) if (G.hasOwnProperty(k)) G2[k] = G[k]; G2.area = a;
    var P = { G2: G2, lb: b, fit: null, scale: null, j: R.LST.length };
    if (_st.camera.isOrthographicCamera && A) {
      _roomsMode = true;   /* the plan's own extent, without the section marks' */
      try {
        P.tries = [];
        for (var j = 0; j < R.LST.length; j++) { var f = sheetFit(G2, R.LST[j][0], A, R.M, R.DP, false); if (f) P.tries.push(R.LST[j][1] + ' ' + f.rw.toFixed(2) + 'x' + f.rh.toFixed(2)); if (f && f.fits) { P.fit = f; P.scale = R.LST[j]; P.j = j; break; } }
        if (!P.fit) { P.scale = R.LST[R.LST.length - 1]; P.fit = sheetFit(G2, P.scale[0], A, R.M, R.DP, false); }
      } finally { _roomsMode = false; }
    }
    return P;
  }
  /* v48: the room's middle -- the centroid of all its rectangles; when that
     falls outside the room (an L), the nearest point well inside one of
     them (30 cm or a quarter of its size from its sides) */
  function roomMid(boxes) {
    var A = 0, cx = 0, cz = 0;
    boxes.forEach(function (b) { var a = (b.x1 - b.x0) * (b.z1 - b.z0); A += a; cx += a * (b.x0 + b.x1) / 2; cz += a * (b.z0 + b.z1) / 2; });
    if (!(A > 0)) return null;
    cx /= A; cz /= A;
    var inside = boxes.some(function (b) { return cx >= b.x0 + 0.05 && cx <= b.x1 - 0.05 && cz >= b.z0 + 0.05 && cz <= b.z1 - 0.05; });
    if (inside) return [cx, cz];
    var best = null;
    boxes.forEach(function (b) {
      var mx = Math.min(0.3, (b.x1 - b.x0) / 4), mz = Math.min(0.3, (b.z1 - b.z0) / 4);
      var px = Math.max(b.x0 + mx, Math.min(b.x1 - mx, cx)), pz = Math.max(b.z0 + mz, Math.min(b.z1 - mz, cz)), d = (px - cx) * (px - cx) + (pz - cz) * (pz - cz);
      if (!best || d < best.d) best = { d: d, p: [px, pz] };
    });
    return best ? best.p : null;
  }
  function drawRoomsSheet(doc, G, it, R) {
    var A = anchors(), list = A ? roomList(A) : [];
    var rows = list.slice().sort(function (a, b) { return b.area - a.area; });
    var PP = roomsPlace(G, A, R), G2 = PP.G2, a2 = G2.area, fit = PP.fit, scale = PP.scale;
    var used = { visible: 1 };
    if (fit) {
      doc.addImage(roomsCanvas(G2, fit, R.dpmm, list, A).toDataURL('image/jpeg', 0.9), 'JPEG', a2.x0, a2.y0, a2.w, a2.h);
      /* the code in the middle of each room -- v48 (Marek 2026-10-29 22:43:
         "Dvojpismenne oznaceni neni na stredu mistnosti"): the asset keeps a
         room as several rectangles and v47 took the largest one's middle
         (the living room's right strip); now the middle of the whole room */
      var CP = [];
      list.forEach(function (rm) {
        var c = roomMid(rm.boxes);
        if (!c || !rm.code) return;
        var u = fit.F.uv(c[0], 0, c[1]), p = fit.F.px(u[0], u[1]);
        CP.push({ t: 't', s: rm.code, x: p[0], y: p[1], code: true });
      });
      _roomsMode = true;
      try { var RP = refPrims(fit.F, A, R.M, fit.VB); used = RP.used; pdfPrims(doc, RP.prims.concat(CP)); } finally { _roomsMode = false; }
    }
    roomsLegend(doc, PP.lb, rows);
    log('rooms   ' + it.view + ': ' + list.length + ' room(s) coloured -- ' + rows.map(function (r) { return (r.code || '-') + ' ' + (r.name || '-') + ' ' + areaTxt(r.area) + (r.closet ? ' (closet)' : ''); }).join(', ') + (scale ? (', scale ' + scale[1]) : '') + ', ' + (G.portrait ? 'portrait' : (G.tbBottom ? 'landscape, block at the foot' : 'landscape')) + ' (tried ' + (PP.tries || []).join(', ') + ')');
    _roomsNote = it.view + ' ' + rows.length + ' room(s), ' + (scale ? scale[1] : '-') + ', tried ' + (PP.tries || []).join(', ');
    sheetTail(doc, G, it, R, used, scale);
  }

  /* ONE SHEET, on whichever doc: the drawing, its vectors, the frame and
     the title block (framed) or the title alone under it (clean) */
  function drawSheet(doc, G, it, R) {
    if(it.technical){it.technical.draw(doc,G.area);sheetTail(doc,G,it,R,{visible:1},null);return;}
    if (it.rooms) { drawRoomsSheet(doc, G, it, R); return; }
    var A = anchors(), ortho = _st.camera.isOrthographicCamera, fit = null, scale = null;
    if (ortho && A) { scale = R.LST[R.common]; fit = sheetFit(G, scale[0], A, R.M, R.DP, _dimsOn); }
    picInto(doc, G, fit, R.dpmm, it.view, G.area.x0, G.area.y0, G.area.w, G.area.h);
    var used = { visible: 1 };
    if (fit) {
      var RP = refPrims(fit.F, A, R.M, fit.VB);
      used = RP.used;
      pdfPrims(doc, RP.prims.concat(_dimsOn ? fit.Lo.prims : []));
    }
    sheetTail(doc, G, it, R, used, scale);
  }
  /* the title under the drawing, the title block and the frame (v46: shared
     with the room plan) */
  function sheetTail(doc, G, it, R, used, scale) {
    var vn = viewName(it.view, it), title = pw(vn.key, vn.s), number = sheetNumber(it.view, R.nums, it);
    var ty = G.area.y1 + 6.5, tw0 = pdfText(doc, title.toUpperCase(), G.area.x0, ty, G.clean ? 3.6 : 3.8, { bold: true, align: 'left', c: _dz.caption || null });
    pdfLine(doc, { c: _dz.under || '#1A1C1D', pw: _dz.under ? 0.8 : 0.5 }, G.area.x0, ty + 2.8, G.area.x0 + Math.max(50, tw0), ty + 2.8);
    if (scale) pdfText(doc, pw('scale', L.pdf.scale) + '  ' + scale[1], G.area.x0, ty + 5.8, 2.4, { align: 'left', c: _dz.caption || null });
    dzTag(doc, G);
    if (G.clean) { if (number) pdfText(doc, number, G.area.x1, ty, 3.6, { bold: true, align: 'right', c: _dz.num || null }); return; }
    (G.tbBottom ? titleBlockH : titleBlock)(doc, G, { project: R.base.project, customer: R.base.customer, id: R.base.id, used: used, tb: R.base.tb,
                         metric: R.metric, unitsLabel:it.technical?'Units as labelled; schematic':null, scaleLabel: scale ? scale[1] : '', k: scale ? 1000 / scale[0] : 0, date: R.base.date,
                         title: title, number: number, page: R.page, pages: R.base.pages });
    dzFrame(doc, G);
  }
  /* THE TITLE BLOCK ACROSS THE FOOT of a portrait sheet (v28): four
     columns -- who (the user's block or LEVA), the project, the legend, the
     scale and the sheet -- the same contents as the block down the side */
  function titleBlockH(doc, G, info) {
    if (_dz.table) { titleBlockTable(doc, G, info); return; }
    var dz = _dz, tb = G.tb, gray = dz.label || '#6B7280', T0 = info.tb || {}, W0 = tb.x1 - tb.x0, dark = !!dz.dark;
    var cx = [tb.x0, tb.x0 + W0 * 0.27, tb.x0 + W0 * 0.52, tb.x0 + W0 * 0.76, tb.x1], i;
    _txtC = dz.text || null;
    if (dz.fill) fillRect(doc, dz.fill, tb.x0, tb.y0, W0, tb.y1 - tb.y0);
    if (dz.band && !tbHas(T0)) fillRect(doc, dz.band.bg, cx[0], tb.y0, cx[1] - cx[0], tb.y1 - tb.y0);
    if (dz.sep !== null) for (i = (dz.band && !tbHas(T0)) ? 2 : 1; i < 4; i++) pdfLine(doc, dz.sep || { c: '#1A1C1D', pw: 0.25 }, cx[i], tb.y0, cx[i], tb.y1);
    function lab(t, x, y) { pdfText(doc, t.toUpperCase(), x, y, 1.7, { align: 'left', c: gray }); }
    /* 1: who */
    var x = cx[0] + 4, y = tb.y0 + 5, cw = cx[1] - cx[0] - 8;
    if (dz.band && !tbHas(T0)) {
      pdfText(doc, 'LEVA', x, y + 6, 8, { bold: true, align: 'left', c: dz.band.fg });
      pdfText(doc, 'theleva.com', x, y + 13, 2.4, { align: 'left', c: dz.band.sub });
    } else if (tbHas(T0)) {
      if (T0.logo && T0.logoW && T0.logoH) {
        var ks = Math.min(cw / T0.logoW, 11 / T0.logoH), lw = T0.logoW * ks, lh = T0.logoH * ks;
        try { doc.addImage(T0.logo, /^data:image\/png/.test(T0.logo) ? 'PNG' : 'JPEG', x, y, lw, lh); } catch (eL) { notesAdd('logo: ' + (eL && eL.message)); }
        y += lh + 4;
      } else y += 2;
      if (T0.company) { pdfText(doc, pw('', T0.company), x, y, 2.8, { bold: true, align: 'left' }); y += 3.8; }
      if (T0.name) { pdfText(doc, pw('', T0.name), x, y, 2.2, { align: 'left' }); y += 3.2; }
      ['phone', 'email', 'web'].forEach(function (f) { if (T0[f] && y < tb.y1 - 6) { pdfText(doc, pw('', T0[f]), x, y, 2.0, { align: 'left' }); y += 3; } });
      pdfText(doc, 'LEVA  \u00B7  theleva.com', x, tb.y1 - 3, 1.7, { align: 'left', c: gray });
    } else {
      pdfText(doc, 'LEVA', x, y + 6, 8, { bold: true, align: 'left' });
      pdfText(doc, 'theleva.com', x, y + 13, 2.4, { align: 'left', c: gray });
    }
    /* 2: the project, units, date */
    x = cx[1] + 4; y = tb.y0 + 5;
    lab(pw('project', L.pdf.project), x, y);
    y += 4.4; pdfText(doc, info.project, x, y, 2.8, { bold: true, align: 'left' });
    if (info.customer) { y += 4; pdfText(doc, info.customer, x, y, 2.2, { align: 'left' }); }
    y += 4; pdfText(doc, 'theleva.com/pages/blueprints?p=' + info.id, x, y, 1.6, { align: 'left', c: gray });
    y += 6; pdfText(doc, (info.unitsLabel || pw(info.metric ? 'mm' : 'ftin', info.metric ? L.pdf.mm : L.pdf.ftin)), x, y, 2.0, { align: 'left' });
    y += 5; lab(pw('date', L.pdf.date), x, y);
    y += 4; pdfText(doc, info.date, x, y, 2.4, { align: 'left' });
    /* 3: the legend */
    x = cx[2] + 4; y = tb.y0 + 5;
    lab(pw('title', legendLabel('title')), x, y);
    LEGEND_ORDER.forEach(function (kk) {
      if (!info.used[kk] || y > tb.y1 - 6) return;
      y += 4.1;
      legendSample(doc, kk, x, y, 9, 2.4, dark);
      pdfText(doc, cap(pw(kk, legendLabel(kk))), x + 11, y, 2.0, { align: 'left' });
    });
    /* 4: the scale and the sheet */
    x = cx[3] + 4; y = tb.y0 + 5;
    var cw4 = cx[4] - cx[3] - 8;
    if (info.scaleLabel) {
      lab(pw('scale', L.pdf.scale), x, y);
      y += 4.4; pdfText(doc, info.scaleLabel, x, y, 2.8, { bold: true, align: 'left' });
      y += 3;
      scaleBar(doc, info, x, y, cw4, 1.4, 1.7);
    }
    pdfText(doc, info.title.toUpperCase(), x, tb.y1 - 15, 2.4, { bold: true, align: 'left' });
    pdfText(doc, info.number, x, tb.y1 - 5, 6.4, { bold: true, align: 'left', c: dz.num || null });
    pdfText(doc, info.page + ' / ' + info.pages, cx[4] - 3, tb.y1 - 5, 2.0, { align: 'right', c: gray });
    _txtC = null;
  }
  /* THE SET, start to end: the views (the + PDF list or the whole set), the
     common scale, the cover, every sheet. o.out 'pdf' or 'svg'; o.doc(n)
     gives the doc of sheet n; o.done(n, doc, it) takes it when drawn;
     o.gen: a newer run makes this one stop between two sheets. */
  var ABORT = { abort: true };
  function setViews(keepModes) {
    var nSt = nPlans(), plans = [], q, out = [];
    if (nSt > 1) { for (q = 1; q <= nSt; q++) plans.push('plan' + q); } else plans.push('plan');
    var mk = function (v) { return { view: v, dims: _dimsOn ? _dimsMode : 'off', layers: keepModes }; };
    out.push(mk('iso'));
    /* v46 (Marek 2026-10-29 21:45: u vsech projektu floorplan mistnosti,
       vcetne barevneho cleneni mistnosti (dle ux.liquid) a legendy, vcetne
       vymer; bez fitouts; mezi prvnimi vykresy): a room plan per storey
       right after the isometric, before the dimensioned floor plans */
    if (roomsHere()) plans.forEach(function (v) { out.push({ view: v, rooms: true, dims: 'off', layers: keepModes }); });
    plans.forEach(function (v) { out.push(mk(v)); });
    ['front', 'back', 'left', 'right', 'secX', 'secZ'].forEach(function (v) { out.push(mk(v)); });
    if(_lib.technicalSheets) _lib.technicalSheets().forEach(function(s){out.push({view:'plan',dims:'off',layers:keepModes,technical:s});});
    return out;
  }
  /* the furniture layers (role fitout). v37 (Marek 2026-10-29: blueprints
     vzdy bez fitouts): off on every sheet, the plan too, and on the live
     view; not offered in the drawer (v28 kept them in the plan) */
  function fitoutLayers() {
    var out = [];
    try { (_lib.blueprintPackage().layers || []).forEach(function (l) { if (l && (l.role === 'fitout' || /fitout/.test(l.id))) out.push(l.id); }); } catch (e) {}
    return out;
  }
  function fitOff() {
    var n = 0, M = {};
    try { M = _lib.layerModes ? _lib.layerModes() : {}; } catch (e) { M = {}; }
    fitoutLayers().forEach(function (id) { if (M[id] !== 'off') { try { _lib.setLayerMode(id, 'off'); n++; } catch (e2) {} } });
    return n;
  }
  function sheetRun(o) {
    var metric = isMetric(), G = sheetGeomFor(metric, false);
    var keepView = _view, keepDims = [_dimsOn, _dimsMode], keepModes = JSON.parse(JSON.stringify(_lib.layerModes ? _lib.layerModes() : {}));
    var items = (o.items && o.items.length) ? o.items : setViews(keepModes);
    /* v29: in the package the first sheet is the list of pages, framed or clean */
    var PK = (o.pkg && pkgReady()) ? pkgPlan(items.length) : null;
    var cover = !!o.cover && (!G.clean || !!PK), TB0 = tbLoad(), pages = items.length + (cover ? 1 : 0);
    var LST = metric ? SCALES_M : SCALES_I, index = [], nums0 = { a0: 0, a1: 0, a2: 0, a3: 0 }, FIT = fitoutLayers();
    /* the shapes a sheet can take: landscape with the block at the side or
       at the foot, portrait with it at the foot (clean: two, no block) */
    var SH = [sheetGeomFor(metric, false), sheetGeomFor(metric, true)];
    if (_look.frame) SH.push(sheetGeomP(metric, false, true, true));
    items.forEach(function (it) { index.push({ n: sheetNumber(it.view, nums0, it), t: viewName(it.view, it) }); });
    var R = { G: G, LST: LST, common: 0, M: null, DP: null, metric: metric, nums: { a0: 0, a1: 0, a2: 0, a3: 0 }, page: 0, dpmm: o.dpmm || DPMM, base: null, pages: pages, cover: cover, geo: [], pk: PK };
    if (o.begin) o.begin(pages, G, PK);
    _ts = G.clean ? 1.2 : 1;
    _svgOut = o.out === 'svg';
    _building = true;
    function check() { if (o.gen != null && o.gen !== _sheetGen) throw ABORT; }
    function apply(it) {
      if(it.technical){_dimsOn=false;return;}
      var k, cur = _lib.layerModes ? _lib.layerModes() : {};
      for (k in cur) if (cur.hasOwnProperty(k) && !(it.layers || {}).hasOwnProperty(k)) _lib.setLayerMode(k, 'on');
      for (k in (it.layers || {})) if (it.layers.hasOwnProperty(k)) _lib.setLayerMode(k, it.layers[k]);
      /* the furniture: off on every sheet (v37) */
      FIT.forEach(function (id) { _lib.setLayerMode(id, 'off'); });
      _dimsOn = it.dims !== 'off'; if (_dimsOn) _dimsMode = it.dims;
      _inApply = true;
      try { setView(it.view); } finally { _inApply = false; }
    }
    function finish() {
      var k, cur = _lib.layerModes ? _lib.layerModes() : {};
      for (k in cur) if (cur.hasOwnProperty(k)) _lib.setLayerMode(k, keepModes[k] || 'on');
      FIT.forEach(function (id) { _lib.setLayerMode(id, 'off'); });
      _dimsOn = keepDims[0]; _dimsMode = keepDims[1];
      _inApply = true;
      try { setView(keepView); } catch (eV) {} finally { _inApply = false; }
      _building = false; _svgOut = false; _ts = 1; _dz = DZS.A; _txtC = null;
    }
    /* the largest standard scale at which a view fits a sheet of shape Gx */
    function bestJ(Gx, A) {
      var j;
      for (j = 0; j < LST.length; j++) { var ft = sheetFit(Gx, LST[j][0], A, R.M, R.DP, _dimsOn); if (ft && ft.fits) return j; }
      return LST.length - 1;
    }
    var chain = Promise.resolve().then(function () {
      R.DP = paperStyle(o.doc(-1, G));
      R.M = dimLayers();
      /* THE COMMON SCALE AND EACH SHEET'S TURN: every square-on view tried
         landscape and portrait; the common scale is the largest at which
         every view fits one way or the other, and each sheet then takes the
         way its drawing fills the more at that scale */
      var c2 = Promise.resolve(), idx = 0, J = [];
      items.forEach(function (it, n) {
        c2 = c2.then(function () { check(); if (o.step) o.step('scale', n, items.length); apply(it); return wait(o.out === 'svg' ? 0 : 30); }).then(function () {
          if(it.technical){J[n]=null;return;}
          var A = anchors();
          if (!_st.camera.isOrthographicCamera || !A) { J[n] = null; return; }
          J[n] = SH.map(function (Gx) { return bestJ(Gx, A); });
          var mn = Math.min.apply(null, J[n]);
          if (mn > idx) idx = mn;
        });
      });
      return c2.then(function () {
        R.common = idx;
        R.best = items.map(function (it, n) { return it.view + ' ' + (J[n] ? LST[Math.min.apply(null, J[n])][1] : '-'); });
        /* the shape of each sheet at the common scale: of those it fits, the
           one whose drawing area is shaped most like the drawing */
        var c4 = Promise.resolve();
        items.forEach(function (it, n) {
          /* v47: the room plan always landscape -- the side block or the foot
             one (framed), whichever draws the plan beside its legend larger */
          if (it.rooms) {
            c4 = c4.then(function () { check(); apply(it); return wait(0); }).then(function () {
              var A = anchors(), cands = [0], bestR = null;
              if (SH[2] && !SH[2].portrait) cands.push(2);
              cands.forEach(function (si) { var P = roomsPlace(SH[si], A, R); if (!bestR || P.j < bestR.j) bestR = { si: si, j: P.j }; });
              R.geo[n] = SH[bestR ? bestR.si : 0];
            });
            return;
          }
          if (!J[n]) { R.geo[n] = SH[0]; return; }
          var ok = []; J[n].forEach(function (j, si) { if (j <= idx) ok.push(si); });
          if (ok.length <= 1) { R.geo[n] = SH[ok.length ? ok[0] : 0]; return; }
          c4 = c4.then(function () { check(); apply(it); return wait(0); }).then(function () {
            var A = anchors(), best = null;
            ok.forEach(function (si) {
              var ft = sheetFit(SH[si], LST[idx][0], A, R.M, R.DP, _dimsOn); if (!ft) return;
              var sc = Math.abs(Math.log(Math.max(1e-3, ft.rw) / Math.max(1e-3, ft.rh)));
              if (!best || sc < best.sc - 0.02) best = { sc: sc, si: si };
            });
            R.geo[n] = SH[best ? best.si : ok[0]];
          });
        });
        return c4;
      });
    }).then(function () {
      var date = '';
      try { date = new Date().toLocaleDateString(BOOT.locale || undefined); } catch (eD) { date = ''; }
      if (!_svgOut && !fontOk(date)) date = new Date().toISOString().slice(0, 10);
      var A0 = anchors(true);
      var proj = pdfTitle() + (A0 && A0.rect ? ('  ' + fmtD(A0.rect.x1 - A0.rect.x0) + ' x ' + fmtD(A0.rect.z1 - A0.rect.z0)) : '');
      R.base = { project: pw('', proj), customer: BOOT.customerName ? pw('', BOOT.customerName) : '', id: readP() || '', metric: metric, date: date, tb: TB0, pages: PK ? PK.total : pages };
      var c3 = Promise.resolve();
      if (cover) {
        c3 = c3.then(function () { check(); if (o.step) o.step('sheet', 0, pages); apply({ view: 'iso', dims: _dimsOn ? _dimsMode : 'off', layers: keepModes }); return wait(o.out === 'svg' ? 0 : 30); })
               .then(function () {
                 check(); var d0 = o.doc(0, G);
                 _dz = dzFor(0);
                 if (PK) { R.page = (PK.nL || 0) + 2; contentsSheet(d0, G, R.base, index, R.dpmm, PK); } else { R.page = 1; coverSheet(d0, G, R.base, index, R.dpmm); }
                 _dz = DZS.A;
                 o.done(0, d0, { view: 'cover' }, G);
               });
      }
      items.forEach(function (it, n0) {
        var n = n0 + (cover ? 1 : 0);
        c3 = c3.then(function () { check(); if (o.step) o.step('sheet', n, pages); apply(it); return wait(o.out === 'svg' ? 0 : 30); })
               .then(function () { check(); var Gn = R.geo[n0] || G, d = o.doc(n, Gn); R.page = n + 1 + (PK ? 1 + (PK.nL || 0) + (PK.nI || 0) : 0); if (o.dpmmFor) R.dpmm = o.dpmmFor(Gn); _dz = dzFor(n); drawSheet(d, Gn, it, R); _dz = DZS.A; o.done(n, d, it, Gn); });
      });
      return c3;
    }).then(function () { finish(); return R; }, function (err) { finish(); throw err; });
    R.items = items;
    return chain;
  }

  /* =========================================================================
     THE PACKAGE (v29, Marek: blueprints se otevre po druhem zmacknuti pdf
     tlacitka a vygeneruje se na strance komplet to, co je ted v pdf, prave
     s blueprints; prvni strana zustane product image, na druhou stranu
     seznam stran -- blueprints 3-8, bill of quantities, shopping list, cut
     list ...)

     The configurator's paid PDF tap keeps the document's arguments in this
     browser (indexedDB leva-pkg, by the project's id, core-v731) and opens
     this page. Here the exporter makes its pages from them (pdf-pkg-v1: the
     document handed back, not saved), and the package is
       1        the exporter's cover (the product image)
       2        the list of pages (contentsSheet)
       3 ...    the blueprints, these sheets
       then     the bill of quantities, the shopping list, the cut list and
                the exporter's other sheets (set-out, roof, trusses, ...);
                its own plan and wall sheets are left out, the blueprints
                draw them.
     On the page the exporter's pages are pictures (pdf.js) before and after
     the sheets; the PDF icon saves the whole package as one file (pdf-lib),
     the page numbers written on the exporter's pages. No package for the
     project in this browser and the page is the drawings alone, as before.
     ========================================================================= */
  var PDFJS_URL = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js';
  var PDFJS_WORKER = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
  var PDFLIB_URL = 'https://cdn.jsdelivr.net/npm/pdf-lib@1.17.1/dist/pdf-lib.min.js';
  var _pkg = null, _bootDone = false;
  function loadScript(src, ready) {
    if (ready()) return Promise.resolve();
    return new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = src;
      sc.onload = function () { if (ready()) res(); else rej(new Error('loaded without its global: ' + src)); };
      sc.onerror = function () { rej(new Error('could not load ' + src)); };
      document.head.appendChild(sc);
    });
  }
  function pdfLib() {
    var X = global.ConfiguratorPdfExporter;
    if (X && typeof X._loadPdfLib === 'function') return X._loadPdfLib();
    return loadScript(PDFLIB_URL, function () { return !!(global.PDFLib && global.PDFLib.PDFDocument); }).then(function () { return global.PDFLib; });
  }
  function pdfJs() {
    return loadScript(PDFJS_URL, function () { return !!global.pdfjsLib; }).then(function () {
      try { global.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; } catch (e) {}
      return global.pdfjsLib;
    });
  }
  function pkgGet(id) {
    return new Promise(function (ok) {
      var rq;
      try { rq = global.indexedDB.open('leva-pkg', 1); } catch (e) { ok(null); return; }
      rq.onupgradeneeded = function () { try { rq.result.createObjectStore('pkg'); } catch (eU) {} };
      rq.onerror = function () { ok(null); };
      rq.onsuccess = function () {
        var db = rq.result, g;
        try { g = db.transaction('pkg', 'readonly').objectStore('pkg').get(id); } catch (eT) { db.close(); ok(null); return; }
        g.onsuccess = function () { db.close(); ok(g.result || null); };
        g.onerror = function () { db.close(); ok(null); };
      };
    });
  }
  function pkgReady() { return !!(_pkg && _pkg.state === 'ready'); }
  function pkgWaiting() { return !!(_pkg && (_pkg.state === 'looking' || _pkg.state === 'making')); }
  function pkgStart(id) {
    if (!id || !global.indexedDB) return;
    var t0 = Date.now();
    _pkg = { state: 'looking', note: 'looking for it' };
    _pkg.p = pkgGet(id).then(function (rec) {
      if (!rec || !rec.args) {
        _pkg = null;
        log('package none in this browser for ' + id + (wentBack() ? ' -- the product page made none (bpback)' : '') + ' -- the drawings alone');
        return null;
      }
      _pkg.rec = rec; _pkg.state = 'making'; _pkg.note = 'making';
      var X = global.ConfiguratorPdfExporter;
      if (!X || typeof X.export !== 'function') throw new Error('no exporter on the page');
      return loadJs(JSPDF_URL).then(function () {
        var a = JSON.parse(JSON.stringify(rec.args)), PL = L.pkg || {};
        a.__returnDoc = true;
        /* the exporter's set-out, roof, services and joinery sheets say what
           they are (in the configurator's PDF they all read Plan), the same
           words as the list of pages */
        if (!a.setOutTitle && PL.setout) a.setOutTitle = PL.setout;
        if (!a.roofPlanTitle && PL.roofplan) a.roofPlanTitle = PL.roofplan;
        if (!a.mepTitle && PL.elec) a.mepTitle = PL.elec;
        if (!a.joineryTitle && PL.joinery) a.joineryTitle = PL.joinery;
        return X.export(a);
      }).then(function (res) {
        if (!res || !res.doc || !res.sections) throw new Error('the exporter handed no document back (' + (X.PKG_VERSION || 'an exporter before pdf-pkg-v1') + ')');
        _pkg.X = res; _pkg.bytes = res.doc.output('arraybuffer');
        return pkgLead(rec, res).then(function () { return res; });
      }).then(function (res) {
        _pkg.state = 'ready';
        /* v30: a buyer of the project sees it all */
        if (rec.owner) unlock('the configurator says this buyer owns the project');
        _pkg.note = 'ready -- ' + res.pages + ' exporter page(s): ' + res.sections.map(function (q) { return q.kind + ' ' + q.from + (q.to > q.from ? ('-' + q.to) : ''); }).join(', ') +
                    ' | kept ' + Math.round((Date.now() - (rec.at || Date.now())) / 60000) + ' min ago by ' + (rec.core || '?') + ' | ' + res.version + ', ' + (Date.now() - t0) + ' ms';
        log('package ' + _pkg.note);
        return _pkg;
      });
    }).catch(function (err) {
      if (_pkg) { _pkg.state = 'failed'; _pkg.note = 'FAILED ' + ((err && err.message) || err) + ' -- the drawings alone'; log('package ' + _pkg.note); }
      return null;
    }).then(function (r) {
      /* the sheets wait for it once the page is up; before that the page's
         first view draws them */
      if (_bootDone) scheduleSheets(0);
      return r;
    });
  }
  /* =========================================================================
     THE PACKAGE FROM THE LINK ALONE (v37; v36 tried a hidden frame of the
     product page -- measured live 2026-10-29 on GitHub Actions: Shopify's
     page written into a frame runs its scripts out of order, the product
     lib found no ConfiguratorCore and nothing was made in 150 s. Marek
     2026-10-29: chci vizualizaci kompletniho pdf na blueprints - i to co
     jsme meli v puvodnim PDF - main page s product picture, cut lists,
     shopping lists, BOQ; blueprints jsou pak rozsireni)

     The package is made on the product's page (its catalogue, its prices,
     its product image), and kept in the browser that made it. A link to
     this page in a browser with no package for the project now goes there
     first: /products/<handle>?p=<id>&bppkg=1 (BLUEPRINT_URLS, liquid v22).
     The configurator covers itself ("Making the PDF..."), keeps the very
     package its PDF tap keeps (core-v767, no tokens) and comes back here
     with &bpback=1 -- the full package then: product picture, list of
     pages, the drawings, bill of quantities, shopping list, cut list and
     the frame / truss / foundation / roof sheets. Back without one (any
     failure) -> the drawings alone, never round again. Only the products
     the configurator packages; ?doc= documents are untouched.
     ========================================================================= */
  function mkUrl() { var U = global.BLUEPRINT_URLS || {}, slug = _proj && _proj.product; return (slug && U[slug]) ? String(U[slug]) : ''; }
  function wentBack() { try { return new URL(global.location.href).searchParams.get('bpback') === '1'; } catch (e) { return false; } }
  /* true when this visit goes to the product page for its package */
  function pkgAsk(id) {
    var base = mkUrl();
    if (!id || !base || wentBack() || !global.indexedDB) return Promise.resolve(false);
    return pkgGet(id).then(function (rec) {
      if (rec && rec.args) return false;
      var to = base + (base.indexOf('?') < 0 ? '?' : '&') + 'p=' + encodeURIComponent(id) + '&bppkg=1';
      log('package none in this browser for ' + id + ' -- made on the product page first: ' + to + ' (v37)');
      status((L.pdf && L.pdf.making) || 'Making the PDF...');
      igKeep();
      try { global.location.replace(to); } catch (e) { return false; }
      return true;
    }, function () { return false; });
  }
  /* THE PRODUCT'S OWN DOCUMENTATION FIRST (v38, Marek 2026-10-29: takto u
     vsech produktu - i Taurusy). The configurator hands it as
     args.prependPdf { url, label } (core-v769; TAURUS: Matt's TAURUS II
     drawings for its buyers and the admin, through leva-scrape /doc): its
     pages go in front of the exporter's (one document, the sections moved
     on), shown and saved before the cover. Not readable -> without them,
     the log says why. */
  function pkgLead(rec, res) {
    var P = (rec.args && rec.args.prependPdf) || null;
    if (!(P && P.url) || !global.fetch) return Promise.resolve();
    return pdfLib().then(function (PL) {
      return global.fetch(P.url, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.arrayBuffer();
      }).then(function (ob) {
        return Promise.all([PL.PDFDocument.create(), PL.PDFDocument.load(ob, { ignoreEncryption: true }), PL.PDFDocument.load(_pkg.bytes.slice(0))]);
      }).then(function (dd) {
        var out = dd[0], A = dd[1], E = dd[2];
        return Promise.all([out.copyPages(A, A.getPageIndices()), out.copyPages(E, E.getPageIndices())]).then(function (cp) {
          cp[0].forEach(function (pg) { out.addPage(pg); });
          cp[1].forEach(function (pg) { out.addPage(pg); });
          return out.save();
        }).then(function (bytes) {
          var n = A.getPageCount();
          _pkg.bytes = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
          res.sections = [{ kind: 'original', from: 1, to: n, title: P.label || '' }].concat(res.sections.map(function (q) {
            var o = {}, k; for (k in q) if (q.hasOwnProperty(k)) o[k] = q[k]; o.from = q.from + n; o.to = q.to + n; return o;
          }));
          res.pages = (res.pages || 0) + n;
          log('package the original in front -- ' + (P.label || '?') + ', ' + n + ' page(s)');
        });
      });
    })['catch'](function (e) { log('package the original NOT in front (' + ((e && e.message) || e) + ') -- the package without it'); });
  }
  /* the package's pages: which exporter page goes where, and its number */
  function pkgPlan(nSheets) {
    var X = _pkg.X, args = (_pkg.rec && _pkg.rec.args) || {}, PL = L.pkg || {}, cover = null, groups = [], by = {};
    var ORDER = ['boq', 'shopping', 'cut'];
    function keyOf(q) {
      var k = q.kind;
      if (k === 'plan' || /^elev:/.test(k)) return null;   /* the blueprints draw them */
      if (k === 'boq') return ['boq', PL.boq];
      if (k === 'shopping') return ['shopping', PL.shopping];
      if (k === 'cutListVisual') return ['cut', PL.cut];
      if (/^(userView|userSnap):|^(view3d|view2d|snapshotOrthos|isometric|orthos|baseAssembly)$/.test(k)) return ['views', PL.views];
      if (/^truss:/.test(k)) { var T0 = (args.trussSheets || [])[parseInt(k.slice(6), 10)] || {}; return T0.kind === 'panel' ? ['panels', PL.panels] : ['truss', PL.truss]; }
      if (k === 'setout') return ['setout', PL.setout];
      if (k === 'joinery') return ['joinery', PL.joinery];
      if (k === 'elec') return ['elec', PL.elec];
      if (k === 'roofplan') return ['roofplan', PL.roofplan];
      if (/^buildups:/.test(k)) return ['buildups', args.buildUpTitle || q.title];
      return [k, q.title || k];
    }
    var lead = [];
    X.sections.forEach(function (q) {
      if (q.kind === 'original') { for (var lp = q.from; lp <= q.to; lp++) lead.push(lp - 1); return; }
      if (q.kind === 'cover') { if (!cover) cover = q; return; }
      var kk = keyOf(q); if (!kk) return;
      var g = by[kk[0]];
      if (!g) { g = by[kk[0]] = { key: kk[0], label: kk[1] || q.title || kk[0], idx: [] }; groups.push(g); }
      /* v39: the variant's own picture leads the views */
      var add = []; for (var pp = q.from; pp <= q.to; pp++) add.push(pp - 1);
      g.idx = (q.kind === 'baseAssembly') ? add.concat(g.idx) : g.idx.concat(add);
    });
    groups.forEach(function (g, i) { g.o = ORDER.indexOf(g.key) < 0 ? 10 + i : ORDER.indexOf(g.key); });
    groups.sort(function (a, b) { return a.o - b.o; });
    /* v39 (Marek 2026-10-29: kompletne vcetne uvodu - product picture,
       variant picture (pokud je) atd.): the pictures -- the variant's own and
       the views chosen with + PDF -- open the package after the sheet index,
       before the drawings; the bill, shopping list, cut list and the rest
       after the drawings as before */
    var INTRO = { views: 1 }, introG = groups.filter(function (g) { return INTRO[g.key]; }), post = groups.filter(function (g) { return !INTRO[g.key]; });
    var nL = lead.length, n = nL + 2, intro = [], order = [], num = {}, PA = args.prependPdf || {};
    introG.forEach(function (g) { g.from = n + 1; g.idx.forEach(function (i) { n++; intro.push(i); num[i] = n; }); g.to = n; });
    n += nSheets;
    post.forEach(function (g) { g.from = n + 1; g.idx.forEach(function (i) { n++; order.push(i); num[i] = n; }); g.to = n; });
    return { lead: lead, nL: nL, leadLabel: nL ? ((/metric/i.test(PA.label || '') ? PL.docMet : PL.docImp) || PA.label || '') : '',
             intro: intro, nI: intro.length, introGroups: introG,
             cover: cover ? cover.from - 1 : 0, groups: post, order: order, num: num, total: n, nSheets: nSheets, sig: nL + '|' + intro.join(',') + '|' + nSheets + '|' + order.join(',') };
  }
  /* the exporter's pages with the package's page numbers written on them */
  function pkgStamp(PK) {
    if (_pkg.stamp && _pkg.stamp.sig === PK.sig) return _pkg.stamp.p;
    var p = pdfLib().then(function (PL) {
      return PL.PDFDocument.load(_pkg.bytes.slice(0)).then(function (D) {
        return D.embedFont(PL.StandardFonts.HelveticaBold).then(function (f) {
          var pages = D.getPages(), MM = 72 / 25.4;
          (PK.intro || []).concat(PK.order).forEach(function (i) {
            var pg = pages[i]; if (!pg) return;
            var sz = pg.getSize(), t = PK.num[i] + ' / ' + PK.total, w = f.widthOfTextAtSize(t, 8);
            pg.drawText(t, { x: sz.width - 12 * MM - w, y: sz.height - 10 * MM, size: 8, font: f, color: PL.rgb(160 / 255, 145 / 255, 120 / 255) });
          });
          return D.save();
        });
      });
    });
    _pkg.stamp = { sig: PK.sig, p: p };
    p['catch'](function () { if (_pkg && _pkg.stamp && _pkg.stamp.p === p) _pkg.stamp = null; });
    return p;
  }
  /* the page's three parts: the exporter's cover, the sheets, the rest */
  function sheetBox(k) {
    var host = sheetsHost(); if (!host) return null;
    var el = $('bp-sheets-' + k);
    if (!el) {
      el = document.createElement('div'); el.id = 'bp-sheets-' + k; el.className = 'bp-part';
      if (k === 'pre') host.insertBefore(el, host.firstChild);
      else if (k === 'post') host.appendChild(el);
      else host.insertBefore(el, $('bp-sheets-post') || null);
    }
    return el;
  }
  /* v39: the pictures' place -- inside the sheets, right after the sheet index */
  function introBox() {
    var mid = $('bp-sheets-mid'), el = $('bp-sheets-intro');
    if (!el) { el = document.createElement('div'); el.id = 'bp-sheets-intro'; el.className = 'bp-part'; }
    var first = _cards[0];
    if (mid && first && first.parentNode === mid) { if (el.parentNode !== mid || el.previousSibling !== first) mid.insertBefore(el, first.nextSibling); }
    else if (!el.parentNode) { var post = sheetBox('post'); if (post && post.parentNode) post.parentNode.insertBefore(el, post); }
    return el;
  }
  function pkgCardsClear() {
    ['pre', 'intro', 'post'].forEach(function (k) { var el = $('bp-sheets-' + k); if (el) el.innerHTML = ''; });
    if (_pkg) _pkg.cardsSig = '';
  }
  function pkgCards(PK) {
    if (!pkgReady() || _pkg.cardsSig === PK.sig) return;
    _pkg.cardsSig = PK.sig;
    var nL = PK.nL || 0, nI = PK.nI || 0, pre = sheetBox('pre'), post = sheetBox('post'), ib = introBox(), want = (PK.lead || []).concat([PK.cover]).concat(PK.intro || []).concat(PK.order), cards = [], t0 = Date.now();
    /* v42: each page says what it is (the ?ig reel stops by it) */
    var kindOf = {}; (PK.groups || []).forEach(function (g) { g.idx.forEach(function (i) { kindOf[i] = g.key; }); });
    pre.innerHTML = ''; ib.innerHTML = ''; post.innerHTML = '';
    want.forEach(function (i, j) {
      var c = document.createElement('div'); c.className = 'bp-card xp wait'; c.style.aspectRatio = '297 / 210';
      c.setAttribute('data-page', j <= nL ? String(j + 1) : String(PK.num[i]));
      c.setAttribute('data-kind', j < nL ? 'lead' : (j === nL ? 'cover' : (j <= nL + nI ? 'views' : (kindOf[i] || ''))));
      c.onclick = function () { if (c.classList.contains('bp-locked')) { if (buyCard()) return; _lock.armed = Date.now(); priceNote(); } };
      (j <= nL ? pre : (j <= nL + nI ? ib : post)).appendChild(c); cards.push(c);
    });
    lockApply();
    pkgStamp(PK).then(function (bytes) {
      return pdfJs().then(function (P) { return P.getDocument({ data: bytes.slice(0) }).promise; });
    }).then(function (D) {
      var host = sheetsHost(), dpr = Math.min(2, global.devicePixelRatio || 1), chain = Promise.resolve();
      want.forEach(function (i, j) {
        chain = chain.then(function () {
          if (!_pkg || _pkg.cardsSig !== PK.sig) return null;
          return D.getPage(i + 1).then(function (pg) {
            var vp0 = pg.getViewport({ scale: 1 }), cw = Math.max(600, Math.min((host ? host.clientWidth : 1000) - 32, 1200)) * dpr, vp = pg.getViewport({ scale: cw / vp0.width });
            var cv = document.createElement('canvas'); cv.width = Math.round(vp.width); cv.height = Math.round(vp.height);
            return pg.render({ canvasContext: cv.getContext('2d'), viewport: vp }).promise.then(function () {
              var c = cards[j];
              c.innerHTML = ''; c.appendChild(cv); c.classList.remove('wait'); c.style.aspectRatio = vp0.width + ' / ' + vp0.height;
            });
          });
        });
      });
      return chain;
    }).then(function () {
      _pkg.cardNote = want.length + ' exporter page(s) on the page in ' + (Date.now() - t0) + ' ms';
      log('package ' + _pkg.cardNote);
    }, function (err) {
      _pkg.cardNote = 'exporter pages NOT shown: ' + ((err && err.message) || err);
      log('package ' + _pkg.cardNote);
      cards.forEach(function (c) { c.classList.remove('wait'); });
    });
  }
  function saveBytes(bytes, name) {
    var blob = new Blob([bytes], { type: 'application/pdf' }), href = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = href; a.download = name; document.body.appendChild(a); a.click(); a.parentNode.removeChild(a);
    global.setTimeout(function () { URL.revokeObjectURL(href); }, 60000);
  }
  /* the one file: the exporter's cover, the list and the sheets, the rest */
  function pkgMerge(PK, sheetsBytes) {
    return Promise.all([pdfLib(), pkgStamp(PK)]).then(function (r) {
      var PL = r[0], S = r[1];
      return Promise.all([PL.PDFDocument.create(), PL.PDFDocument.load(S), PL.PDFDocument.load(sheetsBytes)]).then(function (dd) {
        var out = dd[0], Sd = dd[1], Od = dd[2];
        var nL = PK.nL || 0, nI = PK.nI || 0;
        return Promise.all([out.copyPages(Sd, (PK.lead || []).concat([PK.cover]).concat(PK.intro || []).concat(PK.order)), out.copyPages(Od, Od.getPageIndices())]).then(function (cp) {
          cp[0].slice(0, nL + 1).forEach(function (pg) { out.addPage(pg); });
          if (cp[1].length) out.addPage(cp[1][0]);
          cp[0].slice(nL + 1, nL + 1 + nI).forEach(function (pg) { out.addPage(pg); });
          cp[1].slice(1).forEach(function (pg) { out.addPage(pg); });
          cp[0].slice(nL + 1 + nI).forEach(function (pg) { out.addPage(pg); });
          return out.save();
        });
      });
    });
  }

  /* =========================================================================
     SEEN BEFORE IT IS PAID (v30, Marek: PDF jsou pod registraci / zakoupenim
     produktu, chci aby bylo PDF videt, ale ostre jen prvni 5 stranky,
     ostatni faded)

     Every page is on the screen; until the PDF is paid only the first five
     are sharp, the others faded (blurred, a lock over them, no slider, no
     live view). The PDF icon: the first tap says the price (the black token
     box, the configurator's own words), the next one takes the tokens
     through the exporter's token check (pdf-pay: signed out -> the Sign in
     card, too few -> Buy tokens) and saves the PDF; from then on the
     project is open in this browser (localStorage leva-bp-paid, 30 days).
     A buyer of the project (the configurator says owner) is open at once.
     The key: the configurator's design key from the package, else the
     project's id -- the same design again costs nothing (the worker).
     ========================================================================= */
  var FREE_PAGES = 5, PAID_KEY = 'leva-bp-paid', PAID_DAYS = 30;
  var _lock = { on: true, why: 'not paid', armed: 0 };
  function paidMap() { var o = null; try { o = JSON.parse(global.localStorage.getItem(PAID_KEY) || '{}'); } catch (e) { o = null; } return (o && typeof o === 'object') ? o : {}; }
  function paidHas(id) { var t = paidMap()[id]; return !!(t && Date.now() - t < PAID_DAYS * 86400000); }
  function paidSave(id) {
    var o = paidMap(), k, old = Date.now() - PAID_DAYS * 86400000;
    for (k in o) if (o.hasOwnProperty(k) && !(o[k] > old)) delete o[k];
    o[id] = Date.now();
    try { global.localStorage.setItem(PAID_KEY, JSON.stringify(o)); } catch (e) {}
  }
  function lockApply() {
    var host = sheetsHost(); if (!host) return;
    Array.prototype.forEach.call(host.querySelectorAll('.bp-card'), function (c) {
      var pg = parseInt(c.getAttribute('data-page'), 10) || 0;
      c.classList.toggle('bp-locked', _lock.on && pg > FREE_PAGES);
    });
  }
  function unlock(why) {
    if (!_lock.on) return;
    _lock.on = false; _lock.why = why; _lock.armed = 0;
    log('lock    open -- ' + why);
    lockApply();
  }
  function lockInit(id) {
    if (id && paidHas(id)) { _lock.on = false; _lock.why = 'paid in this browser before'; }
    /* v36 (Marek 2026-10-29: bez blur pro usera s tagem admin); v45 (21:34:
       "Proc to mam na zmkle? ... otevrit vzdy pro user s tagem admin"): the
       page's own HOUSE_BOOT read now, not the copy taken at start -- a start
       before the module had run (three.js slower than 5 s) had none */
    var HB = global.HOUSE_BOOT || BOOT || {};
    if (HB.isAdmin === true) { _lock.on = false; _lock.why = 'admin (customer tag admin)'; }
    log('lock    ' + (_lock.on ? ('the first ' + FREE_PAGES + ' pages sharp, the rest faded until the PDF is paid' + (global.HOUSE_BOOT ? (HB.customerId ? ' (signed in, no admin tag)' : ' (not signed in)') : ' (the page settings not there yet)')) : ('open -- ' + _lock.why)));
    if (_lock.on && !global.HOUSE_BOOT) lockLate();
  }
  /* v45: the page's settings came after the start -- read them then, and an
     admin opens everything as soon as they are there */
  function lockLate() {
    var n = 0, t = global.setInterval(function () {
      n++;
      var HB = global.HOUSE_BOOT;
      if (HB) {
        global.clearInterval(t);
        readBoot();
        if (HB.isAdmin === true) unlock('admin (customer tag admin; the page settings came late)');
        else log('lock    the page settings came late -- ' + (HB.customerId ? 'signed in, no admin tag' : 'not signed in') + ', stays faded');
      } else if (n > 240) global.clearInterval(t);
    }, 500);
  }
  function payKey() {
    var X = global.ConfiguratorPdfExporter, k = (_doc && _doc.rec && _doc.rec.key) || (_pkg && _pkg.rec && _pkg.rec.key);
    if (k) return k;
    return (X && typeof X._payKey === 'function') ? X._payKey('blueprints|' + curId()) : '';
  }
  /* the first tap: the price, in the configurator's words */
  function priceNote() {
    var X = global.ConfiguratorPdfExporter, PY = L.pay || {};
    if (!global.fetch || !X || typeof X.tokenInfo !== 'function') return;
    global.fetch('/apps/leva-ai/tokens', { credentials: 'same-origin', headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var tk = (j && j.tokens) || {}, n = (tk.cost && tk.cost.pdf) || 0, txt;
        if (!n) { log('lock    price unknown -- ' + ((j && j.error) || 'no pdf cost')); return; }
        if (j.customer === 'yes') txt = String(PY.price || 'The PDF takes [n] tokens, you have [b]. Tap the PDF icon again to download it.').replace('[n]', String(n)).replace('[b]', String(tk.balance || 0));
        else txt = String(PY.signup || 'The PDF takes [n] tokens. Sign up and you get [w] tokens free.').replace('[n]', String(n)).replace('[w]', String(j.welcome || 0));
        X.tokenInfo(txt, 6000);
        log('lock    the price said: ' + n + ' tokens, ' + (j.customer === 'yes' ? ('balance ' + (tk.balance || 0)) : 'signed out'));
      })['catch'](function (e) { log('lock    price check FAILED ' + ((e && e.message) || e)); });
  }
  /* the tokens, then go() */
  function payNow(go) {
    var X = global.ConfiguratorPdfExporter;
    if (!X || typeof X._paySpend !== 'function') { log('lock    no token check on the page -- open'); unlock('no token check on the page'); go(); return; }
    X._paySpend(payKey()).then(function (r) {
      if (r.go) {
        try { if (r.spent > 0) X._payToast(X._payTokensLine(r.spent, r.balance)); } catch (eT) {}
        paidSave(curId());
        unlock('paid (' + (r.how || 'the check let it through') + ', ' + (r.spent || 0) + ' tokens)');
        go();
        return;
      }
      if (r.kind === 'sign_in') X._payCard(X._paySignupLine(r.need || '', r.welcome || ''), X._paySignInBtn(r.loginUrl));
      else X.lowTokens(X._payTokensLine(r.need || '', r.balance || 0));
      log('lock    not paid -- ' + r.kind + ', nothing made');
    });
  }
  /* A DOCUMENT BOUGHT, NOT PAID IN TOKENS (v33, rack-v10-docs): a royalty
     product's document (the firewood rack -- the author is paid from its
     sales) carries rec.buy from its configurator; until the buyer owns it,
     a locked page and the PDF icon offer the purchase, never tokens */
  function buyRec() {
    if (_doc && _doc.rec && _doc.rec.buy && _doc.rec.buy.url) return _doc.rec.buy;
    /* v38: a royalty product's package (GARDEN BAR) offers its purchase too */
    if (_pkg && _pkg.rec) return (_pkg.rec.buy && _pkg.rec.buy.url) ? _pkg.rec.buy : null;
    /* and its drawings without a package: the product page, never tokens */
    var R = global.BLUEPRINT_ROYALTY || {}, slug = _proj && _proj.product, PY = L.pay || {};
    if (slug && R[slug]) return { text: PY.buyText || 'To download the PDF documentation, please purchase this product first.', btn: PY.buyBtn || 'Add to Cart', url: global.location.origin + String(R[slug]) };
    return null;
  }
  function buyCard() {
    var X = global.ConfiguratorPdfExporter, B = buyRec();
    if (!B) return false;
    if (X && typeof X._payCard === 'function') X._payCard(String(B.text || ''), { label: String(B.btn || 'Add to Cart'), href: String(B.url), newTab: false });
    else { try { global.location.href = B.url; } catch (e) {} }
    log('lock    purchase offered -- ' + B.url);
    return true;
  }
  /* the PDF icon */
  function pdfTap() {
    if (!_lock.on) { makePdf(); return; }
    if (buyCard()) return;
    if (_lock.armed && Date.now() - _lock.armed < 120000) { _lock.armed = 0; payNow(makePdf); return; }
    _lock.armed = Date.now();
    priceNote();
  }

  /* =========================================================================
     ANOTHER CONFIGURATOR'S DOCUMENT (v32, Marek 2026-10-27: PDF u vsech
     aktivnich projektu stejne, krome puvodniho Taurus a garden swing od
     Andrease). The benches, swings, fences, pool ... make their PDF on
     their own page (exporter pdf-pkg-v2: their cover, the list of pages,
     their sheets, numbered) and keep it in this browser (indexedDB leva-pkg,
     kind doc); this page shows it from ?doc=<id>: every page, the first
     five sharp, the rest faded until the PDF is paid here (the same price
     word, the same token check, the configurator's own key), then the file
     as it was made. No model, no sheets of our own, no frame switch.
     ========================================================================= */
  var _doc = null;
  function readDoc() { var v = null; try { v = new URL(global.location.href).searchParams.get('doc'); } catch (e) { v = null; } return /^d[a-z0-9]{6,24}$/.test(v || '') ? v : null; }
  function curId() { return readP() || readDoc() || ''; }
  function docStart(did) {
    var t0 = Date.now(), wrap = $('bp-wrap');
    if (wrap) wrap.classList.add('doc');
    lockInit(did);
    status('loading the document ' + did + ' ...');
    pkgGet(did).then(function (rec) {
      if (!rec || rec.kind !== 'doc' || !rec.bytes) {
        /* v38: made again where it was made (the link's src), then back here */
        var to = docSrc(did);
        if (to && !wentBack()) {
          log('doc     ' + did + ' not in this browser -- made on the product page first: ' + to + ' (v38)');
          status((L.pdf && L.pdf.making) || 'Making the PDF...');
          igKeep();
          try { global.location.replace(to); return; } catch (eR) {}
        }
        _docNote = 'NOT in this browser -- ' + did + (wentBack() ? ' (the product page made none)' : ''); status('document ' + did + ' is not in this browser'); log('doc     ' + _docNote); return;
      }
      _doc = { rec: rec };
      if (rec.owner) unlock('the configurator says this buyer owns the project');
      var N = rec.pages || 0, mid = sheetBox('mid'), cards = [], i;
      mid.innerHTML = '';
      for (i = 1; i <= N; i++) {
        var c = document.createElement('div'); c.className = 'bp-card xp wait'; c.style.aspectRatio = '297 / 210'; c.setAttribute('data-page', String(i));
        (function (cc) { cc.onclick = function () { if (cc.classList.contains('bp-locked')) { if (buyCard()) return; _lock.armed = Date.now(); priceNote(); } }; })(c);
        mid.appendChild(c); cards.push(c);
      }
      lockApply();
      return pdfJs().then(function (P) { return P.getDocument({ data: new Uint8Array(rec.bytes.slice(0)) }).promise; }).then(function (D) {
        var host = sheetsHost(), dpr = Math.min(2, global.devicePixelRatio || 1), chain = Promise.resolve();
        if (D.numPages !== N) { N = D.numPages; }
        cards.forEach(function (card, j) {
          chain = chain.then(function () {
            if (j + 1 > D.numPages) { card.parentNode && card.parentNode.removeChild(card); return null; }
            return D.getPage(j + 1).then(function (pg) {
              var vp0 = pg.getViewport({ scale: 1 }), cw = Math.max(600, Math.min((host ? host.clientWidth : 1000) - 32, 1200)) * dpr, vp = pg.getViewport({ scale: cw / vp0.width });
              var cv = document.createElement('canvas'); cv.width = Math.round(vp.width); cv.height = Math.round(vp.height);
              return pg.render({ canvasContext: cv.getContext('2d'), viewport: vp }).promise.then(function () {
                card.innerHTML = ''; card.appendChild(cv); card.classList.remove('wait'); card.style.aspectRatio = vp0.width + ' / ' + vp0.height;
              });
            });
          });
        });
        return chain;
      }).then(function () {
        _docNote = (rec.title || '?') + ' -- ' + N + ' page(s), ' + Math.round(rec.bytes.byteLength / 1024) + ' kB, made ' + Math.round((Date.now() - (rec.at || Date.now())) / 60000) + ' min ago by ' + (rec.version || '?') + ', on the page in ' + (Date.now() - t0) + ' ms';
        log('doc     ' + _docNote);
        status(_docNote);
      });
    })['catch'](function (err) { _docNote = 'FAILED ' + ((err && err.message) || err); log('doc     ' + _docNote); status('document: ' + _docNote); });
  }
  var _docNote = '';
  /* the product page that makes the document again (core-v14-bppkg puts it
     in the link as src): this shop's /products/ page only */
  function docSrc(did) {
    var src = ''; try { src = new URL(global.location.href).searchParams.get('src') || ''; } catch (e) { src = ''; }
    if (!src) return '';
    try {
      var u = new URL(src, global.location.href);
      if (u.origin !== global.location.origin || !/\/products\/[^\/]+/.test(u.pathname)) return '';
      u.searchParams.set('bppkg', '1'); u.searchParams.set('bpdoc', did);
      return u.pathname + u.search + u.hash;
    } catch (e2) { return ''; }
  }
  function docSave() {
    if (!_doc) { log('doc     nothing to save -- ' + (_docNote || 'not loaded')); return; }
    saveBytes(_doc.rec.bytes, _doc.rec.fname || ('LEVA-' + (_doc.rec.handle || 'project') + '.pdf'));
    _pdfNote = 'the document saved as made -- ' + (_doc.rec.fname || '') + ', ' + (_doc.rec.pages || '?') + ' page(s)';
    log('pdf     ' + _pdfNote);
  }

  /* ---- the sheets on the page ---- */
  var _sheetT = 0, _cards = [], _runP = null, _barBtns = null;
  function sheetsHost() { return $('bp-sheets'); }
  /* WHAT THE SHEETS ARE DRAWN FROM (v31, Marek: kdyz prejdu do vedlejsiho
     okna a pak zpet, nacitaji se u ikony pdf jakesi cisla): a window that
     comes back, the phone's address bar sliding in or out, a live view
     looked at and closed -- none of them changes a sheet, and each of them
     used to draw the whole set again (the numbers on the PDF icon are the
     sheets left to draw). The sheets are drawn again only when this
     changes: the project, the layers, the dimensions, the frame, the
     sections, the title block, the picture's resolution, the package. */
  var _lastSig = '', _runSig = '', _runModes = null;
  function sheetSig() {
    var p = '', modes = '';
    try { var pk = _lib.blueprintPackage(); p = JSON.stringify(pk.payload) + '|' + pk.units; } catch (e) { return ''; }
    try {
      /* a layer on is a layer on, set or not (a run leaves every layer set) */
      var M0 = _building && _runModes ? _runModes : (_lib.layerModes ? _lib.layerModes() : {}), mk = Object.keys(M0 || {}).sort();
      modes = mk.filter(function (k) { return M0[k] !== 'on'; }).map(function (k) { return k + ':' + M0[k]; }).join(',');
    } catch (e2) { return ''; }
    return [p, modes, _dimsOn ? _dimsMode : 'off', JSON.stringify(_dimsLayer), _look.frame ? 'frame' : 'clean',
            JSON.stringify(SEC.lines || {}), String(SEC.planH), JSON.stringify(tbLoad()), sheetDpmm(sheetGeomFor(isMetric(), false)),
            pkgReady() ? ('pkg ' + (_pkg.X && _pkg.X.pages)) : (pkgWaiting() ? 'pkg-waiting' : 'no-pkg'), 'design ' + dzMode()].join('#');
  }
  function scheduleSheets(ms) {
    if (_inApply) return;
    if (_ST && _ST.on) { _dirty = true; return; }   /* v41: not while the story rolls (its end draws them) */
    var sig = ''; try { sig = sheetSig(); } catch (eS) { sig = ''; }
    if (sig && sig === (_building ? _runSig : _lastSig)) { if (_sheetT) { global.clearTimeout(_sheetT); _sheetT = 0; } return; }
    _sheetGen++;   /* a run in flight stops at its next sheet */
    if (_mode !== 'sheets' || _pdfBusy) { _dirty = true; return; }
    if (_sheetT) global.clearTimeout(_sheetT);
    _sheetT = global.setTimeout(function () { _sheetT = 0; buildSheets(); }, ms == null ? 350 : ms);
  }
  /* the picture's resolution: what the card shows on this screen, 3 - 6 px/mm */
  function sheetDpmm(G) {
    var host = sheetsHost(), w = host ? Math.min(host.clientWidth - 32, G.portrait ? 860 : 1200) : 1000, dpr = Math.min(2, global.devicePixelRatio || 1);
    return Math.max(3, Math.min(6, Math.round(w * dpr / G.W)));
  }
  function lookProgress(t) {
    var b = _barBtns && _barBtns.pdf && _barBtns.pdf.querySelector('.leva-badge');
    if (b) { b.textContent = t || ''; b.hidden = !t; }
  }
  /* the slider on a sheet: how much of the drawing lies over the colour
     (v31, Marek: posuvnik jako jinde na webu, treba sklon strechy) -- the
     configurator's slider: its word and value over a gold track, the part
     behind the thumb gold */
  var SL_GOLD = '#c79a4a', SL_TRACK = 'rgba(0,0,0,0.10)';
  function cardBar(card, key) {
    var bar = document.createElement('div'); bar.className = 'bp-cardbar';
    var head = document.createElement('div'); head.className = 'bp-cardbar-h';
    var lab = document.createElement('span'); lab.textContent = (L.look && L.look.color) || 'Color';
    var val = document.createElement('b');
    head.appendChild(lab); head.appendChild(val);
    var rg = document.createElement('input'); rg.type = 'range'; rg.className = 'cfg-ui-slider'; rg.min = '0'; rg.max = '100'; rg.step = '1'; rg.value = String(blendOf(key));
    rg.setAttribute('aria-label', lab.textContent);
    rg.oninput = function () { _blend[key] = parseInt(rg.value, 10) || 0; inkCard(card, key); };
    ['click', 'pointerdown', 'touchstart', 'touchmove', 'mousedown'].forEach(function (ev) { bar.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true }); });
    bar.appendChild(head); bar.appendChild(rg);
    card.appendChild(bar);
    inkCard(card, key);
  }
  function inkCard(card, key, v0) {
    var v = (v0 != null) ? v0 : blendOf(key);   /* v41: the story inks a card without touching _blend */
    Array.prototype.forEach.call(card.querySelectorAll('image[data-ink]'), function (im) { im.setAttribute('opacity', String(1 - v / 100)); });
    var rg = card.querySelector('.bp-cardbar input'); if (rg && String(rg.value) !== String(v)) rg.value = String(v);
    if (rg) rg.style.background = 'linear-gradient(to right,' + SL_GOLD + ' 0%,' + SL_GOLD + ' ' + v + '%,' + SL_TRACK + ' ' + v + '%,' + SL_TRACK + ' 100%)';
    var vb = card.querySelector('.bp-cardbar-h b'); if (vb) vb.textContent = v + ' %';
  }
  function buildSheets() {
    var host = sheetsHost(); if (!host || !_lib || !_st) return;
    if (_mode !== 'sheets' || _pdfBusy) { _dirty = true; return; }
    /* v29: the package is made first -- the list of pages needs its pages */
    if (pkgWaiting()) { _dirty = true; return; }
    /* the run before ends first (it stops at its next sheet) */
    if (_building) { (_runP || Promise.resolve()).then(buildSheets, buildSheets); return; }
    var gen = _sheetGen, t0 = Date.now(), metric = isMetric(), G = sheetGeomFor(metric, false), turns = [0, 0], mid = sheetBox('mid') || host, pg0 = 1, nI0 = 0;
    var sig = ''; try { sig = sheetSig(); } catch (eS) { sig = ''; }
    if (sig && sig === _lastSig) { _dirty = false; log('sheets  nothing changed -- not drawn again'); return; }
    try { _runModes = JSON.parse(JSON.stringify(_lib.layerModes ? _lib.layerModes() : {})); } catch (eM) { _runModes = null; }
    _runSig = sig;
    _dirty = false;
    var run = sheetRun({ out: 'svg', cover: true, pkg: true, gen: gen, dpmm: sheetDpmm(G), dpmmFor: sheetDpmm,
      doc: function (n, Gn) { return new SvgDoc((Gn || G).W, (Gn || G).H); },
      begin: function (pages, G2, PK) {
        /* every sheet's place at once, so the page scrolls its full length */
        while (_cards.length < pages) { var c0 = document.createElement('div'); c0.className = 'bp-card wait'; mid.appendChild(c0); _cards.push(c0); }
        pg0 = PK ? 2 + (PK.nL || 0) : 1; nI0 = PK ? (PK.nI || 0) : 0;
        _cards.forEach(function (c1, i1) { if (!c1.firstChild) c1.style.aspectRatio = G2.W + ' / ' + G2.H; c1.style.display = i1 < pages ? '' : 'none'; c1.setAttribute('data-page', String(pg0 + i1 + ((PK && i1 > 0) ? (PK.nI || 0) : 0))); });
        /* and the exporter's pages before and after them */
        if (PK) pkgCards(PK); else pkgCardsClear();
        lockApply();
      },
      step: function (ph, n, N) { lookProgress(String(N - n)); },
      done: function (n, d, it, Gn) {
        var card = _cards[n], key = it.technical ? it.technical.number : it.rooms ? String(it.view).replace(/^plan/, 'rooms') : it.view;   /* v46 the room plan's own key */
        if (!card) { card = document.createElement('div'); mid.appendChild(card); _cards[n] = card; }
        card.style.aspectRatio = Gn.W + ' / ' + Gn.H;
        card.setAttribute('data-view', key);
        card.className = 'bp-card' + (Gn.portrait ? ' port' : '');
        /* v41: the pictures after the sheet index count too (v39 numbered the
           place, the drawn sheet lost it -- three drawings more were sharp) */
        var pgN = pg0 + n + (n > 0 ? nI0 : 0);
        card.setAttribute('data-page', String(pgN));
        card.classList.toggle('bp-locked', _lock.on && pgN > FREE_PAGES);
        turns[Gn.portrait ? 1 : 0]++;
        /* v30: a faded page says the price, it does not open */
        card.onclick = function () { if (card.classList.contains('bp-locked')) { if (buyCard()) return; _lock.armed = Date.now(); priceNote(); return; } if(it.technical)return; openLive(key === 'cover' ? 'iso' : (it.rooms ? it.view : key)); };
        while (card.firstChild) card.removeChild(card.firstChild);
        card.appendChild(d.root);
        if (!it.rooms && !it.technical) cardBar(card, key);   /* v46: the room plan has no slider (no colour model) */
      } });
    _runP = run;
    run.then(function (R) {
      /* fewer sheets than before (a storey removed): the rest go */
      while (_cards.length > R.pages) { var c = _cards.pop(); if (c && c.parentNode) c.parentNode.removeChild(c); }
      _sheetNote = R.pages + ' sheet(s) on the page' + (R.pk ? (' in the package of ' + R.pk.total + ' page(s)') : '') + ', ' + (metric ? 'A4' : 'letter') + ' ' + turns[0] + ' landscape / ' + turns[1] + ' portrait, ' + (G.clean ? 'clean' : 'frame + title block') +
                   ', colour ' + (_look.color ? 'on' : 'off') + ', scale ' + (R.LST[R.common] ? R.LST[R.common][1] : '-') + ' (each alone: ' + (R.best || []).join(', ') + '), ' + (Date.now() - t0) + ' ms';
      log('sheets  ' + _sheetNote);
      lookProgress('');
      _lastSig = sig; _runSig = ''; _runModes = null;
    }).catch(function (err) {
      _lastSig = ''; _runSig = ''; _runModes = null;
      if (err === ABORT) { if (!_sheetT) _dirty = true; return; }
      _sheetNote = 'FAILED ' + ((err && err.message) || err);
      log('sheets  ' + _sheetNote);
      lookProgress('');
    });
  }
  var _sheetNote = '';
  /* a tap on a sheet: that view, live */
  function openLive(v) {
    var wrap = $('bp-wrap'); if (!wrap) return;
    _mode = 'live'; wrap.classList.add('live');
    _ink = _look.color ? 0 : 100;
    try { global.scrollTo(0, wrap.getBoundingClientRect().top + (global.pageYOffset || 0)); } catch (eS) {}
    setView(v === 'iso' ? 'free' : v);
    applyInk();
    log('live    ' + v);
  }
  function closeLive() {
    var wrap = $('bp-wrap'); if (!wrap) return;
    var v = _view;
    _mode = 'sheets'; wrap.classList.remove('live');
    if (_dirty) scheduleSheets(0);
    var i;
    for (i = 0; i < _cards.length; i++) if (_cards[i] && _cards[i].getAttribute('data-view') === (v === 'free' ? 'iso' : v)) { try { _cards[i].scrollIntoView({ block: 'center' }); } catch (eS) {} break; }
  }
  /* THE SWITCHES IN THE FLOATING BAR (v28, Marek: jako ta dole, ikony,
     ne text): the site's own bar at the foot of the page gets three more
     round icons on this page -- colour / black & white, title block / no
     frame, the PDF -- and its gear opens the drawer here. */
  var ICO_FRAME = '<svg class="leva-act__svg" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4.5" width="18" height="15" rx="1" fill="none" stroke="#fff" stroke-width="1.8"/><path d="M15.5 4.5v15M15.5 13.5H21M15.5 9H21" stroke="#fff" stroke-width="1.6"/></svg>';
  var ICO_CLEAN = '<svg class="leva-act__svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8V4.5h3.5M17.5 4.5H21V8M21 16v3.5h-3.5M6.5 19.5H3V16" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 15l3-3.5 2 2 3-4" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICO_PDF = '<svg class="leva-act__svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M14 3.5H7a1.5 1.5 0 0 0-1.5 1.5v14A1.5 1.5 0 0 0 7 20.5h10a1.5 1.5 0 0 0 1.5-1.5V8z" fill="none" stroke="#fff" stroke-width="1.8" stroke-linejoin="round"/><path d="M14 3.5V8h4.5" fill="none" stroke="#fff" stroke-width="1.6" stroke-linejoin="round"/><path d="M12 10.5v6m0 0-2.6-2.6M12 16.5l2.6-2.6" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function barIcons(tries) {
    var group = document.querySelector('.leva-float-group');
    if (!group) { if ((tries | 0) < 40) global.setTimeout(function () { barIcons((tries | 0) + 1); }, 250); return; }
    var LK = L.look || {};
    if (!_barBtns) {
      _barBtns = {};
      var mk = function (id, bg, onClick) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'leva-icon leva-act leva-act--' + id; b.style.background = bg;
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); onClick(); });
        group.insertBefore(b, group.firstChild);
        return b;
      };
      /* inserted before the gear, last first */
      /* v31 (Marek: pdf ikonu v barve adobe pdf; ramecek nasi tmave hnedou;
         kdyz mame posuvniky, prepinac black & white / color pryc) */
      _barBtns.pdf = mk('bppdf', '#EC1C24', pdfTap);
      _barBtns.frame = mk('bpframe', '#463529', function () { _look.frame = !_look.frame; lookSave(); barIcons(); frameChanged(); });
      /* the gear: the drawer of this page instead of the central budget */
      var gear = group.querySelector('.leva-icon--central');
      if (gear) gear.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggleDrawer(); }, true);
      log('bar     icons added to the floating bar' + (gear ? ', the gear opens the drawer' : ''));
    }
    var set = function (b, svg, label) { b.innerHTML = svg + '<span class="leva-badge" hidden></span>'; b.setAttribute('aria-label', label); b.title = label; };
    set(_barBtns.frame, _look.frame ? ICO_FRAME : ICO_CLEAN, _look.frame ? (LK.frame || 'Title block') : (LK.clean || 'No frame'));
    /* v32: a document of another configurator has no sheets to frame */
    _barBtns.frame.style.display = (_mode === 'doc') ? 'none' : '';
    set(_barBtns.pdf, ICO_PDF, 'PDF');
    var bk = $('bp-back'), wrap = $('bp-wrap');
    if (!bk && wrap) {
      bk = document.createElement('button'); bk.id = 'bp-back'; bk.type = 'button'; bk.className = 'bp-back';
      bk.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      bk.onclick = closeLive;
      wrap.appendChild(bk);
    }
  }
  /* colour: every sheet already holds both pictures, only the mix changes */
  function colourChanged() {
    _ink = _look.color ? 0 : 100;
    if (_mode === 'live') applyInk();
    _cards.forEach(function (c) { var k = c.getAttribute('data-view'); if (k) inkCard(c, k); });
    log('look    colour ' + (_look.color ? 'on' : 'off'));
  }
  function frameChanged() {
    if (_mode === 'live') _dirty = true; else scheduleSheets(0);
    log('look    ' + (_look.frame ? 'frame + title block' : 'clean'));
  }
  function makePdf() {
    /* v32: another configurator's document is saved as it was made */
    if (_mode === 'doc') { docSave(); return; }
    if (_pdfBusy || !_lib || !_st) return;
    _pdfBusy = true;
    _sheetGen++;   /* a run of the sheets on the page stops first */
    var t0 = Date.now(), metric = isMetric(), G = sheetGeomFor(metric, false), TB0 = tbLoad(), first = true, delFirst = false;
    var items = _queue.length ? _queue.slice() : null;
    var making = L.pdf && L.pdf.making ? L.pdf.making : 'PDF...';
    busy(true, making);
    var doc = null, notes = (_pdfNotes = []), RR = null;
    var prev = _runP || Promise.resolve();
    /* v29: the package, when it is still being made, first */
    _runP = prev.then(null, function () {}).then(function () { return (_pkg && _pkg.p) ? _pkg.p : null; }).then(function () { return loadJs(JSPDF_URL); }).then(function () {
      var J = global.jspdf && global.jspdf.jsPDF;
      if (!J) throw new Error('jsPDF missing');
      doc = new J({ orientation: 'landscape', unit: 'mm', format: [G.W, G.H] });
      return Promise.all([fetchFont('normal'), fetchFont('bold')]).then(function (f) {
        doc.addFileToVFS('Montserrat-600.ttf', f[0]); doc.addFont('Montserrat-600.ttf', 'Montserrat', 'normal');
        doc.addFileToVFS('Montserrat-700.ttf', f[1]); doc.addFont('Montserrat-700.ttf', 'Montserrat', 'bold');
        _pdfFont = 'Montserrat';
      }).catch(function (eF) { _pdfFont = 'helvetica'; notes.push('font: ' + (eF && eF.message) + ' -- helvetica'); });
    }).then(function () {
      /* v27: the PDF is the sheets as the page shows them -- the look (colour
         or black and white, framed or clean) included */
      return sheetRun({ out: 'pdf', items: items, cover: !items, pkg: !items, dpmm: DPMM,
        /* each sheet on its own page size and turn; the page jsPDF opened
           with goes when the first sheet is portrait */
        doc: function (n, Gn) {
          Gn = Gn || G;
          if (n < 0) return doc;
          var orient = Gn.portrait ? 'portrait' : 'landscape';
          if (first) { first = false; if (Gn.W === G.W && Gn.H === G.H) return doc; delFirst = true; }
          doc.addPage([Gn.W, Gn.H], orient);
          return doc;
        },
        step: function (ph, n, N) { busy(true, making + '  ' + (n + 1) + ' / ' + N); },
        done: function () {} });
    }).then(function (R) {
      RR = R;
      if (delFirst) { try { doc.deletePage(1); } catch (eDP) { notes.push('first page: ' + eDP.message); } }
      var name = 'LEVA-' + (_proj ? _proj.product : 'project') + '-' + (readP() || 'drawings') + '.pdf';
      _pdfNote = R.pages + ' sheet(s)' + (R.cover ? ' with the cover' : '') + (tbHas(TB0) ? ', own title block' + (TB0.logo ? ' + logo' : '') : '') + ', ' +
                 (G.clean ? 'clean ' : '') + (metric ? 'A4' : 'letter') + ' ' + R.geo.filter(function (g) { return g && g.portrait; }).length + ' portrait, colour per sheet ' +
                 JSON.stringify(_blend) + ' default ' + (_look.color ? 100 : 0) +
                 ', scale ' + (R.LST[R.common] ? R.LST[R.common][1] : '-') + ', font ' + _pdfFont +
                 (notes.length ? (' | ' + notes.join(' | ')) : '') + ', ' + (Date.now() - t0) + ' ms';
      log('pdf     ' + _pdfNote);
      global.__bpLastPdf = doc;
      if (!R.pk) { doc.save(name); status('PDF: ' + name); return null; }
      /* v29: the package in one file */
      busy(true, making);
      var t1 = Date.now();
      return pkgMerge(R.pk, doc.output('arraybuffer')).then(function (bytes) {
        _pdfNote = 'package of ' + R.pk.total + ' page(s) (' + R.pages + ' sheet(s) after the cover, ' + (R.pk.introGroups || []).concat(R.pk.groups).map(function (g) { return g.key + ' ' + g.from + (g.to > g.from ? ('-' + g.to) : ''); }).join(', ') +
                   '), ' + Math.round(bytes.length / 1024) + ' kB, merged in ' + (Date.now() - t1) + ' ms | ' + _pdfNote;
        log('pdf     ' + _pdfNote);
        saveBytes(bytes, name);
        status('PDF: ' + name);
      });
    }).catch(function (err) {
      _pdfNote = 'FAILED ' + ((err && err.message) || err);
      /* the package without the sheets beats nothing (the exporter's pages as they came) */
      if (!items && pkgReady()) {
        try { saveBytes(_pkg.bytes, 'LEVA-' + (_proj ? _proj.product : 'project') + '-' + (readP() || 'drawings') + '.pdf'); _pdfNote += ' -- the exporter pages saved alone'; } catch (eS) {}
      }
      log('pdf     ' + _pdfNote);
      status('PDF failed: ' + ((err && err.message) || err));
    }).then(function () {
      _pdfBusy = false;
      busy(false);
      buildDims(); buildLayers();
      if (_dirty && _mode === 'sheets') scheduleSheets(0);
    });
  }

  /* ---------- boot ---------- */
  /* the drawer and the plus */
  function addToSheet() {
    _queue.push({ view: _view, dims: _dimsOn ? _dimsMode : 'off', layers: _lib && _lib.layerModes ? JSON.parse(JSON.stringify(_lib.layerModes())) : {} });
    buildQueue(); buildViews();
    status('view added to the sheet: ' + (L.views[_view] || _view) + ' (' + _queue.length + ' on the sheet)');
  }
  function toggleDrawer() { var dr = $('bp-drawer'); if (dr) dr.classList.toggle('open'); }
  function bindChrome() {
    var open = $('bp-open'), close = $('bp-close'), dr = $('bp-drawer'), plus = $('bp-plus'), upd = $('bp-update');
    /* the floating bar at the bottom calls these on this page */
    global.LevaBudgetIcons = global.LevaBudgetIcons || {};
    global.LevaBudgetIcons.bpdrawer = toggleDrawer;
    global.LevaBudgetIcons.bplog = copyLog;
    /* UPDATE: the newest project of the same product from the diary the
       configurator keeps (its every save writes the new id first) */
    if (upd) upd.onclick = function () {
      var d = diary(), cur = readP(), prod = _proj ? _proj.product : null, i;
      for (i = 0; i < d.length; i++) {
        if (prod && d[i].product !== prod) continue;
        if (d[i].id === cur) { status('already the newest project of ' + prod); return; }
        try { var u = new URL(global.location.href); u.searchParams.set('p', d[i].id); global.location.href = u.toString(); } catch (e) {}
        return;
      }
      status('no newer project of ' + (prod || '?') + ' in the diary');
    };
    if (open && dr) open.onclick = function () { dr.classList.toggle('open'); };
    if (close && dr) close.onclick = function () { dr.classList.remove('open'); };
    if (plus) plus.onclick = addToSheet;
    var mk = $('bp-make'); if (mk) mk.onclick = pdfTap;
    /* a new size of the window frames the view again */
    var _rsT = 0;
    global.addEventListener('resize', function () {
      if (_rsT) global.clearTimeout(_rsT);
      _rsT = global.setTimeout(function () { _rsT = 0; if (!_st || !_lib) return; if (_mode === 'live') setView(_view); else scheduleSheets(); }, 250);
    });
  }
  function buildQueue() {
    var host = $('bp-queue'); if (!host) return;
    host.innerHTML = '';
    if (!_queue.length) { host.textContent = '-'; return; }
    _queue.forEach(function (q, i) {
      var row = document.createElement('div');
      var nm = document.createElement('span'); nm.textContent = (i + 1) + '. ' + (L.views[q.view] || q.view) + (q.dims !== 'off' ? (' + ' + q.dims) : '');
      var rm = document.createElement('button'); rm.className = 'bp-btn'; rm.textContent = 'x';
      rm.onclick = function () { _queue.splice(i, 1); buildQueue(); };
      row.appendChild(nm); row.appendChild(rm);
      host.appendChild(row);
    });
  }
  /* NOTHING FLOATS OVER THE BAR. The status lives in the drawer and shows
     for a moment as a toast at the top left. The Copy log and SEND LOG
     buttons are gone (blueprints-v50, Marek 2026-10-31: admin logs
     buttons uz nepotrebujeme); copyLog and sendLog stay for the code. */
  var _toastTimer = 0;
  function toast(m) {
    var t = $('bp-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'bp-toast';
      t.style.cssText = 'position:absolute;left:16px;top:76px;z-index:20;max-width:46vw;padding:8px 12px;border-radius:10px;' +
        'background:rgba(255,255,255,0.94);color:#1A1C1D;font:600 11px Montserrat,sans-serif;box-shadow:0 2px 10px rgba(0,0,0,0.15);white-space:pre-wrap;';
      var wrap = $('bp-wrap') || document.body;
      wrap.appendChild(t);
    }
    t.textContent = m; t.style.display = '';
    if (_toastTimer) global.clearTimeout(_toastTimer);
    _toastTimer = global.setTimeout(function () { t.style.display = 'none'; }, 5000);
  }
  function start() {
    var id = readP(), did = readDoc();
    igBack(); storyMount();   /* v41 the ?ig story */
    /* v32: another configurator's document (?doc=) -- no model here */
    if (did) _mode = 'doc';
    bindChrome();
    _look = lookLoad(); _ink = _look.color ? 0 : 100;
    try { barIcons(); } catch (eLk) { log('bar icons THREW ' + ((eLk && eLk.message) || eLk)); }
    buildViews(); buildDims(); buildQueue();
    if (did) { docStart(did); return; }
    if (!id) { status('No project in the link (?p=...). Open the drawings from a configurator share link.'); fillProjects(null); return; }
    status('loading project ' + id + ' ...');
    fetchProject(id).then(function (p) {
      /* the product's name; p.product is the settings bag, not the name */
      var product = (typeof p.productName === 'string' && p.productName) ||
                    (typeof p.product === 'string' ? p.product : null) || 'adu';
      _proj = { id: id, product: product, label: product.toUpperCase() + ' ' + (p.footprint ? (Math.round(p.footprint.w * 100) / 100 + ' x ' + Math.round(p.footprint.l * 100) / 100) : '') };
      diaryAdd(id, product, _proj.label);
      fillProjects(_proj);
      /* v37: no package in this browser -> the product page makes it first */
      return pkgAsk(id).then(function (away) {
        if (away) return new Promise(function () {});
        status('loading ' + product + ' ...');
        /* v51: the project, for a lib with a product switch to read before it
           is loaded (the shed lib's RUSSWORX SHED: his drawings from his
           shed, not from the SHED's rules) -- nothing else reads it */
        try { global.LEVA_BP_PROJECT = p; } catch (eBP) {}
        return loadLib(product);
      });
    }).then(function (lib) {
      if (!lib || !lib.boot) throw new Error('HouseLib missing after load');
      _lib = lib;
      var ok = lib.boot();
      if (ok === false) throw new Error('boot returned false');
      _st = global.ConfiguratorStage || null;
      /* v30: what is open before the PDF is paid */
      lockInit(id);
      /* v29: the package the configurator kept for this project, if any */
      try { pkgStart(id); } catch (ePk) { log('package THREW ' + ((ePk && ePk.message) || ePk)); }
      secLoad();
      try { buildTitleUI(); } catch (eTB) { log('title block form THREW ' + ((eTB && eTB.message) || eTB)); }
      /* the project arrives through the lib's own ?p= path; give it a moment
         to land and rebuild, then frame the first view */
      /* after every build of the lib (an Update, a late payload) the ink and
         the section are put back */
      /* blueprints-v17: a project that lands after the first frame (a lib
         that fetches ?p= itself, the container) gets its layers and its line
         too -- once its build is in, not only at the 1.2 s mark */
      var _readyT = 0, _readyOnce = false;
      try { if (lib.afterBuild) lib.afterBuild.push(function () {
        /* a rebuild (units flipped) brings the grid back: off again */
        global.setTimeout(function () { try { secEnsure(); } catch (eSE) {} if (SEC.on) secMaterials(); hideGrid(); applyInk(); }, 30);
        if (fitOff()) log('fitouts off (v37, a build turned them on)');
        if (!_readyOnce) return;
        if (_readyT) global.clearTimeout(_readyT);
        _readyT = global.setTimeout(function () { _readyT = 0; buildLayers(); readyLine(); redraw(); }, 300);
      }); } catch (eAB) {}
      global.setTimeout(function () {
        hideGrid();
        bindInk();
        log('fitouts off on the drawings (v37): ' + fitOff() + ' layer(s)');
        buildLayers();
        setView(_view);
        _readyOnce = true; _bootDone = true;
        readyLine();
      }, 1200);
      function readyLine() {
        /* WHAT ARRIVED: the proof of the bridge in one line -- the payload
           the page got, as the lib sees it */
        var line = (lib.VERSION || '') + ' ready -- project ' + id;
        try {
          var pk = lib.blueprintPackage ? lib.blueprintPackage() : null, p = pk && pk.payload;
          if (p) {
            var prod = p.product || {};
            line += ' | ' + (p.footprint ? (p.footprint.w + ' x ' + p.footprint.l + ' m') : '?') +
                    ' | roof ' + (p.roof ? (p.roof.type + ' ' + p.roof.pitch) : '?') +
                    ' | openings ' + ((p.openings || []).length) +
                    ' | partitions ' + ((p.parts || []).length) + ' doors ' + ((p.doors || []).length) +
                    ' | fitouts ' + ((prod.fixtures || []).length) +
                    ' | colours ' + JSON.stringify(prod.colors || {}) +
                    ' | trees ' + (p.trees && p.trees.list ? Object.keys(p.trees.list).map(function (k) { return k + ':' + p.trees.list[k].length; }).join(',') : '-') +
                    ' | layers ' + pk.layers.length + ' | units ' + pk.units;
          }
        } catch (e) { line += ' | package failed: ' + (e && e.message); }
        /* said once per change, so a rebuild with nothing new says nothing */
        if (line === readyLine.last) return;
        readyLine.last = line;
        status(line);
      }
    }).catch(function (err) {
      status('Failed: ' + (err && err.message));
      log('failed: ' + (err && err.message));
    });
  }
  /* ==== THE ?ig REEL AND THE ?ig2 STORY (blueprints-v41, v42, v43) =========
     v41 (Marek 2026-10-29 18:42: "Udelej mi prosim tlacitko play a projet
     cely blueprint, vcetne ukazky posuvniku dratovy - brevny pohled. Bez
     voice over, dam to zatim jako Story, do 15 sec, ale cele idealne.")
     v42 (Marek 19:50: "Udelej ale plynulou animaci, nezrychlovat. Posuvnik
     vzdy jen jednim smerem. Udelej rovnou i voice over, zvlast pro
     blueprints, zvlast pro cut lists, shopping list a boQ, mame tam i u ADU
     wall frame a roof details / jednotlive prvky. Dva odkazy, jeden s voice
     over, vzdy se zastavi na relevantni strance. Druhy bez, plynula animace
     pres cely dokument.")
     v43 (Marek 20:15: "Story bez hlasu je extremne rychla. Musis pomaleji.
     Posuvniky plynule, jak prochazi snimace, a muzes jen u prvnich dvou.
     Jestli jde tak udelej zoom in a out na title shopping list / boQ
     atd"): the story at 1.2 pages a second (faster only when that would
     run past 58 s), 0.6 s to get going and to stop; at the first page of
     every part after the drawings (bill of quantities, shopping list, cut
     list, wall frames, trusses, foundation, roof ...) it stops with the
     page's title 40 % down the screen, ZOOMS IN on the title (x 2.2 round
     its left end, 0.6 s), holds 0.5 s, zooms out (0.6 s) and goes on --
     the reel does the same on its pages while the clip speaks. Only the
     FIRST TWO DRAWINGS move their slider, smoothly while they cross the
     screen (from their top at 80 % of the screen to their bottom at 20 %),
     one way; the other sheets keep their own value.
     v44 (Marek 20:30: "Ten zoom in /out muzes udelat i s voice over a o
     kousek vetsi zoom in"): the zoom kept in the reel, x 2.6 (was 2.2).
     A page opened with ?ig or ?ig2 (layout/theme.liquid ig-v1 / ig-v4: no
     admin buttons or logs) gets a PLAY at the bottom middle, 12 px above the
     site's floating bar, once every page is drawn. As on every ?ig post
     (Marek 2026-10-27): the tap takes the page to its first page and hides
     the PLAY, 2 s nothing, then:
     ?ig2  THE STORY, silent: an even scroll from the first page to the
           last (v43: 1.2 pages a second, the zoom stops on the parts'
           titles); nothing faster, no way back.
     ?ig   THE REEL, voiced (English, Roger, leva-voice clips bp-ig-*), each
           clip on its own page, the page held while it speaks:
             the first page (the product)      bp-ig-intro
             the first drawing                 bp-ig-drawings -- its slider
                                               at the line drawing for the
                                               first sentence, to the full
                                               model during the second
             the bill of quantities            bp-ig-boq
             the shopping list                 bp-ig-shopping
             the cut list                      bp-ig-cut
             the wall frames                   bp-ig-walls
             the roof trusses                  bp-ig-roof
           (the parts the document has, in its order), on to the last page,
           a fade to the first page, ig-outro there. Between the pages one
           even speed (2.8 pages a second, 0.3 s to start and to stop). The
           clip's words as subtitles in the lower third (the tours' ?ig
           size), from the voice worker's /texts/en. A clip that does not
           load: its page is held as long as its words would take.
     THE SLIDERS GO ONE WAY ONLY: when the play starts every sheet's slider
     stands at the line drawing (0 %); a sheet coming up the screen goes to
     the full model (100 %) by the time its middle is in the middle of the
     screen (300 % a second at the most), and stays there. The reel's drawing is held at 0 until its second sentence.
     The hidden 3D stage's 2-second heartbeat (a whole-model draw, 100 -
     200 ms on a tablet) is off while it plays and no sheet is redrawn
     meanwhile. At the end the sliders go back to their own values, the
     drawer stays shut, the PLAY comes back; nothing is saved.
     A link that has to make the package first (the product page and back,
     v37 / v38) keeps its ig key: sessionStorage before leaving, back into
     the address on bpback=1.
     Blueprints.story() = what it would play, story(true) plays now (no 2 s),
     story(t) = the story's frame at t ms (harness), story(false) stops. */
  var STORY_PAGES = 1.2, STORY_RAMP = 600, STORY_MAX = 58000, STORY_WAIT = 2000, IG_KEY = 'leva-bp-ig';
  var ZOOM_K = 2.6, ZOOM_IN = 600, ZOOM_HOLD = 500, ZOOM_OUT = 600;   /* v44 (Marek 20:30: o kousek vetsi zoom in) 2.2 -> 2.6 */
  /* the exporter's pages that are not a part of their own */
  var NOT_PART = { '': 1, lead: 1, cover: 1, views: 1 };
  var VOICE_URL = 'https://leva-voice.long-cloud-d006.workers.dev';
  var REEL_PAGES = 2.8, REEL_RAMP = 300;
  var REEL_CLIP = { intro: 'bp-ig-intro', drawings: 'bp-ig-drawings', boq: 'bp-ig-boq', shopping: 'bp-ig-shopping', cut: 'bp-ig-cut', panels: 'bp-ig-walls', truss: 'bp-ig-roof', outro: 'ig-outro' };
  var _ST = { btn: null, on: false, wait: false, raf: 0, P: null, sb: '', ox: '', tick: 0, tok: 0, texts: null, audio: {}, sub: null, fade: null, zs: 1, zp: null };
  function igKey() {
    try { var sp = new URLSearchParams(global.location.search); return sp.has('ig2') ? 'ig2' : (sp.has('ig') ? 'ig' : ''); }
    catch (e) { var q = String(global.location.search || ''); return /[?&]ig2(=|&|$)/.test(q) ? 'ig2' : (/[?&]ig(=|&|$)/.test(q) ? 'ig' : ''); }
  }
  function igKeep() { var k = igKey(); try { if (k) global.sessionStorage.setItem(IG_KEY, k); else global.sessionStorage.removeItem(IG_KEY); } catch (e) {} }
  function igBack() {
    if (!wentBack() || igKey()) return;
    var k = ''; try { k = global.sessionStorage.getItem(IG_KEY) || ''; global.sessionStorage.removeItem(IG_KEY); } catch (e) { k = ''; }
    if (k !== 'ig' && k !== 'ig2') return;
    global.LEVA_IG = true;
    document.documentElement.classList.add('leva-ig');
    try { var Lc = global.location; global.history.replaceState(global.history.state, '', Lc.pathname + (Lc.search ? Lc.search + '&' : '?') + k + Lc.hash); } catch (eH) {}
    log('story   back from the product page -- the ' + k + ' key put back into the address');
  }
  function storyPage() { return !!global.LEVA_IG || document.documentElement.classList.contains('leva-ig') || !!igKey(); }
  /* ?ig2 the silent story, ?ig (or an ig page without its key) the voiced reel */
  function storyMode() { return igKey() === 'ig2' ? 'story' : 'reel'; }
  function storyNow() { try { return global.performance.now(); } catch (e) { return Date.now(); } }
  function storyReady() {
    var host = sheetsHost(); if (!host) return false;
    if (_mode === 'live' || _pdfBusy || _building || _sheetT || pkgWaiting()) return false;
    if (!host.querySelector('.bp-card') || host.querySelector('.bp-card.wait')) return false;
    return true;
  }
  function storyCss() {
    if ($('bp-story-css')) return;
    var st = document.createElement('style'); st.id = 'bp-story-css';
    /* the tours' PLAY (configurator-ui / bench: #cf-tour-btn) and their ?ig subtitles */
    st.textContent =
      '#bp-story-btn{position:fixed;left:50%;bottom:97px;z-index:45;width:38px;height:38px;margin:0 0 0 -19px;border-radius:50%;border:0;padding:0;' +
      'display:inline-flex;align-items:center;justify-content:center;background:#141516;color:#ffffff;cursor:pointer;' +
      'box-shadow:0 4px 14px rgba(0,0,0,0.20);-webkit-tap-highlight-color:transparent;touch-action:manipulation;transition:opacity .2s;}' +
      '#bp-story-btn svg{width:18px;height:18px;display:block;}' +
      '#bp-story-btn[hidden]{display:none;}' +
      '#bp-story-btn.bp-idle{animation:bp-story-fade 1.6s ease-in-out infinite;}' +
      '@keyframes bp-story-fade{0%,100%{opacity:1;}50%{opacity:0.5;}}' +
      '#bp-story-btn.bp-intro{animation:bp-story-in 1.8s cubic-bezier(0.25,0.8,0.3,1) both;}' +
      '@keyframes bp-story-in{0%{transform:scale(2);opacity:0.1;}100%{transform:scale(1);opacity:1;}}' +
      '#bp-story-btn.bp-gone{opacity:0 !important;pointer-events:none !important;animation:none !important;}' +
      '@media (prefers-reduced-motion:reduce){#bp-story-btn.bp-idle,#bp-story-btn.bp-intro{animation:none;}}' +
      '#bp-story-sub{position:fixed;left:50%;bottom:24%;transform:translateX(-50%);z-index:46;box-sizing:border-box;width:max-content;max-width:calc(100% - 48px);' +
      'padding:0.32em 0.7em;border-radius:0.38em;background:rgba(20,21,22,0.80);color:#ffffff;text-align:center;' +
      "font:700 clamp(24px,4.2vw,56px)/1.22 'Montserrat',sans-serif;letter-spacing:0.01em;pointer-events:none;display:none;box-shadow:0 6px 20px rgba(0,0,0,0.20);}" +
      '#bp-story-sub.bp-on{display:block;}' +
      '@media (max-width:640px){#bp-story-sub{font-size:22px;max-width:calc(100% - 32px);}}' +
      '#bp-story-veil{position:fixed;left:0;top:0;right:0;bottom:0;z-index:44;background:#f5f5f5;opacity:0;pointer-events:none;transition:opacity .35s ease;}' +
      '#bp-story-veil.bp-on{opacity:1;}';
    document.head.appendChild(st);
  }
  function storyMount() {
    if (_ST.btn || !storyPage()) return;
    storyCss();
    var b = document.createElement('button');
    b.type = 'button'; b.id = 'bp-story-btn'; b.className = 'bp-idle'; b.hidden = true;
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.5 5.5v13l10.5-6.5z" fill="currentColor"/></svg>';
    b.setAttribute('aria-label', 'Play');
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); storyGo(); });
    document.body.appendChild(b);
    _ST.btn = b;
    _ST.tick = global.setInterval(storyTick, 700);
    if (storyMode() === 'reel') reelTexts();
    log('story   ?' + (igKey() || 'ig') + ' page: ' + (storyMode() === 'reel' ? 'the voiced reel' : 'the silent story') + ' -- the PLAY waits until every page is drawn (v43)');
  }
  /* the PLAY's place: the middle, 12 px above the floating bar */
  function storyPlace() {
    var b = _ST.btn; if (!b) return;
    var bar = document.querySelector('.leva-float-group'), bt = 25;
    try {
      var r = bar ? bar.getBoundingClientRect() : null;
      if (r && r.height > 0 && r.top < global.innerHeight) bt = Math.max(bt, Math.round(global.innerHeight - r.top + 12));
    } catch (e) {}
    b.style.bottom = bt + 'px';
  }
  function storyTick() {
    var b = _ST.btn; if (!b) return;
    var show = !_ST.on && !_ST.wait && storyReady();
    if (show && b.hidden) {
      b.hidden = false; storyPlace();
      if (!_ST.intro) { _ST.intro = true; b.classList.add('bp-intro'); global.setTimeout(function () { b.classList.remove('bp-intro'); }, 2000); }
      log('story   every page drawn -- the PLAY is there');
    } else if (!show && !b.hidden && !_ST.on && !_ST.wait) b.hidden = true;
    if (!b.hidden) storyPlace();
  }
  /* the page's cards and where each one sits */
  function storyGeo() {
    var host = sheetsHost(); if (!host) return null;
    var all = Array.prototype.filter.call(host.querySelectorAll('.bp-card'), function (c) { return c.offsetHeight > 0; });
    if (!all.length) return null;
    var vh = global.innerHeight || 800, se = document.scrollingElement || document.documentElement;
    var maxY = Math.max(0, se.scrollHeight - vh), sy = global.pageYOffset || se.scrollTop || 0;
    /* a page in the middle of the screen; one taller than the screen from its top */
    var Yof = function (c) { var r = c.getBoundingClientRect(), y = (r.height > vh - 24) ? (r.top + sy - 12) : (r.top + sy + r.height / 2 - vh / 2); return Math.max(0, Math.min(maxY, y)); };
    var hs = all.map(function (c) { return c.offsetHeight; }).sort(function (a, b) { return a - b; });
    var sl = all.filter(function (c) { return !!c.querySelector('.bp-cardbar'); });
    /* v43: only the first two drawings move their slider */
    var two = sl.filter(function (c) { return (c.getAttribute('data-view') || '') !== 'cover'; }).slice(0, 2);
    /* v43: the first page of every part after the drawings, its title's place:
       12 mm from the left, 19 mm from the top of the exporter's A4 */
    _ST.zs = 1; _ST.zp = null; host.style.transform = ''; host.style.transformOrigin = '';
    var hr = host.getBoundingClientRect(), parts = [], prev = '';
    all.forEach(function (c) {
      var k = c.getAttribute('data-kind') || '';
      if (NOT_PART[k]) { prev = k; return; }
      if (k === prev) return;
      prev = k;
      var r = c.getBoundingClientRect(), land = r.width >= r.height, ax = r.width * 12 / (land ? 297 : 210), ay = r.height * 19 / (land ? 210 : 297);
      parts.push({ c: c, kind: k, y: Math.max(0, Math.min(maxY, r.top + sy + ay - 0.4 * vh)), ox: r.left - hr.left + ax, oy: r.top - hr.top + ay });
    });
    return { all: all, vh: vh, maxY: maxY, Yof: Yof, pageH: hs[hs.length >> 1] + 26, sl: sl, parts: parts, host: host,
             ink: two.map(function (c) { return { c: c, key: c.getAttribute('data-view') || '', v: -1, hold: false, force: null }; }) };
  }
  /* the zoom on a part's title: the sheets scaled round the title's left end */
  function storyZoomSet(part, z) {
    var host = sheetsHost(); if (!host) return;
    if (!part || z <= 1.0005) {
      if (_ST.zs !== 1) { host.style.transform = ''; host.style.transformOrigin = ''; host.style.willChange = ''; _ST.zs = 1; _ST.zp = null; }
      return;
    }
    if (_ST.zp !== part) { host.style.transformOrigin = part.ox.toFixed(1) + 'px ' + part.oy.toFixed(1) + 'px'; host.style.willChange = 'transform'; _ST.zp = part; }
    host.style.transform = 'scale(' + z.toFixed(4) + ')';
    _ST.zs = z;
  }
  function storyZoomAt(u) {   /* u = ms into a zoom stop */
    if (u < ZOOM_IN) return 1 + (ZOOM_K - 1) * storySm(u / ZOOM_IN);
    if (u < ZOOM_IN + ZOOM_HOLD) return ZOOM_K;
    return ZOOM_K - (ZOOM_K - 1) * storySm((u - ZOOM_IN - ZOOM_HOLD) / ZOOM_OUT);
  }
  function storySm(x) { x = Math.max(0, Math.min(1, x)); return x * x * (3 - 2 * x); }
  /* one way only (v43: the first two drawings): the line drawing while the
     sheet's top is below 80 % of the screen, the full model once its bottom
     is above 20 % -- smoothly all the way it crosses the screen -- and
     never back */
  function storyInk(G) {
    var vh = global.innerHeight || G.vh;
    G.ink.forEach(function (it) {
      var v;
      if (it.force != null) v = it.force;
      else if (it.hold) v = 0;
      else {
        var r = it.c.getBoundingClientRect();
        v = 100 * storySm((0.8 * vh - r.top) / (0.6 * vh + r.height));
        if (it.v >= 0) v = Math.max(v, it.v);
      }
      v = Math.round(v);
      if (v !== it.v) { it.v = v; inkCard(it.c, it.key, v); }
    });
  }
  /* one speed: ramp up in ta, even, ramp down in ta */
  function storyTrap(y0, y1, T, ta) {
    var D = y1 - y0; if (2 * ta > T) ta = T / 2;
    var vm = D / Math.max(1, T - ta);
    return function (t) {
      t = Math.max(0, Math.min(T, t));
      var p;
      if (t < ta) p = 0.5 * vm / ta * t * t;
      else if (t <= T - ta) p = 0.5 * vm * ta + vm * (t - ta);
      else { var u = T - t; p = D - 0.5 * vm / ta * u * u; }
      return y0 + p;
    };
  }
  function storyGo() {
    if (_ST.on || _ST.wait) return;
    if (!storyReady()) { log('story   not yet -- pages still being drawn'); return; }
    _ST.wait = true;
    if (_ST.btn) _ST.btn.classList.add('bp-gone');
    var dr = $('bp-drawer'); if (dr) dr.classList.remove('open');
    /* to the first page now, inside the 2 s that get cut away */
    var G = storyGeo();
    if (G) { try { var de0 = document.documentElement, sb0 = de0.style.scrollBehavior; de0.style.scrollBehavior = 'auto'; global.scrollTo(0, Math.round(G.Yof(G.all[0]))); de0.style.scrollBehavior = sb0; } catch (eS) {} }
    if (storyMode() === 'reel') reelPreload();
    log('story   PLAY hidden, the ' + storyMode() + ' starts in 2 s');
    global.setTimeout(function () { _ST.wait = false; storyRun(); }, STORY_WAIT);
  }
  function storyBegin(G) {
    _ST.on = true; _ST.tok++;
    var de = document.documentElement; _ST.sb = de.style.scrollBehavior; de.style.scrollBehavior = 'auto';
    _ST.ox = de.style.overflowX; de.style.overflowX = 'hidden';   /* v43: the zoom makes no side scroll */
    /* the hidden 3D stage's heartbeat off while it plays */
    _ST.rr = null; _ST.r0 = null;
    try { if (_st && _st.renderer && typeof _st.renderer.render === 'function') { _ST.rr = _st.renderer; _ST.r0 = _st.renderer.render; _st.renderer.render = function () {}; } } catch (eR) { _ST.rr = null; }
    /* every slider at the line drawing first, then one way only */
    G.ink.forEach(function (it) { it.v = 0; inkCard(it.c, it.key, 0); });
    _ST.P = G;
  }
  function storyRun(manual) {
    var G = storyGeo();
    if (!G) { log('story   nothing on the page to show'); storyEnd(''); return; }
    if (storyMode() === 'reel' && !manual) { reelRun(G); return; }
    storyBuild(G);
    storyBegin(G);
    log('story   the story, silent: ' + (G.T / 1000).toFixed(1) + ' s, ' + G.all.length + ' page(s), ' + Math.round(G.D) + ' px at ' + Math.round(G.v * 1000) + ' px/s (' + (G.v * 1000 / G.pageH).toFixed(2) + ' pages/s, ' + (STORY_RAMP / 1000) + ' s to start and to stop), zoom on ' + G.parts.length + ' title(s): ' + G.parts.map(function (p) { return p.kind + ' p' + (p.c.getAttribute('data-page') || '?'); }).join(', ') + ', the slider of ' + G.ink.length + ' drawing(s)');
    if (manual) return;
    var t0 = storyNow(), frames = 0, tok = _ST.tok;
    (function frame() {
      if (!_ST.on || tok !== _ST.tok) return;
      var t = Math.min(G.T, storyNow() - t0);
      frames++;
      try { storySeek(G, t); } catch (eF) { log('story   frame THREW ' + ((eF && eF.message) || eF)); }
      if (t >= G.T) { storyEnd('the story played (' + (t / 1000).toFixed(1) + ' s, ' + frames + ' frames, ' + Math.round(frames / (t / 1000)) + ' fps)'); return; }
      _ST.raf = global.requestAnimationFrame(frame);
    })();
  }
  /* the story's timeline: hold, (move, zoom) per part, move to the end, hold */
  function storyBuild(G) {
    var segs = [], t = 0, y = G.Yof(G.all[0]), D = 0, nMov = 0, yy = y;
    G.parts.forEach(function (p) { if (Math.abs(p.y - yy) >= 2) { D += Math.abs(p.y - yy); nMov++; } yy = p.y; });
    if (Math.abs(G.maxY - yy) >= 2) { D += Math.abs(G.maxY - yy); nMov++; }
    var fixed = 500 + 800 + G.parts.length * (ZOOM_IN + ZOOM_HOLD + ZOOM_OUT) + nMov * STORY_RAMP;
    var v = STORY_PAGES * G.pageH / 1000;
    if (D / v + fixed > STORY_MAX) v = D / Math.max(1000, STORY_MAX - fixed);
    var hold = function (ms) { segs.push({ k: 'hold', t0: t, t1: t + ms, y: y }); t += ms; };
    var move = function (y1) {
      if (Math.abs(y1 - y) < 2) return;
      var T = Math.abs(y1 - y) / v + STORY_RAMP;
      segs.push({ k: 'move', t0: t, t1: t + T, f: storyTrap(y, y1, T, STORY_RAMP) }); t += T; y = y1;
    };
    hold(500);
    G.parts.forEach(function (p) { move(p.y); segs.push({ k: 'zoom', t0: t, t1: t + ZOOM_IN + ZOOM_HOLD + ZOOM_OUT, y: y, p: p }); t += ZOOM_IN + ZOOM_HOLD + ZOOM_OUT; });
    move(G.maxY); hold(800);
    G.segs = segs; G.T = t; G.v = v; G.D = D;
  }
  /* the story at t ms: where the page is, the zoom, the sliders */
  function storySeek(G, t) {
    var sg = G.segs[G.segs.length - 1], i;
    for (i = 0; i < G.segs.length; i++) if (t < G.segs[i].t1) { sg = G.segs[i]; break; }
    var u = Math.max(0, Math.min(sg.t1 - sg.t0, t - sg.t0));
    var y = sg.k === 'move' ? sg.f(u) : sg.y;
    if (sg.k === 'zoom') storyZoomSet(sg.p, storyZoomAt(u)); else storyZoomSet(null, 1);
    global.scrollTo(0, Math.round(y));
    storyInk(G);
  }
  function storyEnd(why) {
    _ST.on = false; _ST.wait = false; _ST.tok++;
    if (_ST.raf) { global.cancelAnimationFrame(_ST.raf); _ST.raf = 0; }
    document.documentElement.style.scrollBehavior = _ST.sb || '';
    storyZoomSet(null, 1);
    document.documentElement.style.overflowX = _ST.ox || '';
    if (_ST.rr && _ST.r0) { try { _ST.rr.render = _ST.r0; } catch (eR) {} }
    _ST.rr = null; _ST.r0 = null;
    if (_ST.P) _ST.P.ink.forEach(function (it) { inkCard(it.c, it.key); });
    _ST.P = null;
    reelSub('');
    Object.keys(_ST.audio).forEach(function (k) { try { _ST.audio[k].pause(); } catch (eA) {} });
    if (_ST.fade) _ST.fade.classList.remove('bp-on');
    if (_dirty && _mode === 'sheets') scheduleSheets(0);
    if (_ST.btn) _ST.btn.classList.remove('bp-gone');
    if (why) log('story   ' + why + ' -- the sliders back to their values, the PLAY back');
  }

  /* ---- the voiced reel (?ig) ---- */
  function reelTexts() {
    if (_ST.texts || _ST.textsAsked || !global.fetch) return;
    _ST.textsAsked = true;
    global.fetch(VOICE_URL + '/texts/en', { mode: 'cors', credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (j) {
      _ST.texts = j || {};
      var have = Object.keys(REEL_CLIP).filter(function (k) { return !!_ST.texts[REEL_CLIP[k]]; });
      log('story   subtitles: ' + have.length + ' of ' + Object.keys(REEL_CLIP).length + ' reel clip text(s) from the voice worker' + (have.length < Object.keys(REEL_CLIP).length ? (' -- missing ' + Object.keys(REEL_CLIP).filter(function (k) { return !_ST.texts[REEL_CLIP[k]]; }).map(function (k) { return REEL_CLIP[k]; }).join(', ')) : ''));
    })['catch'](function (e) { _ST.textsAsked = false; log('story   subtitles: the texts did not come (' + ((e && e.message) || e) + ')'); });
  }
  function reelPreload() {
    Object.keys(REEL_CLIP).forEach(function (k) {
      var n = REEL_CLIP[k];
      if (_ST.audio[n]) return;
      try { var a = new global.Audio(); a.preload = 'auto'; a.src = VOICE_URL + '/v/en/' + n + '.mp3'; a.load(); _ST.audio[n] = a; } catch (e) {}
    });
  }
  /* the words in the lower third, sentence by sentence, each as long as its letters */
  function reelSub(t) {
    var el = _ST.sub;
    if (!el && t) { el = _ST.sub = document.createElement('div'); el.id = 'bp-story-sub'; document.body.appendChild(el); }
    if (!el) return;
    if (el.textContent !== t) el.textContent = t || '';
    el.classList.toggle('bp-on', !!t);
  }
  function reelChunks(text) {
    var out = [];
    String(text || '').replace(/([.!?])\s+/g, '$1\n').split('\n').forEach(function (s) {
      s = s.trim(); if (!s) return;
      if (s.length <= 78) { out.push(s); return; }
      var mid = s.length / 2, best = -1;
      s.replace(/[,:;]\s/g, function (m, i) { if (best < 0 || Math.abs(i - mid) < Math.abs(best - mid)) best = i; return m; });
      if (best > 0) { out.push(s.slice(0, best + 1).trim()); out.push(s.slice(best + 1).trim()); } else out.push(s);
    });
    var tot = out.reduce(function (a, s) { return a + s.length; }, 0) || 1, acc = 0;
    return out.map(function (s) { var a = acc / tot; acc += s.length; return { t: s, a: a, b: acc / tot }; });
  }
  /* the steps: the pages the document has, in its order */
  function reelPlan(G) {
    var kindOf = function (c) { return c.getAttribute('data-kind') || ''; }, S = [];
    S.push({ c: G.all[0], clip: 'intro' });
    var dr = G.sl.filter(function (c) { return (c.getAttribute('data-view') || '') !== 'cover'; })[0];
    if (dr) S.push({ c: dr, clip: 'drawings', demo: true });
    ['boq', 'shopping', 'cut', 'panels', 'truss'].forEach(function (k) {
      var pt = G.parts.filter(function (x) { return x.kind === k; })[0];
      if (pt) S.push({ c: pt.c, clip: k, part: pt });
    });
    S.forEach(function (s) { s.y = s.part ? s.part.y : G.Yof(s.c); });
    var first = S[0];
    S = [first].concat(S.slice(1).sort(function (a, b) { return a.y - b.y; }));
    return S;
  }
  function reelWait(ms, tok) { return new Promise(function (res) { global.setTimeout(function () { res(tok === _ST.tok); }, ms); }); }
  /* one even move to y (REEL_PAGES pages a second), the sliders with it */
  function reelMove(G, y, tok) {
    return new Promise(function (res) {
      var se = document.scrollingElement || document.documentElement, y0 = global.pageYOffset || se.scrollTop || 0, D = Math.abs(y - y0);
      if (D < 2) { res(tok === _ST.tok); return; }
      var v = REEL_PAGES * G.pageH / 1000, T = Math.max(600, D / v + REEL_RAMP), f = storyTrap(y0, y, T, REEL_RAMP), t0 = storyNow();
      (function frame() {
        if (!_ST.on || tok !== _ST.tok) { res(false); return; }
        var t = Math.min(T, storyNow() - t0);
        try { global.scrollTo(0, Math.round(f(t))); storyInk(G); } catch (eF) {}
        if (t >= T) { res(true); return; }
        _ST.raf = global.requestAnimationFrame(frame);
      })();
    });
  }
  /* a clip on its page: the page held while it speaks, its words below */
  function reelSay(G, s, tok) {
    var name = REEL_CLIP[s.clip], text = (_ST.texts && _ST.texts[name]) || '', ch = reelChunks(text), a = _ST.audio[name];
    var est = Math.max(2500, (text ? text.length : 60) * 62), t0 = storyNow(), ok = false, ended = false, dur = 0, outAt = 0;
    var f1 = ch.length > 1 ? ch[0].b : 0.45;
    return new Promise(function (res) {
      if (a) {
        try { a.currentTime = 0; } catch (eT) {}
        a.onended = function () { ended = true; };
        try { var pr = a.play(); if (pr && pr.then) pr.then(function () { ok = true; }, function (e) { log('story   ' + name + ' did not play (' + ((e && e.message) || e) + ') -- held ' + (est / 1000).toFixed(1) + ' s'); }); else ok = true; } catch (eP) {}
      }
      log('story   say ' + name + ' on page ' + (s.c.getAttribute('data-page') || '?') + ' (' + (s.c.getAttribute('data-kind') || s.c.getAttribute('data-view') || '-') + ')');
      var finish = function (t) {
        log('story   ' + name + ' ' + (ok ? ('spoken, ' + (t / 1000).toFixed(1) + ' s') : ('silent (no clip), held ' + (t / 1000).toFixed(1) + ' s')) + (s.part ? ' + the zoom on its title' : ''));
        global.setTimeout(function () { res(tok === _ST.tok); }, 250);
      };
      (function frame() {
        if (!_ST.on || tok !== _ST.tok) { if (a) try { a.pause(); } catch (eA) {} reelSub(''); res(false); return; }
        /* v43: after the words, the zoom back out, then on */
        if (outAt) {
          var w = storyNow() - outAt;
          storyZoomSet(s.part, ZOOM_K - (ZOOM_K - 1) * storySm(w / ZOOM_OUT));
          if (w >= ZOOM_OUT) { storyZoomSet(null, 1); finish(storyNow() - t0); return; }
          _ST.raf = global.requestAnimationFrame(frame);
          return;
        }
        var t = storyNow() - t0, frac;
        if (s.part) storyZoomSet(s.part, 1 + (ZOOM_K - 1) * storySm(t / ZOOM_IN));
        if (ok && a && a.duration && isFinite(a.duration)) { dur = a.duration * 1000; frac = Math.min(1, a.currentTime * 1000 / dur); }
        else frac = Math.min(1, t / est);
        var cur = ch.filter(function (c) { return frac >= c.a && frac < c.b; })[0];
        reelSub(cur ? cur.t : (frac < 1 && ch.length ? ch[ch.length - 1].t : ''));
        if (s.it) { s.it.force = frac < f1 ? 0 : 100 * storySm((frac - f1) / Math.max(0.05, 0.92 - f1)); }
        storyInk(G);
        var done = ok ? (ended || (dur && t > dur + 1500)) : t >= est;
        if (done || t > 30000) {
          if (s.it) { s.it.force = null; s.it.hold = false; s.it.v = 100; inkCard(s.it.c, s.it.key, 100); }
          reelSub('');
          if (s.part) { outAt = storyNow(); _ST.raf = global.requestAnimationFrame(frame); return; }
          finish(t);
          return;
        }
        _ST.raf = global.requestAnimationFrame(frame);
      })();
    });
  }
  /* a fade to the first page: no fast scroll back up */
  function reelFade(G, y, tok) {
    var v = _ST.fade;
    if (!v) { v = _ST.fade = document.createElement('div'); v.id = 'bp-story-veil'; document.body.appendChild(v); }
    v.classList.add('bp-on');
    return reelWait(400, tok).then(function (go) {
      if (!go) return false;
      global.scrollTo(0, Math.round(y));
      v.classList.remove('bp-on');
      return reelWait(400, tok);
    });
  }
  function reelRun(G) {
    reelTexts(); reelPreload();
    var S = reelPlan(G), tok;
    storyBegin(G); tok = _ST.tok;
    var t0 = storyNow();
    S.forEach(function (s) { if (s.demo) { s.it = G.ink.filter(function (it) { return it.c === s.c; })[0] || null; if (s.it) s.it.hold = true; } });
    log('story   the reel, voiced: ' + S.map(function (s) { return REEL_CLIP[s.clip] + ' p' + (s.c.getAttribute('data-page') || '?'); }).join(' > ') + ' > the last page > ' + REEL_CLIP.outro + ' on the first -- ' + G.all.length + ' page(s), ' + (REEL_PAGES) + ' pages/s between');
    var chain = Promise.resolve(true);
    S.forEach(function (s) {
      chain = chain.then(function (go) { return go ? reelMove(G, s.y, tok) : false; })
                   .then(function (go) { return go ? reelSay(G, s, tok) : false; });
    });
    chain.then(function (go) { return go ? reelMove(G, G.maxY, tok) : false; })
      .then(function (go) { return go ? reelWait(400, tok) : false; })
      .then(function (go) { return go ? reelFade(G, G.Yof(G.all[0]), tok) : false; })
      .then(function (go) { return go ? reelSay(G, { c: G.all[0], clip: 'outro' }, tok) : false; })
      .then(function (go) { return go ? reelWait(600, tok) : false; })
      .then(function (go) { if (go) storyEnd('the reel played (' + ((storyNow() - t0) / 1000).toFixed(1) + ' s)'); })
      ['catch'](function (e) { log('story   reel THREW ' + ((e && e.message) || e)); storyEnd('stopped by an error'); });
  }
  /* wait for the module script's globals (THREE, HOUSE_BOOT), then start */
  function whenReady(tries) {
    if (global.THREE && global.HOUSE_BOOT) { readBoot(); start(); return; }
    if (tries > 100) { readBoot(); start(); return; }
    global.setTimeout(function () { whenReady(tries + 1); }, 50);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { whenReady(0); }); else whenReady(0);
  global.Blueprints = { version: VERSION, setView: setView, lib: function () { return _lib; },
                        dims: function () { return _dimNote; }, makePdf: makePdf, sec: function () { return { note: SEC.note, lines: SEC.lines, planH: planCutH() }; }, secAutoNow: function (k) { return secAuto(k, anchors(true)); }, pdfNote: function () { return _pdfNote; }, setDims: function (on, mode) { _dimsOn = !!on; if (mode) _dimsMode = mode; buildDims(); if (_st && _lib) setView(_view); },
                        dimsLayer: function (id, on) { _dimsLayer[id] = !!on; buildLayers(); redraw(); },
                        /* v27: the sheets on the page */
                        sheets: function () { return _sheetNote; }, building: function () { return _building || !!_sheetT || pkgWaiting(); },
                        /* v29: the package (the configurator's pages around the sheets) */
                        pkg: function () { return _pkg ? (_pkg.note + (_pkg.cardNote ? (' | ' + _pkg.cardNote) : '')) : 'none'; },
                        /* v32: another configurator's document */
                        doc: function () { return _docNote || 'none'; },
                        /* v31: what differs from the sheets on the page (debugging) */
                        sigDiff: function () { var a = sheetSig().split('#'), b = _lastSig.split('#'); return (_lastSig ? '' : 'no sheets drawn yet\n') + a.map(function (x, i) { return i + (x === b[i] ? ' same' : (' DIFF ' + x.slice(0, 120) + ' | was ' + String(b[i] || '').slice(0, 120))); }).join('\n'); },
                        /* v30: the gate -- open or not, and why; open(why) for the harness */
                        lock: function (open) { if (open) unlock(String(open)); return (_lock.on ? 'locked' : 'open') + ' -- ' + _lock.why + ' | faded ' + ((sheetsHost() && sheetsHost().querySelectorAll('.bp-locked').length) || 0); },
                        look: function (color, frame) {
                          if (color != null && !!color !== _look.color) { _look.color = !!color; _blend = {}; lookSave(); barIcons(); colourChanged(); }
                          if (frame != null && !!frame !== _look.frame) { _look.frame = !!frame; lookSave(); barIcons(); frameChanged(); }
                        },
                        blend: function (key, v) { _blend[key] = v; _cards.forEach(function (c) { if (c.getAttribute('data-view') === key) inkCard(c, key); }); },
                        openLive: openLive, closeLive: closeLive,
                        rooms: function () { return _roomsNote; },   /* v47 the last room plan drawn (harness) */
                        /* v41 the ?ig story: story() its plan, story(true) plays it now (no 2 s), story(false) stops it */
                        story: function (go) {
                          if (typeof go === 'number') { if (!_ST.on) storyRun(true); var P = _ST.P; if (!P || !P.segs) return 'nothing to show'; storySeek(P, Math.min(P.T, go)); return Math.round(global.pageYOffset || 0) + (_ST.zs > 1 ? (' zoom ' + _ST.zs.toFixed(2)) : ''); }
                          if (go === true) { storyRun(); return storyMode(); }
                          if (go === false) { storyEnd('stopped'); return 'stopped'; }
                          var G = storyGeo(); if (G && storyMode() === 'story') storyBuild(G); return (storyReady() ? 'ready' : 'not ready') + ' | ' + storyMode() + (G ? (' | ' + G.all.length + ' page(s), ' + G.ink.length + ' slider(s), ' + G.parts.length + ' title zoom(s)' + (G.T ? (', ' + (G.T / 1000).toFixed(1) + ' s') : '') + (storyMode() === 'reel' ? (' | ' + reelPlan(G).map(function (x) { return REEL_CLIP[x.clip] + ' p' + (x.c.getAttribute('data-page') || '?'); }).join(' > ')) : '')) : ' | no pages');
                        },
                        /* debugging: the strings of a view, each point with its foot */
                        strings: function (v) {
                          _inApply = true; try { setView(v); } finally { _inApply = false; }
                          var F = camFrame(); if (!F) return 'no frame';
                          return viewStrings(F, anchors(), dimLayers()).map(function (S) { return S.side + '/' + S.tier + ': ' + S.pts.map(function (p) { return p.c.toFixed(2) + '@' + (p.f == null ? '-' : p.f.toFixed(2)); }).join(' '); }).join('\n');
                        },
                        /* debugging: how much of a sheet's drawing area a view takes at scale s */
                        fitProbe: function (v, portrait, s, foot) {
                          _inApply = true; try { setView(v); } finally { _inApply = false; }
                          var G = sheetGeomP(isMetric(), !!portrait, _look.frame, !!foot), ft = sheetFit(G, s, anchors(), dimLayers(), paperStyle(new SvgDoc(10, 10)), _dimsOn);
                          return ft ? ('w ' + ft.rw.toFixed(3) + ' h ' + ft.rh.toFixed(3) + ' area ' + G.area.w.toFixed(0) + ' x ' + G.area.h.toFixed(0) + ' mm') : 'none';
                        },
                        /* debugging: what the line passes saw at a CSS pixel of the canvas */
                        lnProbe: function (cx, cy) {
                          var cv = _st.renderer.domElement, W = cv.width | 0, H = cv.height | 0, k = W / cv.clientWidth;
                          var B = lnBuffers(_st.camera, W, H), x = Math.round(cx * k), y = H - 1 - Math.round(cy * k), i = (y * W + x) * 4;
                          var id = (B.I[i] << 16) | (B.I[i + 1] << 8) | B.I[i + 2], who = '-';
                          _st.group.traverse(function (o) { var m = LN.mats && LN.mats.get(o); if (m && (m.uniforms.uId.value + 1) === id) who = (o.name || o.type); });
                          return 'id ' + id + ' a ' + B.I[i + 3] + ' n ' + B.N[i] + ',' + B.N[i + 1] + ',' + B.N[i + 2] + ' ' + who + ' | ' + LN.note;
                        } };
})(window);
